import PropTypes from "prop-types"
import React, { useState, useEffect, useMemo } from "react"
import { useParams, useNavigate, useLocation } from "react-router-dom"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import {
  Chart as ChartJS,
  ArcElement,
  Legend,
  CategoryScale,
  LinearScale,
  Title,
  PointElement,
  LineElement
} from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, ArcElement, Title, Legend)
import { Pie } from "react-chartjs-2"
import { Line } from "react-chartjs-2"

import { DateRangePicker } from "rsuite"
import {
  Container,
  Input,
  Card,
  CardBody,
  Button,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormFeedback,
  Form,
  Progress,
} from "reactstrap"
import { Link } from "react-router-dom"
import Select from "react-select"
import classnames from "classnames"
import awicon from "../../assets/images/services-icon/coin.png"
import record from "../../assets/images/services-icon/record.png"
import play from "../../assets/images/services-icon/play.svg"
import calendar from "../../assets/images/services-icon/calendar.png"
import watch from "../../assets/images/services-icon/watch.png"
import timer from "../../assets/images/services-icon/timer.png"
import reportIcon from "../../assets/images/services-icon/es4.png"

import "chartist/dist/scss/chartist.scss"
import sort from "assets/images/sort.png"
// import images
import st1 from "../../assets/images/services-icon/st1.png"
import st2 from "../../assets/images/services-icon/st2.png"
import reel from "../../assets/images/services-icon/reel.png"
import chevleft from "assets/images/services-icon/chev-left.png"
import TableComm from "../../dataTableCommon"

//i18n
import { withTranslation } from "react-i18next"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

import "react-datepicker/dist/react-datepicker.css"

import axios from "axios"
import { BASE_URL, STUDENT_BASE_URL } from "../../global"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { useRef } from "react";

import moment from "moment"
import Loader from "react-spinner-loader"
import Switch from "react-switch";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { GameCard } from "./Games/lesson-plan/game-card"
import { ActivityType } from "../../modules/lesson/activity/activity.types"
import { LllActivityCard } from "./lll/lll-card"
import { PDFDocument, StandardFonts, rgb } from "pdf-lib"
import { accessibleService } from "../../modules/center-services/AccessibleService"
import { gotoOnlineSession } from "../../modules/online-session/online-session-util"
import { OnlineSessionStatus, OnlineSessionStatusChild } from "../../modules/online-session/online-session-status"
import { getUserSession } from "../../common/session/user-session"
import { CopyLessonActivitiesDialog } from "./copy-lesson-activities"
import { MathOnlineActivityCard } from "../../modules/session/activity/math-online-activity-card"
import { EnglishOnlineActivityCard } from "../../modules/session/activity/english-online-activity-card"
import { GeneralActivityCard } from "../../modules/session/activity/general-activity-card"
import { BmdActivityCard } from "../../modules/session/activity/bmd-activity-card"
import { SkillbuilderActivityCard } from "../../modules/session/activity/skillbuilder-activity-card"
import { LllMetadata } from "../../modules/lll/lll-nodes"
import { GameMetadata } from "../../modules/games/game"
import { getMomentLocaleTimeFormat } from "../../common/utils/date-utils"
import { getUserSetting } from "../../common/user-setting"

const S3_PDF_BASES = {
  1: "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/english_activity_pdf/",
  2: "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/activity_pdf/math_activity_pdf/",
};


const buildPdfUrl = (fileName, subjectId) => {
  if (!fileName) return null;
  if (/^https?:\/\//i.test(fileName)) return fileName; // already absolute
  const base = S3_PDF_BASES[String(subjectId)] || S3_PDF_BASES["1"]; // default to English
  return `${base}${encodeURI(String(fileName).replace(/^\/+/, ""))}`;
};


const slug = (s) =>
  String(s || "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")

const isWorksheet = (a) => Number(a?.activity_type) === 7
const firstNode   = (a) => a?.activity_node?.[0] ?? null
function openBlobForPrint(pdfBlob) {
  const url = URL.createObjectURL(pdfBlob)
  const iframe = document.createElement("iframe")
  iframe.style.position = "fixed"
  iframe.style.right = "0"
  iframe.style.bottom = "0"
  iframe.style.width = "0"
  iframe.style.height = "0"
  iframe.style.border = "0"
  iframe.src = url
  document.body.appendChild(iframe)
  iframe.onload = () => {
    try {
      iframe.contentWindow?.focus()
      iframe.contentWindow?.print()
    } catch (e) {
      window.open(url, "_blank", "noopener,noreferrer")
    }
    setTimeout(() => {
      URL.revokeObjectURL(url)
      document.body.removeChild(iframe)
    }, 60000)
  }
}
function sessionDateTimeStrings(session) {
  const dateStr = (session?.ses_date || "").slice(0,10)        // YYYY-MM-DD
  const start   = (session?.ses_start_time || "").slice(0,5)   // HH:MM
  const end     = (session?.ses_end_time   || "").slice(0,5)
  const timeStr = start || end ? `${start}${end ? " – " + end : ""}` : ""
  return { dateStr, timeStr }
}

function tutorNameFromSest(sest_name) {
  if (!sest_name) return null
  const dayTokens = new Set(["Mon","Monday","Tue","Tues","Tuesday","Wed","Wednesday","Thu","Thursday","Fri","Friday","Sat","Saturday","Sun","Sunday"])
  const parts = String(sest_name).trim().split(/\s+/)
  const idx = parts.findIndex((p) => dayTokens.has(p))
  return idx > 0 ? parts.slice(0, idx).join(" ") : null
}
async function labelPdf({
                          pdfUrl,
                          studentName,
                          tutorName,
                          dateStr,
                          timeStr,
                          origin, // "session" | "homework"
                        }) {
  const res = await fetch(pdfUrl, { mode: "cors" });
  if (!res.ok) throw new Error(`Failed to fetch PDF ${res.status}: ${pdfUrl}`);
  const bytes = await res.arrayBuffer();
  const pdf = await PDFDocument.load(bytes, { updateMetadata: false });

  const helv = await pdf.embedFont(StandardFonts.Helvetica);
  const helvBold = await pdf.embedFont(StandardFonts.HelveticaBold);

  const badgeText = origin === "homework" ? "Homework Worksheet" : "Session Worksheet";
  const labelWord = origin === "homework" ? "Homework" : "Session";

  for (const page of pdf.getPages()) {
    const { width, height } = page.getSize();
    const barH = 24;

    page.drawRectangle({
      x: 0, y: height - barH, width, height: barH,
      color: rgb(0.97, 0.97, 0.97), opacity: 0.98,
    });

    const line = `Student: ${studentName}   |   ${labelWord}: ${dateStr}${timeStr ? " " + timeStr : ""}   |   Tutor: ${tutorName}`;
    page.drawText(line, {
      x: 10, y: height - barH + 7, size: 9, font: helv, color: rgb(0.2, 0.2, 0.2),
      maxWidth: width - 170,
    });

    const fs = 9, padX = 6, padY = 3;
    const w = helvBold.widthOfTextAtSize(badgeText, fs) + padX * 2;
    const h = fs + padY * 2;
    const ox = width - w - 10;
    const oy = height - barH + (barH - h) / 2;

    page.drawRectangle({ x: ox, y: oy, width: w, height: h, color: rgb(1,1,1), borderColor: rgb(0.7,0.7,0.7), borderWidth: 0.5, opacity: 0.98 });
    page.drawText(badgeText, { x: ox + padX, y: oy + padY, size: fs, font: helvBold, color: rgb(0.15,0.15,0.15) });
  }

  const out = await pdf.save();
  return new Blob([out], { type: "application/pdf" });
}

function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

function isSessionCompleted(session) {
  return session && session.ses_is_completed === 1
}


const SessionDetails = props => {
  const { key } = useParams()
  const userSetting = getUserSetting();

  const isHomeworkView = () =>
    String(rollOveractiveTab || "").toLowerCase() === "homework";


  function gatherWorksheetJobs({ lessonSession, homeworkSession }) {
    const jobs = [];
    const seen = new Set();

    const collectFromSession = (session, origin) => {
      const enrols = session.tbl_session_time?.tbl_student_enrolment || [];
      for (const enrol of enrols) {
        const st = enrol?.tbl_student;
        if (!st) continue;

        const studentName = [st.st_first_name, st.st_surname].filter(Boolean).join(" ") || "Student";
        const acts = st?.Lesson?.LessonActivities || [];

        for (const a of acts) {
          if (!isWorksheet(a)) continue;
          const node = firstNode(a);
          const url = buildPdfUrl(node?.file_name, a?.fk_sub_id);
          if (!url) continue;

          const key = `${origin}|${st?.pk_student_key}|${node?.file_name}|${a?.fk_sub_id}`;
          if (seen.has(key)) continue;
          seen.add(key);

          jobs.push({
            origin,
            url,
            studentName,
            nodeName: node?.node_name || "worksheet",
            subjectId: a?.fk_sub_id,
            studentKey: st?.pk_student_key,
          });
        }
      }
    };

    if (lessonSession)   collectFromSession(lessonSession, "lesson");
    if (homeworkSession) collectFromSession(homeworkSession, "homework");

    jobs.sort((a, b) => (a.studentName || "").localeCompare(b.studentName || "") || (a.origin > b.origin ? 1 : -1));
    return jobs;
  }

  const [NextSessionData, setnextsessiondeatils] = useState([])
  const [PendingActivitySeleteAll, setPendingActivitySeleteAll] = useState(false)
  const [SessionStudentPendingActivityArray, setSessionStudentPendingActivityArray] =
    useState([])
  console.log(SessionStudentPendingActivityArray)
  const [SessionStudentPendingActivity, setSessionStudentPendingActivity] =
    useState([])
  const [ActivityPendingLoading, setActivityPendingLoading] = useState(false)

  const [TotalPendingActivity, setTotalPendingActivity] = useState(0)

  const [SessionStudentNextActivity, setSessionStudentNextActivity] = useState(
    []
  )
  const [SessionStudentSubject, setSessionStudentSubject] = useState([])
  const [
    SessionStudentSubjectNextActivity,
    setSessionStudentSubjectNextActivity,
  ] = useState([])
  const [SessiosNextActivity, setSessiosNextActivity] = useState([])
  const [ActivityNextLoading, setActivityNextLoading] = useState(false)
  const [ActivitySubjectNextLoading, setActivitysubjectNextLoading] =
    useState(false)
  const [rollOveractiveTab, setrollOverActiveTab] = useState("lessonPlan")
  const [modal_center3, setmodal_center3] = useState(false)
  const tog_center3 = () => {
    setmodal_center3(!modal_center3)
    validation1.resetForm()
  }

  const [modal_center2, setmodal_center2] = useState(false)
  const tog_center2 = () => {
    setmodal_center2(!modal_center2)
  }


  const [modal_removeCoins, setmodal_removeCoins] = useState(false)
  const tog_removeCoins = () => {
    setmodal_removeCoins(!modal_removeCoins)
  }

  const tog_session_end = () => {
    setModal_session_end(!modal_session_end)
  }

  const today = new Date()
  const sixMonthsAgo = new Date()
  sixMonthsAgo.setMonth(today.getMonth() - 6)

  const [dateValue, setDateValue] = useState([sixMonthsAgo, today])

  const [selectedYearLevelTopic, setselectedYearLvel] = useState("")
  function handleSelectYearLevelTopic(selectedGroup) {
    setselectedYearLvel(selectedGroup)
    filterData(selectedGroup, selectedMastryScore)
  }

  const filterData = (
    yearLevel = selectedYearLevelTopic,
    masteryScore = selectedMastryScore
  ) => {
    let filteredData = Alldata

    if (masteryScore) {
      if (parseInt(masteryScore) === 1) {
        filteredData = filteredData.filter(item => item.masteryscore == 0)
      } else if (parseInt(masteryScore) === 2) {
        filteredData = filteredData.filter(
          item => item.masteryscore < 30 && item.masteryscore > 0
        )
      } else if (parseInt(masteryScore) === 3) {
        filteredData = filteredData.filter(
          item => item.masteryscore >= 30 && item.masteryscore <= 69
        )
      } else if (parseInt(masteryScore) === 4) {
        filteredData = filteredData.filter(item => item.masteryscore >= 70)
      }
    }

    if (yearLevel && yearLevel !== "all" && yearLevel != "") {
      filteredData = filteredData.filter(item =>
        item.activity_node.some(node => node.level_name === yearLevel)
      )
    }

    setMistryTopic(filteredData)
  }

  const [selectedMastryScore, setselectedMasterScore] = useState("")
  function handleSelectMastryScore(selectedGroup) {
    setselectedMasterScore(selectedGroup)
    filterData(selectedYearLevelTopic, selectedGroup)
  }

  const optionMastryScore = [
    { label: "Select", value: "" },
    { label: "No score", value: "1" },
    { label: "Improvement", value: "2" },
    { label: "Average", value: "3" },
    { label: "Excellent", value: "4" },
  ]

  const [modal_center1, setmodal_center1] = useState(false)
  const tog_center1 = () => {
    setmodal_center1(!modal_center1)
  }

  const [isRightStuTopic, setIsRightStuTopic] = useState(false)
  const toggleRightCanvasStuTopic = () => {
    setIsRightStuTopic(!isRightStuTopic)
  }

  const [isRightTopicGraph, setIsRightTopicGraph] = useState(false)

  const toggleRightCanvasTopicGraph = () => {
    setIsRightTopicGraph(!isRightTopicGraph)
    const today = new Date()
    const sixMonthsAgo = new Date()
    sixMonthsAgo.setMonth(today.getMonth() - 6)
    setDateValue([sixMonthsAgo, today])
  }

  const [levelOption, setLevelOptions] = useState([])
  const [isRightStu, setIsRightStu] = useState(false)
  const [studentKay, setStudentKey] = useState("")
  const [lessonNote, setLessonNote] = useState("")
  const toggleRightCanvasStu = studentKey => {
    setIsRightStu(!isRightStu)
    fetchStudentData(studentKey)
    fetchlessonNotesData(studentKey)
    fetchpastsessionData(studentKey)
    fetchMastryScoresessionData(studentKey)
    setStudentKey(studentKey)
    setLessonNote("")
  }

  const [activeTab1, setActiveTab1] = useState("5")

  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setActiveTab1(tab)
    }
  }

  const [modalStuPastSession, setStuPastSession] = useState(false)
  const togStudentPastSession = () => {
    setStuPastSession(!modalStuPastSession)
  }

  const [startDate, setStartDate] = useState("")
  const handelDateReset = () => {
    setStartDate("")
  }

  const handleDateChange = date => {
    setDateValue(date)
    // Here you can implement logic to fetch data for the selected month
    // and update the chart accordingly
  }

  const [isTopicId, setTopicId] = useState("")
  const [isNodeId, setNodeId] = useState("")
  const [MistryTopic, setMistryTopic] = useState([])
  const [Alldata, setAllData] = useState([])
  const [topicData, setToipc] = useState([])
  const [mastryScore, setMastryScore] = useState([])
  const [TopicGraphDeatils, setMistryTopicGraphDeatils] = useState([])
  const [TopicGraphDeatilsValueData, setTopicGraphDeatilsValueData] = useState(
    []
  )
  const [TopicGraphDeatilsLabelData, setTopicGraphDeatilsLabelData] = useState(
    []
  )

  const [PastSessionStuData, setPastSessionStuData] = useState([])
  const [LessonNoteDetail, setLessonNoteDetail] = useState([])
  //delete notes start
  const [modal_delete_note, setmodal_delete_note] = useState(false)

  const tog_delete_note = () => {
    setmodal_delete_note(!modal_delete_note)
  }
  const [isNoteSubmitting, setIsNoteSubmitting] = useState(false)

  const [note_key, setNoteKey] = useState(null)
  function delete_notes(getNoteKey) {
    setNoteKey(getNoteKey)
    tog_delete_note()
  }
  //delete notes end

  function textareachange(event) {
    const value = event.target.value

    setLessonNote(value)
  }

  const [studentDetail, setstudentDetail] = useState([])

  const [SessionStart, setIsSessionStart] = useState(false)
  const [SessionEnd, setIsSessionEnd] = useState(false)

  const [isLoopRun, setLoopRun] = useState(1)

  const [modal_session_end, setModal_session_end] = useState(false)
  const [sessionData, setSessionData] = useState(null)

  const [isSubmitting, setIsSubmitting] = useState(false)

  const [studentOption, setStudentOption] = useState([])

  const optionPendingActivityType = [
    { label: "Lesson Plan", value: "0" },
    { label: "Homework", value: "1" },
  ]

  const [loader, setLoader] = useState(false)
  //student attendence star
  const [studentattDetails, setStudentAttDetails] = useState([])

  //HomeWork tab
  const [HomeSessionData, setHomeSessionData] = useState([])

  //Homework tab

  //Student tab
  const [StudentData, setStudentData] = useState([])
  //student tab

  //precious tab
  const [PresessionData, setPreSessionData] = useState([])
  const [PreHomeSessionData, setPreHomeSessionData] = useState([])

  //previous tab


  //Move activity start
  const [UpcomingSessionData, setUpcomingSessionData] = useState([])
  const [modal_move_activity, setmodal_move_activity] = useState(false)
  const [moveTosession, setmoveTosession] = useState(false)
  const tog_move_activity = () => {
    handlerollOverTabChangeSingle("lessonPlan")
    setmodal_move_activity(!modal_move_activity)
  }
  const [move_activity, setMoveActivity] = useState([])
  function onMoveActivityPopup(getActivity) {
    setMoveActivity(getActivity)
    setmoveTosession(true)
  }

  const [moveingSessionKey, setmoveingSessionKey] = useState([])
  const [isMASubmitting, setIsMASubmitting] = useState(false)
  function onMoveingActivityPopup() {

    if (moveingSessionKey.length === 0) {
      toast.error("Please select at least one session!", {
        autoClose: 3000
      })
    } else {
      onMoveActivityUpcomingSession();
    }
  }

  const handleCheckboxChange = (key, isChecked) => {
    const updatedSessions = UpcomingSessionData.map(session => {
      if (session.pk_ses_key === key) {
        return { ...session, checked: isChecked }
      }
      return session
    })

    setUpcomingSessionData(updatedSessions)
    if (isChecked) {
      // Add key to the selectedKeys array if checked
      setmoveingSessionKey(prev => [...prev, key])
    } else {
      // Remove key from the selectedKeys array if unchecked
      setmoveingSessionKey(prev => prev.filter(k => k !== key))
    }
  }
  const [rollOveractiveTabSingle, setrollOverActiveTabSingle] = useState("lessonPlan")
  const handlerollOverTabChangeSingle = tab => {
    setrollOverActiveTabSingle(tab)

    const updatedSessions = UpcomingSessionData.map(session => ({
      ...session,
      checked: false,
    }))

    setUpcomingSessionData(updatedSessions)
    setmoveingSessionKey([])
  }
  //Roll over to homework start

  function onMoveHomeworkActivityPopup(getActivity) {
    setMoveActivity(getActivity)
    setmoveTosession(false)
    onMoveActivityHomework(getActivity);// Update state after toggle
  }
  // Roll over to homework end
  useEffect(() => {
    if (moveTosession && move_activity && move_activity != "") {
      fetchUpcommingSessionData()
    }
  }, [moveTosession, move_activity])

  //Move activity end

  const [customActiveTab, setcustomActiveTab] = useState("1")

  function toggleCustom(tab) {
    if (customActiveTab !== tab) {
      setActivityStudentKey("")
      setSelectedActivityKeys([])
      setselectedActivitySubject([])
      setSelectAllChecked(false)
      setcustomActiveTab(tab)
    }
  }

  const authUser = JSON.parse(localStorage.getItem("authUser")) || null

  const navigate = useNavigate()

  const getUniqueSubjectNames = jsonData => {
    const uniqueSubjectNames = new Set()

    // Check if the necessary data is available
    if (
      jsonData &&
      jsonData.session &&
      jsonData.session.tbl_session_time &&
      jsonData.session.tbl_session_time.tbl_student_enrolment
    ) {
      // Iterate through student enrollments
      jsonData.session.tbl_session_time.tbl_student_enrolment.forEach(
        enrollment => {
          // Check if the necessary data is available and is an array
          if (
            enrollment &&
            enrollment.tbl_enrolment_subject &&
            Array.isArray(enrollment.tbl_enrolment_subject)
          ) {
            // Iterate through enrollment subjects
            enrollment.tbl_enrolment_subject.forEach(subject => {
              // Assuming subject_name is a property of the subject object and is not null/undefined
              if (subject && subject.subject_name != null) {
                uniqueSubjectNames.add(subject.subject_name)
              }
            })
          }
        }
      )
    }

    // Convert Set to array if needed
    return Array.from(uniqueSubjectNames)
  }

  const getUniqueStudentSubjectNames = jsonData => {
    const uniqueSubjectNames = new Set()


    // Check if the necessary data is available
    if (jsonData) {
      // Iterate through student enrollments
      // jsonData.forEach((enrollment) => {
      // Check if the necessary data is available and is an array
      if (jsonData && Array.isArray(jsonData)) {
        // Iterate through enrollment subjects
        jsonData.forEach(subject => {
          // console.log(subject);
          // Assuming subject_name is a property of the subject object and is not null/undefined
          if (subject && subject.subject_name != null) {
            uniqueSubjectNames.add(subject.subject_name)
          }
        })
      }
    }

    // Convert Set to array if needed
    return Array.from(uniqueSubjectNames)
  }

  const getUniqueStudentSubjectID = jsonData => {
    const uniqueSubjectID = new Set()


    // Check if the necessary data is available
    if (jsonData) {
      // Iterate through student enrollments
      // jsonData.forEach((enrollment) => {
      // Check if the necessary data is available and is an array
      if (jsonData && Array.isArray(jsonData)) {
        // Iterate through enrollment subjects
        jsonData.forEach(subject => {
          // console.log(subject);
          // Assuming subject_name is a property of the subject object and is not null/undefined
          if (subject && subject.fk_sub_id != null) {
            uniqueSubjectID.add(subject.fk_sub_id)
          }
        })
      }
    }

    // Convert Set to array if needed
    return Array.from(uniqueSubjectID)
  }

  const getUniqueTopicsNames = jsonData => {
    const uniqueTopicsNames = new Set()

    // Check if the necessary data is available
    if (jsonData) {
      // Iterate through student enrollments
      // jsonData.forEach((enrollment) => {
      // Check if the necessary data is available and is an array
      if (jsonData && Array.isArray(jsonData)) {
        // Iterate through enrollment subjects
        jsonData.forEach(subject => {
          subject.forEach(data => {
            if (data && data.topic_name != null) {
              uniqueTopicsNames.add(data.topic_name)
            }
          })
        })
      }
    }

    // Convert Set to array if needed
    return Array.from(uniqueTopicsNames)
  }

  const location = useLocation()
  useEffect(() => {
    fetchData()
    setIsRightStu(false)
    setStuPastSession(false)
    fetchMasterData()
    setActivityStudentKey("")
    setSelectedActivityKeys([])
    setselectedActivitySubject([])
    setSelectAllChecked(false)
  }, [location, customActiveTab])
  useEffect(() => {
    fetchInitialHomeWorkData()
  }, [key])
  let timeoutID = ""
  useEffect(() => {
    if (isLoopRun !== 0) {
      timeoutID = setTimeout(() => {
        fetchSessionLoopData()
      }, 120000)

      return () => {
        clearTimeout(timeoutID)
      }
    } else {
    }
  }, [isLoopRun])

  const CountTotalActivityStudent = enrolments => {
    const students = [] // Initialize an array to store student data

    enrolments.forEach(enrolment => {
      let total_activity_stu = 0
      let completed_activity_stu = 0

      let student_data = {} // Use object instead of array for student data

      if ( enrolment.tbl_student?.pk_student_key
        && !([3, 4, 5, 6].includes(enrolment.tbl_student?.tbl_session_attendance?.attendance_status))
      ) {
        student_data.student_key = enrolment.tbl_student.pk_student_key
        student_data.student_name =
          enrolment.tbl_student.st_first_name +
          " " +
          enrolment.tbl_student.st_surname

        student_data.status = ""

        if (
          enrolment.tbl_student?.Lesson?.LessonActivities?.length > 0
        ) {
          enrolment.tbl_student.Lesson.LessonActivities.forEach(activity => {
            completed_activity_stu +=
              activity.status != null && activity.status === "1" ? 1 : 0
            total_activity_stu += 1
          })
        }

        let Count_activity = 0
        if (total_activity_stu !== completed_activity_stu) {
          Count_activity = total_activity_stu - completed_activity_stu
          student_data.pendingactivity = Count_activity
          student_data.homework = false
        } else {
          student_data.pendingactivity = 0
          student_data.homework = false
        }

        students.push(student_data) // Push student data to the array
      }
    })

    setStudentAttDetails(students)

  }


  const fetchSessionLoopData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      if (key) {

        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/sessionDetails", {
            pk_ses_key: key,
          })
          .then(responseSession => {

            if (
              responseSession.data.session != null &&
              responseSession.data.session != ""
            ) {
              if (
                key === responseSession.data.session?.pk_ses_key
              ) {
                setSessionData(responseSession.data)
                setLoopRun(isLoopRun + 1)

                if (
                  responseSession.data?.session?.tbl_session_time?.tbl_student_enrolment?.length > 0
                ) {

                  CountTotalActivityStudent(
                    responseSession.data.session.tbl_session_time
                      .tbl_student_enrolment
                  )
                } else {
                }

                if (
                  responseSession.data?.session?.tbl_session_time?.tbl_student_enrolment?.length > 0
                ) {
                  const formattedOptions =
                    responseSession.data.session.tbl_session_time.tbl_student_enrolment.map(
                      enroll => ({
                        value: enroll.tbl_student.pk_student_key,
                        label:
                          enroll.tbl_student.st_first_name != null &&
                          enroll.tbl_student.st_first_name !== ""
                            ? enroll.tbl_student.st_first_name +
                            " " +
                            enroll.tbl_student.st_surname
                            : null,
                      })
                    )

                  setStudentOption(formattedOptions)
                } else {
                  setStudentOption([])
                }
              }
            } else {
              setSessionData(null)
              setStudentOption([])
            }
          })
          .catch(error => {
            setLoopRun(0)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })

      } else {
        setLoader(false)
        navigate("/session")
      }
    } else {
      setLoader(false)
      navigate("/login")
    }
  }
  const fetchInitialHomeWorkData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/sessionHomeWorkDetails", {
            pk_ses_key: key,
          })
          .then(responseSession => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties
            if (
              responseSession.data.session != null &&
              responseSession.data.session != ""
            ) {
              setHomeSessionData(responseSession.data)

            } else {
              setHomeSessionData([])
            }
          })
          .catch(error => {
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })

      } else {
        navigate("/session")
      }
    } else {
      navigate("/login")
    }
  }


  const fetchData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      console.log(customActiveTab)
      if (key) {
        if (parseInt(customActiveTab) === 1) {
          setLoader(true)

          await accessibleService.init();

          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          axios
            .post(BASE_URL + "session/sessionDetails", {
              pk_ses_key: key,
            })
            .then(responseSession => {

              if (
                responseSession.data.session != null &&
                responseSession.data.session != ""
              ) {
                setLoader(false)
                setSessionData(responseSession.data)

                if (
                  responseSession.data?.session?.tbl_session_time?.tbl_student_enrolment?.length > 0
                ) {

                  CountTotalActivityStudent(
                    responseSession.data.session.tbl_session_time
                      .tbl_student_enrolment
                  )
                } else {
                }

                if (
                  responseSession.data?.session?.tbl_session_time?.tbl_student_enrolment?.length > 0
                ) {
                  const formattedOptions =
                    responseSession.data.session.tbl_session_time.tbl_student_enrolment.map(
                      enroll => ({
                        value: enroll.tbl_student.pk_student_key,
                        label:
                          enroll.tbl_student.st_first_name != null &&
                          enroll.tbl_student.st_first_name !== ""
                            ? enroll.tbl_student.st_first_name +
                            " " +
                            enroll.tbl_student.st_surname
                            : null,
                      })
                    )

                  setStudentOption(formattedOptions)
                } else {

                  setStudentOption([])
                  setLoader(false)
                }
              } else {
                setSessionData(null)
                setLoader(false)

                setStudentOption([])
              }
            })
            .catch(error => {
              setLoader(false)
              if (
                (error?.response?.status === 403 || error?.response?.status === 401) &&
                (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
              ) {
                localStorage.clear()
                navigate("/login")
              }
            })
        } else if (parseInt(customActiveTab) === 2) {
          //Home work tab

          setLoader(true)
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          axios
            .post(BASE_URL + "session/sessionHomeWorkDetails", {
              pk_ses_key: key,
            })
            .then(responseSession => {

              if (
                responseSession.data.session != null &&
                responseSession.data.session != ""
              ) {
                setLoader(false)
                setHomeSessionData(responseSession.data)
              } else {
                setSessionData(null)
                setLoader(false)

                setStudentOption([])
              }
            })
            .catch(error => {
              setLoader(false)
              if (
                (error?.response?.status === 403 || error?.response?.status === 401) &&
                (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
              ) {
                localStorage.clear()
                navigate("/login")
              }
            })
        } else if (parseInt(customActiveTab) === 3) {
          setLoader(true)
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          axios
            .post(BASE_URL + "session/sessionDetails", {
              pk_ses_key: key,
              tab_type: 3,
            })
            .then(responseSession => {

              if (
                responseSession.data.session != null &&
                responseSession.data.session != ""
              ) {
                setLoader(false)
                setPreSessionData(responseSession.data)

              } else {
                setPreSessionData([])
                setLoader(false)

              }
            })
            .catch(error => {
              setLoader(false)
              if (
                (error?.response?.status === 403 || error?.response?.status === 401) &&
                (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
              ) {
                localStorage.clear()
                navigate("/login")
              }
            })

          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          axios
            .post(BASE_URL + "session/sessionHomeWorkDetails", {
              pk_ses_key: key,
              tab_type: 3,
            })
            .then(responseSession => {

              if (
                responseSession.data.session != null &&
                responseSession.data.session != ""
              ) {
                setLoader(false)
                setPreHomeSessionData(responseSession.data)
              } else {
                setPreHomeSessionData([])
                setLoader(false)
              }
            })
            .catch(error => {
              setLoader(false)
              if (
                (error?.response?.status === 403 || error?.response?.status === 401) &&
                (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
              ) {
                localStorage.clear()
                navigate("/login")
              }
            })
        } else if (parseInt(customActiveTab) === 4) {
          setLoader(true)
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          axios
            .post(BASE_URL + "session/sessionStudentDetails", {
              pk_ses_key: key,
            })
            .then(responseStudent => {

              if (responseStudent.data.length > 0) {
                setLoader(false)
                setStudentData(responseStudent.data)
              } else {
                setLoader(false)
                setStudentData([])
              }
            })
            .catch(error => {
              setLoader(false)
              if (
                (error?.response?.status === 403 || error?.response?.status === 401) &&
                (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
              ) {
                localStorage.clear()
                navigate("/login")
              }
            })
        } else {
          setLoader(false)
        }
      } else {
        setLoader(false)
        navigate("/session")
      }
    } else {
      setLoader(false)
      navigate("/login")
    }
  }

  const fetchStudentData = async studentKey => {
    if (authUser && authUser != "" && authUser != null) {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responseStudent = await axios.post(
          BASE_URL + "student/getstudentdetails",
          {
            pk_student_key: studentKey,
          }
        )

        if (responseStudent.data.data.data != "") {
          setstudentDetail(responseStudent.data.data.data)
        } else {
          setstudentDetail([])
        }
      } catch (error) {
        console.error("Error in fetching stident deatails:", error)
      }
    } else {
      navigate("/login")
      setLoading(false)
    }
  }
  const fetchlessonNotesData = async studentKey => {
    if (authUser && authUser != "" && authUser != null) {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responseStudentNotes = await axios.post(
          BASE_URL + "session/sessionLessonDetails",
          {
            pk_student_key: studentKey,
            pk_ses_key: key,
          }
        ) //console.log(studentKey);

        if (responseStudentNotes.data.length > 0) {
          setLessonNoteDetail(responseStudentNotes.data)
        } else {
          setLessonNoteDetail([])
        }
      } catch (error) {
        console.error("Error in fetching stident deatails:", error)
      }
    } else {
      navigate("/login")
      setLoading(false)
    }
  }

  const fetchpastsessionData = async studentKey => {
    if (authUser && authUser != "" && authUser != null) {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responsePastSessionStudent = await axios.post(
          BASE_URL + "student/getpastsessionDetails",
          {
            pk_student_key: studentKey,
          }
        )

        if (responsePastSessionStudent.data.data.data) {
          setPastSessionStuData(responsePastSessionStudent.data.data.data)
        } else {
          setPastSessionStuData([])
        }

      } catch (error) {
        console.error("Error in fetching stident deatails:", error)
      }
    } else {
      navigate("/login")
      setLoading(false)
    }
  }

  const fetchTopicGraphData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responseMastryScroreStudentGraph = await axios.post(
          BASE_URL + "student/TopicGraphDetails",
          {
            pk_student_key: studentKay,
            filter_node_id: isNodeId,
            filter_topic_id: isTopicId,
            filter_date: startDate,
            startDate: moment(dateValue[0]).format("YYYY-MM-DD"),
            endDate: moment(dateValue[1]).format("YYYY-MM-DD"),
          }
        )

        if (responseMastryScroreStudentGraph.data.TopicDetails != "") {
          setMistryTopicGraphDeatils(
            responseMastryScroreStudentGraph.data.TopicDetails
          )
          setTopicGraphDeatilsLabelData(
            responseMastryScroreStudentGraph.data.TopicDetails.LabelData
          )
          setTopicGraphDeatilsValueData(
            responseMastryScroreStudentGraph.data.TopicDetails.ValueData
          )

        } else {
          setMistryTopicGraphDeatils([])
        }
      } catch (error) {
        console.error("Error in fetching stident deatails:", error)
      }
    } else {
      navigate("/login")
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isRightTopicGraph) {
      fetchTopicGraphData()
    } else {
    }
  }, [isRightTopicGraph, startDate, dateValue])

  const fetchMastryScoreTopicListData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responseMastryScroreStudent = await axios.post(
          BASE_URL + "student/mastryScroeTopic",
          {
            pk_student_key: studentKay,
          }
        )

        if (responseMastryScroreStudent.data.length > 0) {
          const data = responseMastryScroreStudent.data.filter(
            entry => entry?.activity_node?.length > 0
          )

          const levelNames = [
            {
              value: 'all',
              label: 'All'
            },
            ...[...new Set(
              data
                .flatMap(entry => entry.activity_node)
                .map(node => node.level_name)
                .filter(level => level && level.trim() !== '') // Remove empty values
            )]
              .sort((a, b) => a.localeCompare(b)) // Sort alphabetically
              .map(level => ({
                label: level,
                value: level,
              }))
          ];

          setMistryTopic(data)
          setAllData(data)
          setLevelOptions(levelNames)

        } else {
          setMistryTopic([])
          setAllData([])
          setLevelOptions([])
        }
      } catch (error) {
        console.error("Error in fetching stident deatails:", error)
      }
    } else {
      navigate("/login")
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isRightStuTopic) {
      fetchMastryScoreTopicListData()
      setLevelOptions([])
      setselectedMasterScore("")
    } else {
    }
  }, [isRightStuTopic])

  const data_area_chart = {
    labels: TopicGraphDeatilsLabelData || [],
    datasets: [
      {
        label: "Mastery score over time",
        data: TopicGraphDeatilsValueData || [],
        fill: true,
        backgroundColor: "rgba(192,192,192,0.2)", // Gray color with opacity
        borderColor: "rgba(192,192,192,1)", // Gray color
      },
    ],
  }

  const fetchMastryScoresessionData = async studentKey => {
    if (authUser && authUser != "" && authUser != null) {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responseMastrySessionStudent = await axios.post(
          BASE_URL + "student/mastryScroe",
          {
            pk_student_key: studentKey,
          }
        )

        if (responseMastrySessionStudent.data != "") {
          if (responseMastrySessionStudent.data.studentDetails != "") {
            setMastryScore(responseMastrySessionStudent.data.studentDetails)
          } else {
            setMastryScore([])
          }

          if (responseMastrySessionStudent.data.studentprogressBar != "") {
            setToipc(responseMastrySessionStudent.data.studentprogressBar)
          } else {
            setToipc([])
          }
        } else {
          setMastryScore([])
        }
      } catch (error) {
        console.error("Error in fetching stident deatails:", error)
      }
    } else {
      navigate("/login")
      setLoading(false)
    }
  }

  const fetchUpcommingSessionData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      setmoveTosession(false)
      if(move_activity && move_activity!=''){
        try {
          axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
          const uniqueSubjects = [move_activity].reduce((acc, item) => {
            if (!acc.some(obj => obj.subject_id === item.fk_sub_id)) {
              acc.push({ subject_id: item.fk_sub_id })
            }
            return acc
          }, [])
          const responseSessionUpcoming = await axios.post(
            BASE_URL + "session/getAllUpcommingActivitySessionList",
            {
              pk_student_key: move_activity.fk_student_key,
              fk_subject_id: uniqueSubjects,
            }
          )

          if (responseSessionUpcoming.data.length > 0) {
            const updatedData = responseSessionUpcoming.data.map(item => ({
              ...item,
              checked: false, // Add the checked property to each item
            }))
            setUpcomingSessionData(updatedData)
            setmodal_move_activity(true)
          } else {
            toast.error("Not found upcoming sessions!", {
              autoClose: 3000, // 3 seconds in this example
            })
            setUpcomingSessionData([])
            setmodal_move_activity(false)
          }
        } catch (error) {
          console.error("Error in fetching upcoming session deatails:", error)
        }
      }
    } else {
      navigate("/login")
    }
  }

  function generateRandomColors(count) {
    const colors = []
    for (let i = 0; i < count; i++) {
      // Generate a random color in hexadecimal format
      const color = "#" + Math.floor(Math.random() * 16777215).toString(16)
      colors.push(color)
    }
    return colors
  }

  function labelName(data_label) {
    const labels = []

    if (data_label.mistryScore && data_label.mistryScore.length > 0) {
      data_label.mistryScore.forEach(activity => {
        let label = ""
        if (
          activity.activity_type === 0 &&
          (activity.fk_sub_id === 1 || activity.fk_sub_id === 2)
        ) {
          label =
            activity.activity_node[0].node_name != "" &&
            activity.activity_node[0].level_name != ""
              ? activity.activity_node[0].level_name +
              " > " +
              activity.activity_node[0].node_name
              : activity.activity_node[0].node_name != ""
                ? activity.activity_node[0].node_name
                : null
        } else if (
          activity.activity_type === 1
        ) {
          label =
            activity.activity_node[0].name != ""
              ? activity.activity_node[0].name
              : null
        } else if (
          activity.activity_type === 2 &&
          (activity.fk_sub_id === 1 || activity.fk_sub_id === 2)
        ) {
          label =
            activity.activity_node[0].topic_name != ""
              ? activity.activity_node[0].topic_name
              : null
        } else if (
          activity.activity_type === 3
        ) {
          label =
            activity.activity_node[0].name != ""
              ? activity.activity_node[0].name
              : null
        } else if (
          activity.activity_type === 4
        ) {
          label =
            activity.activity_node[0].name != ""
              ? activity.activity_node[0].name
              : null
        } else if (
          activity.activity_type === 5
        ) {
          label =
            activity.activity_node[0].name != ""
              ? activity.activity_node[0].name
              : null
        } else if (activity.activity_type === 6 && activity.fk_sub_id === 1) {
          label =
            activity.activity_node[0].video_name != ""
              ? activity.activity_node[0].video_name
              : null
        } else if (activity.activity_type === 6 && activity.fk_sub_id === 2) {
          label =
            activity.activity_node[0].video_name != ""
              ? activity.activity_node[0].video_name
              : null
        } else if (
          activity.activity_type === 7 &&
          (activity.fk_sub_id === 1 || activity.fk_sub_id === 2)
        ) {
          label =
            activity.activity_node[0].file_name != ""
              ? activity.activity_node[0].file_name
              : null
        } else {
          label = ""
        }

        labels.push(label)
      })
    }
    return labels
  }

  function labelValue(data_label) {
    const labelValue = []

    if (data_label.mistryScore && data_label.mistryScore.length > 0) {
      data_label.mistryScore.forEach(activity => {
        let val =
          activity.masteryscore != "" && activity.masteryscore != ""
            ? activity.masteryscore
            : null
        labelValue.push(val)
      })
    }
    return labelValue
  }

  const options_pie_mastry = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
      },
    },

    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
  }

  const pie_mastry_data = {
    labels: labelName(mastryScore),
    datasets: [
      {
        data: labelValue(mastryScore),
        // backgroundColor: generateRandomColors(50),
        backgroundColor: [
          "#FF5733",
          "#FFD700",
          "#FF6347",
          "#FF8C00",
          "#FF4500",
          "#FF1493",
          "#FF00FF",
          "#FF00FF",
          "#FF0000",
          "#FF69B4",
          "#FF7F50",
          "#FF8C00",
          "#FF4500",
          "#FF6347",
          "#FFD700",
          "#FF5733",
          "#FF69B4",
          "#FF1493",
          "#FF00FF",
          "#FF00FF",
          "#FF0000",
          "#FF7F50",
          "#FF8C00",
          "#FF4500",
          "#FF6347",
        ],

        hoverBorderColor: "#fff",
      },
    ],
  }
  const fetchNextSessionData = async (pk_student_key, activity_method) => {
    if (authUser && authUser != "" && authUser != null) {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responsenextsessiondetails = await axios.post(
          BASE_URL + "session/getNextSessionDetails",
          {
            pk_student_key: pk_student_key.value,
            pk_ses_key: key,
            is_homework: activity_method,
          }
        )

        if (responsenextsessiondetails.data != "") {
          setnextsessiondeatils(responsenextsessiondetails.data[0])
        } else {
          setnextsessiondeatils([])
        }
      } catch (error) {
        console.error("Error in fetching session deatails:", error)
      }
    } else {
      navigate("/login")
      setLoading(false)
    }
  }

  const fetchSessionStudentPendingActivityData = async (
    pk_student_key,
    activity_method
  ) => {
    if (authUser && authUser != "" && authUser != null) {
      setPendingActivitySeleteAll(false);
      setSessionStudentPendingActivityArray([]);
      setSessionStudentPendingActivity([])
      setActivityPendingLoading(true)
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responsesessionpendingactivitydetails = await axios.post(
          BASE_URL + "session/SessionStudentPendingActivity",
          {
            pk_student_key: pk_student_key.value,
            pk_ses_key_cur: key,
            is_homework: activity_method,
          }
        )

        if (responsesessionpendingactivitydetails.data.length > 0) {
          setPendingActivitySeleteAll(false);
          setSessionStudentPendingActivityArray([]);
          setSessionStudentPendingActivity(
            responsesessionpendingactivitydetails.data
          )
          setActivityPendingLoading(false)
        } else {
          setPendingActivitySeleteAll(false);
          setSessionStudentPendingActivityArray([]);
          setSessionStudentPendingActivity([])
          setActivityPendingLoading(false)
        }
      } catch (error) {
        console.error("Error in fetching session deatails:", error)
        setActivityPendingLoading(false)
      }
    } else {
      navigate("/login")
      setActivityPendingLoading(false)
    }
  }

  const fetchSessionStudentNextActivityData = async (
    pk_student_key,
    is_homework,
    session_key,
    subject_id
  ) => {
    if (authUser && authUser != "" && authUser != null) {
      setActivityNextLoading(true)

      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responsesessionnextactivitydetails = await axios.post(
          BASE_URL + "activity/getAssessmentActivitiesNext",
          {
            activity_level_id: 0,
            attended: "",
            search: "",
            student_key: pk_student_key.value,
            session_key: session_key,
            subject_id: subject_id,
            is_homework: is_homework,
          }
        )

        if (
          responsesessionnextactivitydetails.data.activities &&
          responsesessionnextactivitydetails.data.activities.length > 0
        ) {
          setSessionStudentNextActivity(
            responsesessionnextactivitydetails.data.activities
          )
          setActivityNextLoading(false)
        } else {
          setSessionStudentNextActivity([])
          setSessionStudentNextActivity(prevData => [...prevData, ...[]])
          setActivityNextLoading(false)
        }
      } catch (error) {
        console.error("Error in fetching session deatails:", error)
        setActivityNextLoading(false)
      }
    } else {
      navigate("/login")
      setActivityNextLoading(false)
    }
  }

  const fetchSessionStudentSubjectNextActivityData = async (
    pk_student_key,
    is_homework,
    session_key,
    subject_id
  ) => {
    if (authUser && authUser != "" && authUser != null) {
      setActivitysubjectNextLoading(true)
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responsesessionnextactivitydetails = await axios.post(
          BASE_URL + "activity/getAssessmentActivitiesNext",
          {
            activity_level_id: 0,
            attended: "",
            search: "",
            student_key: pk_student_key.value,
            session_key: session_key,
            subject_id: subject_id,
            is_homework: is_homework,
          }
        )

        if (
          responsesessionnextactivitydetails.data.activities &&
          responsesessionnextactivitydetails.data.activities.length > 0
        ) {
          setSessionStudentSubjectNextActivity(
            responsesessionnextactivitydetails.data.activities
          )
          setActivitysubjectNextLoading(false)
        } else {
          setSessionStudentSubjectNextActivity([])
          setActivitysubjectNextLoading(false)
        }
      } catch (error) {
        console.error("Error in fetching session deatails:", error)
        setActivitysubjectNextLoading(false)
      }
    } else {
      navigate("/login")
      setActivitysubjectNextLoading(false)
    }
  }

  useEffect(() => {
    let totalPending = 0

    SessionStudentPendingActivity.forEach(enroll => {
      const isNextSessionAvailable =
        NextSessionData &&
        NextSessionData.next_session_date &&
        NextSessionData.next_session_date !== ""

      if (isNextSessionAvailable) {
        const activities = enroll.Lesson?.LessonActivities || []
        const incompleteActivities = activities.filter(
          activity =>
            activity.status === 0 ||
            ((activity.mastryScore === null ||
                parseInt(activity.mastryScore) < 75) &&
              activity.status === 1 &&
              [0, 2, 6, 7].includes(activity.activity_type))
        )

        totalPending += incompleteActivities.length
      }
    })

    setTotalPendingActivity(totalPending)
  }, [SessionStudentPendingActivity, NextSessionData])


  const fetchMasterData = async () => {
    try {
      if (authUser && authUser != "" && authUser != null) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const responseLevel = await axios.post(BASE_URL + "student/yearLevel")
        if (responseLevel.data.length > 0) {
          const formattedyearOptions = responseLevel.data.map(option => ({
            value: option.activity_level_id,
            label: option.level_name,
          }))
          formattedyearOptions.unshift({
            value: "",
            label: "Select",
          })
        }
      } else {
        navigate("/login")
      }
    } catch (error) {
      if (
        (error?.response?.status === 403 || error?.response?.status === 401) &&
        (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
      ) {
        localStorage.clear()
        navigate("/login")
      }
    }
  }

  function noteaddfunction(event) {
    const value = event.target.value

    if (value.length > 0) {
      if (authUser && authUser != "" && authUser != null) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/lessonNotesAdd", {
            pk_ses_key: key,
            pk_student_key: studentKay,
            lessonNote: lessonNote,
          })
          .then(responseNotes => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties
            if (parseInt(responseNotes.data) === 1) {
              setLessonNote("")
              fetchlessonNotesData(studentKay)
              fetchData()
            } else {
            }
          })
          .catch(error => {

            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        navigate("/login")
      }
    }
  }

  const onDelectNote = () => {

    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        setIsNoteSubmitting(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/deleteNote", {
            pk_ses_key: key,
            pk_notes_key: note_key,
          })
          .then(responseNoteDelete => {
            if (parseInt(responseNoteDelete.data) === 1) {
              tog_delete_note()
              setIsNoteSubmitting(false)
              fetchlessonNotesData(studentKay)
              fetchData()
            } else {
              setIsNoteSubmitting(false)
            }
          })
          .catch(error => {
            setIsNoteSubmitting(false)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setIsNoteSubmitting(false)
        navigate("/session")
      }
    } else {
      setIsNoteSubmitting(false)
      navigate("/login")
    }
  }

  const columns = useMemo(
    () => [
      {
        name: "Student Name",
        Header: "Student Name",
        accessor: row =>
          row.st_first_name && row.st_first_name != ""
            ? row.st_first_name + " " + row.st_surname
            : "-",
      },
      {
        name: "Level",
        Header: "Level",
        accessor: row =>
          row.level_name && row.level_name != "" ? row.level_name : "-",
      },
      {
        name: "School Name",
        Header: "School Name",
        accessor: row =>
          row.fk_sc_id != null && row.fk_sc_id != "" ? row.fk_sc_id : "-",
      },
      {
        name: "Attendance",
        Header: "Attendance",
        accessor: "attendance_status",
        Cell: ({ row }) => {
          const rowValue = row.values
          // Conditionally render content based on the value of tp_status

          if (parseInt(rowValue.attendance_status) === 0) {
            return (
              <button className="btn tb-primary text-white text-uppercase">
                Pending
              </button>
            )
          } else if (parseInt(rowValue.attendance_status) === 2) {
            return (
              <button className="btn tb-success text-uppercase">
                Attended
              </button>
            )
          } else if (parseInt(rowValue.attendance_status) === 1) {
            return (
              <button className="btn tb-warning text-white text-uppercase">
                {" "}
                Ongoing
              </button>
            )
          } else if (parseInt(rowValue.attendance_status) === 3) {
            return (
              <button className="btn tb-danger text-white text-uppercase">
                {" "}
                Missed
              </button>
            )
          } else if (parseInt(rowValue.attendance_status) === 4) {
            return (
              <button className="btn tb-danger text-white text-uppercase">
                {" "}
                Offline
              </button>
            )
          } else if (parseInt(rowValue.attendance_status) === 5) {
            return (
              <button className="btn tb-danger text-white text-uppercase">
                {" "}
                Deffer Request
              </button>
            )
          } else if (parseInt(rowValue.attendance_status) === 6) {
            return (
              <button className="btn tb-danger text-white text-uppercase">
                {" "}
               {parseInt(rowValue.is_paused) === 1 ? 'Paused' : 'Cancelled'}
              </button>
            )
          } else {
            return (
              <button className="btn tb-primary text-white text-uppercase">
                Pending
              </button>
            )
          }
        },
        //accessor: row => row.attendance_status != null && row.attendance_status != '' ? parseInt(row.attendance_status) === 0 ? 'Pending' : parseInt(row.attendance_status) === 1 ? 'Ongoing' : parseInt(row.attendance_status) === 2 ? 'Attended' : parseInt(row.attendance_status) === 6 ? 'Canceled' : 'Pending': '-',
      },
      {
        name: "Previous Notes",
        Header: "Previous Notes",
        accessor: row =>
          row.previous_notes != null && row.previous_notes != ""
            ? row.previous_notes
            : "-",
      },
      {
        name: "'Today's Notes'",
        Header: "Today's Notes",
        accessor: row =>
          row.today_notes != null && row.today_notes != ""
            ? row.today_notes
            : "-",
      },
      {
        Header: "",
        disableSortBy: true,
        accessor: "pk_student_key",
        disableFilters: true,

        Cell: ({ row }) => (
          <>
            <button
              className="btn"
              onClick={() => toggleRightCanvasStu(row.original.pk_student_key)}
            >
              <i
                class="mdi mdi-chevron-right-circle-outline"
                style={{ color: "#979797", fontSize: "20px" }}
              ></i>
            </button>
          </>
        ),
      },
      {
        accessor: "student_key",
        disableSortBy: true,
        disableFilters: true,
        isVisible: false,

        selector: row => row.values.pk_student_key,
        show: false,
      },
    ],
    []
  )

  const columns1 = useMemo(
    () => [
      {
        name: "Date",
        Header: "Date",
        accessor: row =>
          row.ses_date != null || row.ses_date != ""
            ? moment(row.ses_date, "YYYY-MM-DDTHH:mm:ss.SSSZ").format(
              "DD-MM-YYYY"
            )
            : "-",
      },
      {
        name: "Time",
        Header: "Time",
        accessor: row =>
          row.ses_start_time != null || row.ses_start_time != ""
            ? getMomentLocaleTimeFormat(row.ses_start_time, "HH:mm:ss", userSetting.locale) +
            " " +
            getMomentLocaleTimeFormat(row.ses_end_time, "HH:mm:ss", userSetting.locale)
            : "-",
      },
      {
        name: "Sestion Name",
        Header: "Sestion Name",
        accessor: row =>
          row.sest_name != null || row.sest_name != "" ? row.sest_name : "-",
      },
      {
        name: "Subject",
        Header: "Subject",
        accessor: row =>
          row.student_subject == null || row.student_subject == ""
            ? "-"
            : row.student_subject,
      },
      {
        name: "Type",
        Header: "Type",
        accessor: row =>
          row.sest_is_holidays == null || row.sest_is_holidays == ""
            ? "-"
            : row.sest_is_holidays == "1"
              ? "Recurring"
              : row.sest_is_holidays == "2"
                ? "One Off Session"
                : row.sest_is_holidays == "3"
                  ? "Make Up Session"
                  : "-",
      },
      {
        Header: "Status",
        disableSortBy: true,
        accessor: "ses_status",
        disableFilters: true,
        Cell: ({ row }) => {
          const rowValue = row.original
          if (parseInt(rowValue.ses_status) === 0) {
            return (
              <button className="btn bg-primary text-white">Upcoming</button>
            )
          } else if (
            parseInt(rowValue.ses_status) === 1 &&
            parseInt(rowValue.ses_is_completed) === 1
          ) {
            return <button className="btn bg-success">Completed</button>
          } else if (
            parseInt(rowValue.ses_status) === 1 &&
            parseInt(rowValue.ses_is_completed) === 0
          ) {
            return (
              <button className="btn bg-warning text-white"> On Going</button>
            )
          } else {
            return (
              <button className="btn bg-primary text-white">Upcoming</button>
            )
          }
        },
      },
      {
        Header: "#",
        disableSortBy: true,
        accessor: "pk_ses_key",
        disableFilters: true,
        Cell: ({ row }) => {
          const rowValue = row.values
          if (rowValue.pk_ses_key && rowValue.pk_ses_key != null) {
            return (
              <Link to={"/session/" + rowValue.pk_ses_key}>
                <i
                  class="mdi mdi-chevron-right-circle-outline"
                  style={{ color: "#979797", fontSize: "20px" }}
                ></i>
              </Link>
            )
          } else {
            return ""
          }
        },
      },
    ],
    []
  )

  const columns_session = [
    {
      name: "Date",
      Header: "Date",
      accessor: row => (row.ses_date ? new Date(row.ses_date) : null), // Use raw date for sorting
      Cell: ({ value }) => {
        if (!value) return "-"

        const day = String(value.getDate()).padStart(2, "0")
        const month = String(value.getMonth() + 1).padStart(2, "0")
        const year = value.getFullYear()
        return `${day}-${month}-${year}`
      },
    },
    {
      name: "Session Name",
      Header: "Session Name",
      accessor: row =>
        row.sest_name && row.sest_name != "" ? row.sest_name : "-",
    },
    {
      name: "Subject",
      Header: "Subject",
      accessor: row =>
        row.sub_name != null && row.sub_name != "" ? row.sub_name : "-",
    },
    {
      name: "Action",
      Header: "Action",
      accessor: "pk_ses_key",
      Cell: ({ row }) => {
        const { pk_ses_key } = row.values

        return (
          <input
            type="checkbox"
            className="form-check-input"
            checked={row.original.checked}
            onChange={e => handleCheckboxChange(pk_ses_key, e.target.checked)}
          />
        )
      },
    },

  ]

  const columns_multi_session = [
    {
      name: "Date",
      Header: "Date",
      accessor: row => (row.ses_date ? new Date(row.ses_date) : null), // Use raw date for sorting
      Cell: ({ value }) => {
        if (!value) return "-"

        const day = String(value.getDate()).padStart(2, "0")
        const month = String(value.getMonth() + 1).padStart(2, "0")
        const year = value.getFullYear()
        return `${day}-${month}-${year}`
      },
    },
    {
      name: "Session Name",
      Header: "Session Name",
      accessor: row =>
        row.sest_name && row.sest_name != "" ? row.sest_name : "-",
    },
    {
      name: "Subject",
      Header: "Subject",
      accessor: row =>
        row.sub_name != null && row.sub_name != "" ? row.sub_name : "-",
    },
    {
      name: "Action",
      Header: "Action",
      accessor: "pk_ses_key",
      Cell: ({ row }) => {
        const { pk_ses_key } = row.values

        return (
          <input
            type="checkbox"
            className="form-check-input"
            checked={row.original.checked}
            onChange={e =>
              handleCheckboxMulChange(pk_ses_key, e.target.checked)
            }
          />
        )
      },
    },
  ]

  //Add Coin Popup start
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      pk_student_key: "",
      coins_earned: "",
      remarks: "",
    },
    validationSchema: Yup.object({
      pk_student_key: Yup.mixed().required("Student list is required"),
      coins_earned: Yup.number()
        .integer()
        .min(1, "Minimum value 1 is required")
        .max(30, "Maximum value 30 is required")
        .required("Coins is required."),
      remarks: Yup.string()
        .notRequired()
        .matches(
          /^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/,
          "Avoid start & end with a space or comma"
        ),
    }),
    onSubmit: async (values, actions) => {
      setIsSubmitting(true)

      try {
        const response = await axios.post(BASE_URL + "session/awardCoins", {
          ...values,
        })
        if (parseInt(response.data) === 1) {
          tog_center2()
          actions.resetForm()
          toast.success(" Coins assigned to students", {
            autoClose: 3000,
          })

          setIsSubmitting(false)
        } else {
          toast.error("Coins not assigned to student, Try again later", {
            autoClose: 3000,
          })
          setIsSubmitting(false)
        }
      } catch (error) {
        if (
          (error?.response?.status === 403 ||
            error?.response?.status === 401) &&
          (error?.response?.data?.error === "jwt expired" ||
            error?.response?.data?.error === "invalid algorithm" ||
            error?.response?.data?.error === "invalid token")
        ) {
          localStorage.clear()
          navigate("/login")
        }
        console.error("Error fetching data:", error)

        setIsSubmitting(false) // Re-enable the submit button
      } finally {
        setIsSubmitting(false) // Re-enable the submit button
      }
    },
  })
  //add coin popup end

  // Remove Coin Popup start
  const removeValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      pk_student_key: "",
      coins_deducted: "",
      remarks: "",
    },
    validationSchema: Yup.object({
      pk_student_key: Yup.mixed().required("Student list is required"),
      coins_deducted: Yup.number()
        .integer()
        .min(1, "Minimum value 1 is required")
//      .max(30, "Maximum value 30 is required")
        .required("Coins is required."),
      remarks: Yup.string()
        .notRequired()
        .matches(
          /^[^,\s][A-Za-z0-9.!@#$%-/^&*()_+,\s]*[^,\s]$/,
          "Avoid start & end with a space or comma"
        ),
    }),
    onSubmit: async (values, actions) => {
      setIsSubmitting(true)

      try {
        const response = await axios.post(BASE_URL + "session/removeCoins", {
          ...values,
        })

        if (parseInt(response.data) === 1) {
          tog_removeCoins()
          actions.resetForm()
          toast.success("Coins removed from students", { autoClose: 3000 })
        } else if (parseInt(response.data) === 2) {
          toast.error("Insufficient coins for one or more students", {
            autoClose: 3000,
          })
        } else {
          toast.error("Coins not removed, try again later", { autoClose: 3000 })
        }
      } catch (error) {
        if (
          (error?.response?.status === 403 || error?.response?.status === 401) &&
          (error?.response?.data?.error === "jwt expired" ||
            error?.response?.data?.error === "invalid algorithm" ||
            error?.response?.data?.error === "invalid token")
        ) {
          localStorage.clear()
          navigate("/login")
        }
        console.error("Error removing coins:", error)
        toast.error("Coins not removed, try again later", { autoClose: 3000 })
      } finally {
        setIsSubmitting(false)
      }
    },
  })
// Remove Coin Popup end
  
  
  const validation1 = useFormik({
    enableReinitialize: true,
    initialValues: {
      pk_student_key: "",
      activities: [],
      next_session: "", // Initialize as empty
      activity_method: "0",
    },
    validationSchema: Yup.object({
      pk_student_key: Yup.mixed().required("Student list is required"),
      activity_method: Yup.mixed().required("Activity method is required"),
      activities: Yup.array()
        .min(1, "At least one activity must be selected.") // Ensure at least one activity is selected
        .required("Activities are required."),
    }),
    onSubmit: async (values, actions) => {
      setIsSubmitting(true) // Disable submit button

      const nextSession = NextSessionData.next_session

      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`

        const response = await axios.post(
          BASE_URL + "session/MoveActivityTonextSession",
          {
            ...values,
            pk_student_key: values.pk_student_key.value,
            pk_ses_key_array: nextSession ? [nextSession] : [],
          }
        )

        if (parseInt(response.data) === 1) {
          tog_center3()
          actions.resetForm()
          toast.success("Moved to the next session successfully", {
            autoClose: 3000,
            onClose: () => {
              // After 3 seconds, navigate back one step in the browser's history
              OnSubmitNavActivityAssign(
                nextSession,
                values.pk_student_key,
                values.activity_method
              )
            },
          })

        } else {
          toast.error(
            "Activity not moved to the next session, Try again later",
            {
              autoClose: 3000,
            }
          )
        }
      } catch (error) {
        if (
          (error?.response?.status === 403 || error?.response?.status === 401) &&
          (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
        ) {
          localStorage.clear()
          navigate("/login")
        }
        console.error("Error fetching data:", error)
      } finally {
        setIsSubmitting(false) // Re-enable the submit button
      }
    },
  })

  const OnSubmitNavActivityAssign = async (
    next_session_key,
    next_student_key,
    activity_method
  ) => {
    if (
      next_session_key &&
      next_student_key &&
      SessiosNextActivity?.length > 0
    ) {
      // Remove specific fields from SessiosNextActivity
      const updatedSessiosNextActivity = SessiosNextActivity.map(
        ({
           activity_level_data,
           activity_level_id_data,
           activity_topic_data,
           activity_subject,
           ...rest
         }) => rest
      )

      if (updatedSessiosNextActivity.length > 0) {
        // Convert the updated data to JSON and store in localStorage
        localStorage.setItem(
          "selectedData",
          JSON.stringify(updatedSessiosNextActivity)
        )
      } else {
        localStorage.removeItem("selectedData")
      }

      // Update typeAct in localStorage
      localStorage.setItem("typeAct", activity_method === 1 ? 2 : 1)

      // Update session and student keys
      localStorage.setItem("session_key", next_session_key)
      localStorage.setItem("student_key", next_student_key.value)

      // Navigate to the new activity session
      navigate("/session-newactivity")
    } else {
      // Skip if validation fails
      console.warn("Invalid inputs or empty activity list.")
    }
  }

  const calculateSessionDuration = (sesStartTime, sesEndTime) => {
    if (sesStartTime && sesEndTime) {
      const currentDate = "2024-02-04"
      const startTime = moment(
        `${currentDate} ${sesStartTime}`,
        "YYYY-MM-DD HH:mm:ss"
      )
      const endTime = moment(
        `${currentDate} ${sesEndTime}`,
        "YYYY-MM-DD HH:mm:ss"
      )

      const duration = moment.duration(endTime.diff(startTime)).asMinutes()
      return `${duration} mins`
    } else {
      return "-"
    }
  }

  const authUserCountry = JSON.parse(localStorage.getItem("country")) || "1"
  const [startButton, setStartButton] = useState(false)

  const [endButton, setendButton] = useState(false)

  useEffect(() => {
    /*kathir 29/03/24 start */

    if (
      sessionData &&
      sessionData.session &&
      sessionData.session.ses_date &&
      parseInt(sessionData.session.ses_status) === 0 &&
      parseInt(sessionData.session.ses_is_completed) === 0
    ) {
      if (
        (parseInt(authUserCountry) === 183 || parseInt(authUserCountry) === 189) &&
        moment(sessionData.session.ses_date, moment.ISO_8601).format(
          "YYYY-MM-DD"
        ) === moment().tz("Europe/London").format("YYYY-MM-DD") &&
        moment(sessionData.session.ses_start_time, "HH:mm:ss").format(
          "HH:mm:ss"
        ) <=
        moment(sessionData.session.todayCurrectTime, "HH:mm:ss").format(
          "HH:mm:ss"
        )
        //&& moment(sessionData.session.ses_end_time, "HH:mm:ss").format("HH:mm:ss") >= moment(sessionData.session.todayCurrectTime, "HH:mm:ss").format("HH:mm:ss")
      ) {
        setStartButton(true)
      } else if (
        parseInt(authUserCountry) === 1 &&
        moment(sessionData.session.ses_date, moment.ISO_8601).format(
          "YYYY-MM-DD"
        ) === moment().tz("Asia/Singapore").format("YYYY-MM-DD") &&
        moment(sessionData.session.ses_start_time, "HH:mm:ss").format(
          "HH:mm:ss"
        ) <=
        moment(sessionData.session.todayCurrectTime, "HH:mm:ss").format(
          "HH:mm:ss"
        )
        //&& moment(sessionData.session.ses_end_time, "HH:mm:ss").format("HH:mm:ss") >= moment(sessionData.session.todayCurrectTime, "HH:mm:ss").format("HH:mm:ss")
      ) {
        setStartButton(true)
      } else if (
        parseInt(authUserCountry) === 184 &&
        moment(sessionData.session.ses_date, moment.ISO_8601).format(
          "YYYY-MM-DD"
        ) === moment().tz("Pacific/Auckland").format("YYYY-MM-DD") &&
        moment(sessionData.session.ses_start_time, "HH:mm:ss").format(
          "HH:mm:ss"
        ) <=
        moment(sessionData.session.todayCurrectTime, "HH:mm:ss").format(
          "HH:mm:ss"
        )
        //&& moment(sessionData.session.ses_end_time, "HH:mm:ss").format("HH:mm:ss") >= moment(sessionData.session.todayCurrectTime, "HH:mm:ss").format("HH:mm:ss")
      ) {
        setStartButton(true)
      } else if (
        parseInt(authUserCountry) === 185 &&
        moment(sessionData.session.ses_date, moment.ISO_8601).format(
          "YYYY-MM-DD"
        ) === moment().tz("Australia/Sydney").format("YYYY-MM-DD") &&
        moment(sessionData.session.ses_start_time, "HH:mm:ss").format(
          "HH:mm:ss"
        ) <=
        moment(sessionData.session.todayCurrectTime, "HH:mm:ss").format(
          "HH:mm:ss"
        )
        //moment(sessionData.session.ses_end_time, "HH:mm:ss").format("HH:mm:ss") >= moment(sessionData.session.todayCurrectTime, "HH:mm:ss").format("HH:mm:ss")
      ) {
        setStartButton(true)
      }
    } else {
      setStartButton(false)
    }

    if (
      sessionData &&
      sessionData.session &&
      sessionData.session.ses_date &&
      parseInt(sessionData.session.ses_status) === 1 &&
      parseInt(sessionData.session.ses_is_completed) === 0
    ) {
      setendButton(true)
    } else {
      setendButton(false)
    }

    /* kathir 29/03/24 end*/
  }, [sessionData])
  function onSessionStart() {
    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        setIsSessionStart(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/sessionStart", {
            pk_ses_key: key,
            pk_ses_id: sessionData.session.pk_ses_id,
          })
          .then(responseSessionStart => {
            if (parseInt(responseSessionStart.data) === 1) {
              setIsSessionStart(false)
              fetchData()
            } else {
              setIsSessionStart(false)
              toast.error("Failure! Unable to session start. Try again later", {
                autoClose: 3000
              })
            }
          })
          .catch(error => {
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setIsSessionStart(false)
        navigate("/session")
      }
    } else {
      setIsSessionStart(false)
      navigate("/login")
    }
  }

  function onSessionEnd() {
    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        setIsSessionEnd(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/sessionEnd", {
            pk_ses_key: key,
          })
          .then(responseSessionEnd => {
            if (parseInt(responseSessionEnd.data) === 1) {
              tog_session_end()
              setIsSessionEnd(false)
              fetchData()
            } else {
              setIsSessionEnd(false)
              toast.error("Failure! Unable to session end. Try again later", {
                autoClose: 3000
              })
            }
          })
          .catch(error => {
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setIsSessionEnd(false)
        navigate("/session")
      }
    } else {
      setIsSessionEnd(false)
      navigate("/login")
    }
  }

  function onDelectActivityPopup(getActivityKey) {
    onDelectActivity(getActivityKey); // Execute after 2 seconds
  }

  const onDelectActivity = (getActivityKey) => {

    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/deleteActivity", {
            pk_ses_key: key,
            pk_lesson_activity_key: getActivityKey,
          })
          .then(responseActivityDelete => {
            if (parseInt(responseActivityDelete.data) === 1) {
              toast.success("Activity deleted successfully", {
                autoClose: 3000
              })
              fetchData()
            } else {
              toast.error(
                "Failure! Unable to delete activity. Try again later",
                {
                  autoClose: 3000
                }
              )
            }
          })
          .catch(error => {
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        navigate("/session")
      }
    } else {
      navigate("/login")
    }
  }
  const onMoveActivityUpcomingSession = () => {

    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        setIsMASubmitting(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios.post(
          BASE_URL + "session/submitMoveMultipleActivityToSessionMultiple",
          {
            pk_ses_key_array: moveingSessionKey,
            pk_lesson_activity_key_array: [move_activity.pk_lesson_activity_key],
            pk_student_key: move_activity.fk_student_key,
            is_homework: rollOveractiveTabSingle === "homework" ? 1 : 0,
          }
        ).then(responseActivityMove => {
          if (parseInt(responseActivityMove.data) === 1) {
            toast.success(
              "Activity rolled over to next session(s) successfully",
              {
                autoClose: 3000
              }
            )
            setmoveingSessionKey([])
            tog_move_activity()
            setIsMASubmitting(false)
          } else {
            setIsMASubmitting(false)
            toast.error("Failure! Unable to move activity. Try again later", {
              autoClose: 3000
            })
          }
        })
          .catch(error => {
            setIsMASubmitting(false)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setIsMASubmitting(false)
        navigate("/session")
      }
    } else {
      setIsMASubmitting(false)
      navigate("/login")
    }
  }

  const onMoveActivityHomework = (move_activity) => {

    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/submitMoveMultipleActivityToSessionMultiple", {
            pk_ses_key_array: [key],
            pk_lesson_activity_key_array: [move_activity.pk_lesson_activity_key],
            pk_student_key: move_activity.fk_student_key,
            is_homework: '1',
          })
          .then(responseActivityMoveHome => {
            if (parseInt(responseActivityMoveHome.data) === 1) {
              toast.success(
                "Activity added to homework successfully",
                {
                  autoClose: 3000
                }
              )
              fetchData()
            } else {
              toast.error("Failure! Unable to add activity. Try again later", {
                autoClose: 3000
              })
            }
          })
          .catch(error => {
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        navigate("/session")
      }
    } else {
      navigate("/login")
    }
  }

  function onPreviewActivity(activityData) {
    const jwt_token = JSON.parse(localStorage.getItem("authUser")) || '';
    if (
      activityData.pk_lesson_activity_key &&
      activityData.fk_sub_id &&
      activityData.fk_student_key
    ) {
      const baseParams = `?type=${encodeURIComponent(activityData.fk_sub_id)}&homework=${encodeURIComponent(activityData.marked_for_homework)}&st_key=${encodeURIComponent(activityData.fk_student_key)}&auth=${encodeURIComponent(jwt_token)}&is_trial=${encodeURIComponent(localStorage.getItem("is_trial") || 0)}`;

      const activityKey = activityData.pk_lesson_activity_key;
      const type = parseInt(activityData.activity_type);

      switch (type) {
        case 0:
          window.location.href = `${STUDENT_BASE_URL}preview-assessment-details/${activityKey}${baseParams}`;
          break;
        case 1:
        case 6:
          window.location.href = `${STUDENT_BASE_URL}preview-video/${activityKey}${baseParams}`;
          break;
        case 2:
          window.location.href = `${STUDENT_BASE_URL}preview-diagnostic-details/${activityKey}${baseParams}`;
          break;
        case 3:
        case 10:
          window.location.href = `${STUDENT_BASE_URL}preview-link/${activityKey}${baseParams}`;
          break;
        case 4:
          window.location.href = `${STUDENT_BASE_URL}preview-task/${activityKey}${baseParams}`;
          break;
        case 5:
        case 7:
          window.location.href = `${STUDENT_BASE_URL}preview-worksheet/${activityKey}${baseParams}`;
          break;
        case 8:
          navigate(
            `/preview-summative-details/${activityKey}${baseParams}`
          );
          break;
        case ActivityType.ONETIME:
          window.location.href = `${STUDENT_BASE_URL}preview-onetime/${activityKey}${baseParams}`;
          break;
        // Diagnostics (base AND prerequisite tests share this type). Without
        // this case a BMD card fell through to "Unknown activity type"
        // (PM, 2026-08-07). The preview page reads the session's own assigned
        // questions, so it works for a prerequisite test too, which has no
        // year/topic to re-derive a test from.
        case ActivityType.DIAGNOSTICS_FLOW:
          window.location.href = `${STUDENT_BASE_URL}preview-bmd/${activityKey}${baseParams}`;
          break;
        // English diagnostics: the card opens its own preview modal, and the
        // student app has no preview page for it, so there is nowhere to go.
        case ActivityType.ENGLISH_DIAGNOSTICS:
          break;
        default:
          toast.error("Unknown activity type", { autoClose: 3000 });
      }
    } else {
      toast.error("Sorry, Activity Key Missing", {
        autoClose: 3000,
      });
    }
  }

  function onManualMarkingActivity(activityDetails) {
    if (activityDetails && (parseInt(activityDetails.activity_type) === 0 || parseInt(activityDetails.activity_type) === 8)) {
      if (
        activityDetails.pk_lesson_activity_key &&
        activityDetails.fk_sub_id &&
        activityDetails.fk_student_key
      ) {
        navigate(
          `/manual-assessment/${activityDetails.pk_lesson_activity_key}`,
          {
            state: {
              type: `${activityDetails.fk_sub_id}`,
              st_key: `${activityDetails.fk_student_key}`,
            },
          }
        )
      } else {
        toast.error("Sorry, Activity Key Missing", {
          autoClose: 3000
        })
      }
    } else if (
      activityDetails &&
      parseInt(activityDetails.activity_type) === 5
    ) {
      if (
        activityDetails.pk_lesson_activity_key &&
        activityDetails.fk_sub_id &&
        activityDetails.fk_student_key
      ) {
        navigate(
          `/manual-worksheet/${activityDetails.pk_lesson_activity_key}`,
          {
            state: {
              type: `${activityDetails.fk_sub_id}`,
              st_key: `${activityDetails.fk_student_key}`,
            },
          }
        )
      } else {
        toast.error("Sorry, Activity Key Missing", {
          autoClose: 3000
        })
      }
    } else if (
      activityDetails &&
      parseInt(activityDetails.activity_type) === 7
    ) {
      if (
        activityDetails.pk_lesson_activity_key &&
        activityDetails.fk_sub_id &&
        activityDetails.fk_student_key
      ) {
        navigate(
          `/manual-lcms-worksheet/${activityDetails.pk_lesson_activity_key}`,
          {
            state: {
              type: `${activityDetails.fk_sub_id}`,
              st_key: `${activityDetails.fk_student_key}`,
            },
          }
        )
      } else {
        toast.error("Sorry, Activity Key Missing", {
          autoClose: 3000
        })
      }
    } else {
      toast.error("Sorry, Activity Key Missing", {
        autoClose: 3000
      })
    }

  }

  //Home Tab
  const CountTotalCoins = enrolment => {
    let total_coins_stu = 0

    let Completed_total_stu = 0

    if (
      enrolment.tbl_student?.Lesson?.LessonActivities?.length > 0
    ) {
      enrolment.tbl_student.Lesson.LessonActivities.forEach(activity => {
        Completed_total_stu +=
          activity.coins_earned != null && activity.coins_earned != ""
            ? parseInt(activity.coins_earned)
            : 0

        if (
          activity.LessonActivitiesQuestions.length > 0 &&
          (parseInt(activity.activity_type) === 0 || parseInt(activity.activity_type) === 8)
        ) {
          activity.LessonActivitiesQuestions.forEach(lsquestion => {
            if (
              parseInt(lsquestion.fk_sub_id) === 2 &&
              lsquestion?.question?.length > 0
            ) {
              lsquestion.question.forEach(lsquestionParts => {
                total_coins_stu += lsquestionParts.question_parts.length * 2
              })
            } else if (
              parseInt(lsquestion.fk_sub_id) === 1 &&
              lsquestion.english_question.length > 0
            ) {
              lsquestion.english_question.forEach(lsquestionParts => {
                if (
                  parseInt(lsquestionParts.english_question_category_id) ===
                  10 ||
                  parseInt(lsquestionParts.english_question_category_id) === 13
                ) {
                  let total_part = lsquestionParts.english_question_parts
                  let array_part_data = total_part.filter(
                    part =>
                      part.english_question_answers.length > 0 &&
                      part.english_question_answers[0].english_answer_text &&
                      part.english_question_answers[0].english_answer_text != ""
                  )
                  total_coins_stu += array_part_data.length * 2 || 0
                } else {
                  total_coins_stu +=
                    lsquestionParts.english_question_parts.length * 2
                }

              })
            }
          })
        } else if (
          activity.LessonActivitiesQuestions.length > 0 &&
          parseInt(activity.activity_type) === 2
        ) {
          activity.LessonActivitiesQuestions.forEach(lsquestion => {
            if (
              parseInt(lsquestion.fk_sub_id) === 2 &&
              lsquestion?.question?.length > 0
            ) {
              total_coins_stu += lsquestion?.question?.length * 2
            } else if (
              parseInt(lsquestion.fk_sub_id) === 1 &&
              lsquestion.english_question.length > 0
            ) {
              total_coins_stu += lsquestion.english_question.length * 2
            }
          })
        }else if (
          activity.LessonActivitiesQuestions.length > 0 &&
          (parseInt(activity.activity_type) === 1 || parseInt(activity.activity_type) === 3 || parseInt(activity.activity_type) === 4 || parseInt(activity.activity_type) === 5 || parseInt(activity.activity_type) === 10)
        ) {
          total_coins_stu += activity.activity_node[0] && activity.activity_node[0].coins != ""? activity.activity_node[0].coins : 2
        }else if (
          parseInt(activity.activity_type) === 7
        ) {
          total_coins_stu += 20;
        }else if (
          parseInt(activity.activity_type) === ActivityType.PLATFORM_GAMES
        ) {
          total_coins_stu += GameMetadata.coinsPerGame;
        }else if (
          parseInt(activity.activity_type) === ActivityType.LLL
        ) {
          total_coins_stu += LllMetadata.coinsPerActivity;
        } else {
          activity.LessonActivitiesQuestions.forEach(lsquestion => {
            if (lsquestion?.question?.length > 0) {
              total_coins_stu += lsquestion?.question?.length * 2
            }
          })
        }
      })
    }

    return Completed_total_stu + "/" + total_coins_stu
  }

  const CountTotalCoinsActvity = (activity) => {
    let total_coins_stu = 0;
    let Completed_total_stu = 0;

    if (!activity || !activity.LessonActivitiesQuestions?.length) return "0/0";

    Completed_total_stu = Number(activity?.coins_earned) || 0;

    const { LessonActivitiesQuestions, activity_type, activity_node } = activity;

    if ([0, 8].includes(Number(activity_type))) {
      LessonActivitiesQuestions.forEach((lsquestion) => {
        if (Number(lsquestion.fk_sub_id) === 2) {
          lsquestion.question?.forEach(lsquestionParts => {
            total_coins_stu += lsquestionParts.question_parts.length * 2
          }) || 0

        } else if (Number(lsquestion.fk_sub_id) === 1) {
          lsquestion.english_question?.forEach((part) => {
            if ([10, 13].includes(Number(part.english_question_category_id))) {
              total_coins_stu += (part.english_question_parts?.filter(
                (p) => p.english_question_answers?.[0]?.english_answer_text
              ).length || 0) * 2;
            } else {
              total_coins_stu += (part.english_question_parts?.length || 0) * 2;
            }
          });
        }
      });
    } else if (Number(activity_type) === 2) {
      LessonActivitiesQuestions.forEach((lsquestion) => {
        total_coins_stu += (lsquestion.question?.length || lsquestion.english_question?.length || 0) * 2;
      });
    } else if ([1, 3, 4, 5].includes(Number(activity_type))) {
      total_coins_stu += Number(activity_node?.[0]?.coins) || 2;
    } else if (Number(activity_type) === 7) {
      total_coins_stu += 20;
    } else {
      LessonActivitiesQuestions.forEach((lsquestion) => {
        total_coins_stu += (lsquestion.question?.length || 0) * 2;
      });
    }

    return `${Completed_total_stu}/${total_coins_stu}`;
  };

  const CountHours = enrolment => {
    let total_time = 0

    if (
      enrolment.tbl_student?.Lesson?.LessonActivities?.length > 0
    ) {
      enrolment.tbl_student.Lesson.LessonActivities.forEach(activity => {
        total_time += parseInt(activity.total_activity_time) || 0
      })
      let hours = Math.floor(total_time / 60)

      // Calculate remaining minutes
      let minutes = total_time % 60

      return hours + " h " + minutes + " m"
    } else {
      return null
    }
  }

  const CountTotalActivity = enrolment => {
    let total_activity_stu = 0
    let completed_activity_stu = 0

    let icon = <i className="mdi mdi-shuffle-variant"></i>

    if (
      enrolment.tbl_student?.Lesson?.LessonActivities?.length > 0
    ) {
      if (parseInt(enrolment.tbl_student.Lesson.is_lesson_sequential) === 1) {
        icon = <i className=" mdi mdi-sort-ascending"></i>
      } else {
        icon = <i className="mdi mdi-shuffle-variant"></i>
      }

      enrolment.tbl_student.Lesson.LessonActivities.forEach(activity => {
        completed_activity_stu +=
          activity.status != null && activity.status == "1" ? 1 : 0
        total_activity_stu += 1
      })
    }
    //console.log(enrolment)
    if (
      enrolment.tbl_student?.tbl_session_attendance?.attendance_status === 3
    ) {
      return <p className="mt-2 mb-2 text-danger">Missed</p>
    } else if (
      enrolment.tbl_student?.tbl_session_attendance?.attendance_status === 4
    ) {
      return <p className="mt-2 mb-2 text-danger">Offline</p>
    } else if (
      enrolment.tbl_student?.tbl_session_attendance?.attendance_status === 5
    ) {
      return <p className="mt-2 mb-2 text-danger">Defer Request</p>
    } else if (
      enrolment.tbl_student?.tbl_session_attendance?.attendance_status === 6
    ) {
      return <p className="mt-2 mb-2 text-danger">{parseInt(enrolment.tbl_student?.tbl_session_attendance?.is_paused) === 1 ? 'Paused' : 'Cancelled'}</p>
    }

    if (total_activity_stu === 0) {
      return <p className="mt-2 mb-2 text-danger">No activities assigned</p>
    }

    let percentage = (completed_activity_stu / total_activity_stu) * 100

    return (
      <p className="mt-2 mb-2">
        {completed_activity_stu}/{total_activity_stu} activities completed (
        {percentage.toFixed(2)}%)<span className="float-end ">{icon}</span>
      </p>
    )
  }

  const [dropdownOpen, setDropdownOpen] = useState({})

  const toggleDropdown = key => {
    setDropdownOpen(prevState => ({
      ...prevState,
      [key]: !prevState[key] || false,
    }))
  }
  const handleLinkClick = (student_key, session_key, subject_ID) => {
    localStorage.setItem("session_key", session_key)
    localStorage.setItem("student_key", student_key)
    localStorage.setItem("subject_ID", subject_ID)
  }

  //Rollover multiple moving option start

  // State to store selected activity keys

  const [activityStudentKey, setActivityStudentKey] = useState("")
  const [selectedActivityKeys, setSelectedActivityKeys] = useState([])
  const [selectedActivitySubject, setselectedActivitySubject] = useState([])
  const [selectAllChecked, setSelectAllChecked] = useState(false)
  const handleSelectAllChange = LessonActivities => {
    const newSelectAllState = !selectAllChecked
    setSelectAllChecked(newSelectAllState)

    // Get all activity keys and student keys
    const allActivityKeys = LessonActivities.map(
      activity => activity.pk_lesson_activity_key
    )
    const allActivitySubjects = LessonActivities.map(activity => ({
      pk_lesson_activity_key: activity.pk_lesson_activity_key,
      fk_sub_id: activity.fk_sub_id,
    }))

    // Set selected activities and subjects based on the select-all state
    setSelectedActivityKeys(newSelectAllState ? allActivityKeys : [])
    setselectedActivitySubject(newSelectAllState ? allActivitySubjects : [])

    // Set the student key only once if selecting all, otherwise clear it
    if (newSelectAllState && LessonActivities.length > 0) {
      setActivityStudentKey(LessonActivities[0].fk_student_key)
    } else {
      setActivityStudentKey("")
    }
  }

  // Function to handle checkbox change
  const handleCheckboxActivityChange = (
    activityKey,
    activity,
    totalActivities
  ) => {

    setSelectedActivityKeys(prevSelectedKeys => {
      const updatedKeys = prevSelectedKeys.includes(activityKey)
        ? prevSelectedKeys.filter(key => key !== activityKey)
        : [...prevSelectedKeys, activityKey]

      // Update selectAllChecked based on the length of selected keys
      setSelectAllChecked(updatedKeys.length === totalActivities)

      return updatedKeys
    })

    setselectedActivitySubject(prevSelectedActivities => {
      const activityObject = {
        pk_lesson_activity_key: activityKey,
        fk_sub_id: activity.fk_sub_id,
      }

      if (
        prevSelectedActivities.some(
          activity => activity.pk_lesson_activity_key === activityKey
        )
      ) {
        // If the activity is already selected, remove it
        const updatedActivities = prevSelectedActivities.filter(
          activity => activity.pk_lesson_activity_key !== activityKey
        )
        return updatedActivities
      } else {
        // If not selected, add the activity object
        return [...prevSelectedActivities, activityObject]
      }
    })
    setActivityStudentKey(activity.fk_student_key)
  }
  useEffect(() => {
    if (selectedActivityKeys && selectedActivityKeys.length === 0) {
      setActivityStudentKey("")
    }
  }, [selectedActivityKeys])

  const [MultipleUpcomingSessionData, setMultipleUpcomingSessionData] =
    useState([])

  const [show_modal_move_multiple_activity, setmodal_move_multiple_activity] =
    useState(false)

  const tog_move_multiple_activity = () => {
    handlerollOverTabChange("lessonPlan")
    setmodal_move_multiple_activity(!show_modal_move_multiple_activity)
  }

  const [moveingMultipleSessionKey, setmoveingMultipleSessionKey] = useState([])
  const [isMulMoningSubmitting, setIsMulMoningSubmitting] = useState(false)

  function onMoveingMultipleActivityPopup() {
    if (moveingMultipleSessionKey.length === 0) {
      toast.error("Please select at least one session!", {
        autoClose: 3000
      })
    } else {
      onMoveMultipleActivityUpcomingSession()
    }
  }

  const handleCheckboxMulChange = (key, isChecked) => {
    const updatedSessions = MultipleUpcomingSessionData.map(session => {
      if (session.pk_ses_key === key) {
        return { ...session, checked: isChecked }
      }
      return session
    })

    setMultipleUpcomingSessionData(updatedSessions)
    if (isChecked) {
      // Add key to the selectedKeys array if checked
      setmoveingMultipleSessionKey(prev => [...prev, key])
    } else {
      // Remove key from the selectedKeys array if unchecked
      setmoveingMultipleSessionKey(prev => prev.filter(k => k !== key))
    }
  }

  const handlerollOverTabChange = tab => {
    setrollOverActiveTab(tab)

    const updatedSessions = MultipleUpcomingSessionData.map(session => ({
      ...session,
      checked: false,
    }))

    setMultipleUpcomingSessionData(updatedSessions)
    setmoveingMultipleSessionKey([])
  }
  const fetchMultipleUpcommingSessionData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      try {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        const uniqueSubjects = selectedActivitySubject.reduce((acc, item) => {
          if (!acc.some(obj => obj.subject_id === item.fk_sub_id)) {
            acc.push({ subject_id: item.fk_sub_id })
          }
          return acc
        }, [])
        const responseSessionUpcomingList = await axios.post(
          BASE_URL + "session/getAllUpcommingActivitySessionList",
          {
            pk_student_key: activityStudentKey,
            fk_subject_id: uniqueSubjects,
          }
        )
        if (responseSessionUpcomingList.data.length > 0) {
          const updatedData = responseSessionUpcomingList.data.map(item => ({
            ...item,
            checked: false, // Add the checked property to each item
          }))
          setMultipleUpcomingSessionData(updatedData)
          setmodal_move_multiple_activity(true)
        } else {
          toast.error("Not found upcoming sessions!", {
            autoClose: 3000
          })
          setMultipleUpcomingSessionData([])
        }
      } catch (error) {
        console.error("Error in fetching upcoming session deatails:", error)
      }
    } else {
      navigate("/login")
    }
  }

  const onMoveMultipleActivityUpcomingSession = () => {

    if (authUser && authUser != "" && authUser != null) {
      if (moveingMultipleSessionKey) {
        setIsMulMoningSubmitting(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(
            BASE_URL + "session/submitMoveMultipleActivityToSessionMultiple",
            {
              pk_ses_key_array: moveingMultipleSessionKey,
              pk_lesson_activity_key_array: selectedActivityKeys,
              pk_student_key: activityStudentKey,
              is_homework: rollOveractiveTab === "homework" ? 1 : 0,
            }
          )
          .then(responseActivityMove => {
            if (parseInt(responseActivityMove.data) === 1) {
              toast.success(
                "Activity rolled over to next session(s) successfully",
                {
                  autoClose: 3000
                }
              )
              tog_move_multiple_activity()
              setIsMulMoningSubmitting(false)
              setSelectedActivityKeys([])
              setselectedActivitySubject([])
              setSelectAllChecked(false)
              window.location.reload()
            } else {
              setIsMulMoningSubmitting(false)
              toast.error("Failure! Unable to move activity. Try again later", {
                autoClose: 3000
              })
            }
          })
          .catch(error => {
            setIsMulMoningSubmitting(false)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setIsMulMoningSubmitting(false)
        navigate("/session")
      }
    } else {
      setIsMulMoningSubmitting(false)
      navigate("/login")
    }
  }

  //Rollover multiple moving option end

//LeaderboardHideandShow start
  const onHandleStudentIsleaderboard = async(data, student_key) => {

    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/updateTutorStudentIsLeaderBoard", {
            pk_student_key: student_key,
            IsLeaderBoard: data === true ? 1 : 0,
          })
          .then(responseStudentLeaderBoard => {
            if (parseInt(responseStudentLeaderBoard.data) === 1) {
              if(data=== true){
                toast.success("Student leaderboard set active successfully", {
                  autoClose: 3000
                })
              }else{
                toast.success("Student leaderboard set in-active successfully", {
                  autoClose: 3000
                })
              }

              fetchData()
            } else {

              toast.error("Sorry, the student leaderboard is not update.", {
                autoClose: 3000
              })
            }
          })
          .catch(error => {

            //console.log(error)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {

        navigate("/session")
      }
    } else {

      navigate("/login")
    }
  }
  //LeaderboardHideandShow end

  const generatePDF = () => {

    const printLesDetails = sessionData || null;
    const printHomeDetails = HomeSessionData || null;

    let file_name = (printLesDetails?.session?.tbl_session_time?.sest_name || "Session Summary");

    // Ensure sessionData

    // Helper to convert data into formated array
    const getFormattedArray = (printDetails) => {
      return printDetails?.session?.tbl_session_time
        ? [{
          session: printDetails.session.tbl_session_time.sest_name || "",
          startTime: getMomentLocaleTimeFormat(printDetails.session.ses_start_time,"HH:mm:ss", userSetting.locale) || "",
          endTime: getMomentLocaleTimeFormat(printDetails.session.ses_end_time,"HH:mm:ss", userSetting.locale) || "",
          date: moment(printDetails.session.ses_date, moment.ISO_8601).format("DD MMM YYYY (ddd)") || "",
          students: Array.isArray(printDetails.session.tbl_session_time.tbl_student_enrolment)
            ? printDetails.session.tbl_session_time.tbl_student_enrolment.map(enrolment => ({
              name: enrolment?.tbl_student?.st_first_name? enrolment?.tbl_student?.st_first_name+' '+enrolment?.tbl_student?.st_surname : "N/A",
              subject: enrolment?.tbl_enrolment_subject ? getUniqueStudentSubjectNames(enrolment?.tbl_enrolment_subject).join(" & ") || "" : "",
              flexi: enrolment?.tbl_student?.tbl_session_attendance?.is_flexi == 1 ? "(Flexi)" : "",
              activities: Array.isArray(enrolment?.tbl_student?.Lesson?.LessonActivities)
                ? enrolment.tbl_student.Lesson.LessonActivities.map(activity => ({
                  coins: activity? CountTotalCoinsActvity(activity) : 0,
                  // score: printDetails?.session?.ses_is_completed === 1 &&
                  // [0, 2, 6, 7, 8].includes(activity?.activity_type) ? activity?.mastryScore || 0 : null,
                  score: printDetails?.session?.ses_is_completed === 1
                    ? [0, 2, 6, 7, 8].includes(activity?.activity_type)
                      ? activity?.mastryScore || 0
                      : [1, 3, 4, 10].includes(activity?.activity_type)
                        ? activity?.mastryScore || (activity?.status === 1 ? 100 : 0)
                        : [5].includes(activity?.activity_type)
                          ? activity?.mastryScore ||
                          (activity?.status === 1 &&
                          activity?.LessonActivitiesQuestions?.[0]?.marked_for_manual_marking > 0
                            ? 100
                            : 0)
                          : null
                    : null,
                  level_name: activity?.level_name ? activity.level_name+' - ' : '',
                  topic_name: activity?.topic_name ? activity.topic_name+' - ' : '',
                  type: activity?.activity_type === 0
                    ? "Online Activities" || ""
                    : activity?.activity_type === 1
                      ? "Video" || ""
                      : activity?.activity_type === 2
                        ? "Diagnostics"|| ""
                        : activity?.activity_type === 3
                          ? "Link" || ""
                          : activity?.activity_type === 4
                            ? "Task" || ""
                            : activity?.activity_type === 5
                              ? "WorkSheet" || ""
                              : activity?.activity_type === 6
                                ? "Video" || ""
                                : activity?.activity_type === 7
                                  ? "WorkSheet" || ""
                                  : activity?.activity_type === 8
                                    ? "Summative" || ""
                                    : activity?.activity_type === 10
                                      ? "File" || ""
                                      : activity?.activity_type === ActivityType.ONETIME
                                        ? "Task (One-time)" || ""
                                        :"",
                  name: activity?.activity_type === 0
                    ? activity?.activity_node?.[0]?.node_name || ""
                    : activity?.activity_type === 1
                      ? activity?.activity_node?.[0]?.name || ""
                      : activity?.activity_type === 2
                        ? getUniqueTopicsNames(activity?.topics) || ""
                        : activity?.activity_type === 3
                          ? activity?.activity_node?.[0]?.name || ""
                          : activity?.activity_type === 4
                            ? activity?.activity_node?.[0]?.name || ""
                            : activity?.activity_type === 5
                              ? activity?.activity_node?.[0]?.name || ""
                              : activity?.activity_type === 6
                                ? activity?.activity_node?.[0]?.video_name || ""
                                : activity?.activity_type === 7
                                  ? activity?.activity_node?.[0]?.node_name || ""
                                  : activity?.activity_type === 8
                                    ? activity?.activity_node?.[0]?.name || ""
                                    : activity?.activity_type === 10
                                      ? activity?.activity_node?.[0]?.name || ""
                                      : activity?.activity_type === ActivityType.ONETIME
                                        ? activity?.activity_node?.[0]?.name || ""
                                        : "Activity",
                  status: activity?.status === 1 ? "Completed" : (activity?.status === 0 ? "Incomplete" : "N/A")
                }))
                : []
            }))
            : []
        }]
        : [];
    };

    //lesson Details filter
    const formattedArray = getFormattedArray(printLesDetails)
    //Homework Details filter
    const formattedHomeArray = getFormattedArray(printHomeDetails)


    const doc = new jsPDF({
      orientation: "portrait", // Change to "portrait" if needed
      unit: "mm",
      format: "a3"
    });


    // Title with Session Details
    const pageWidth = doc.internal.pageSize.getWidth();
    const sessionName = formattedArray.length > 0 ? formattedArray[0].session : "";
    const sessionTime = formattedArray.length > 0
      ? `${formattedArray[0].startTime} - ${formattedArray[0].endTime}`
      : "";
    const sessionDate = formattedArray.length > 0 ? formattedArray[0].date : "";
    // Construct Title
    const title = `Session Summary`;
    const sessionDetails = `Session: ${sessionName} | Date: ${sessionDate} | Time: ${sessionTime}`;
    const currentTab = "Lesson";

    // Calculate Text Width for Center Alignment
    const titleWidth = doc.getTextWidth(title);
    const sessionWidth = doc.getTextWidth(sessionDetails);
    const currentTabWidth = doc.getTextWidth(currentTab);
    const titleX = (pageWidth - titleWidth) / 2;
    const sessionX = (pageWidth - sessionWidth) / 2;
    const currenttabX = (pageWidth - currentTabWidth) / 2;

    // Set Font & Style
    doc.setFont("times", "bold"); // Use Times New Roman
    doc.setFontSize(16);
    doc.text(title, titleX, 15);

    doc.setFont("times", "normal"); // Reset font style
    doc.setFontSize(16);
    doc.text(sessionDetails, sessionX, 25); // Position session details below the title

    doc.setFont("times", "normal"); // Reset font style
    doc.setFontSize(16);
    doc.text(currentTab, currenttabX, 35); // Position tab details below the title
    const wrapText = (text, maxLen = 90) => {
      return text.replace(new RegExp(`(.{1,${maxLen}})(\\s|$)`, 'g'), '$1\n');
    };
    // Helper to convert data into table rows
    const getTableRows = (data) => {
      return data.students.map(student => [
        student.name ? `${student.name}\n(${student.subject})\n${student.flexi}` : "-", // If null or empty, show '-'
        data.session && data.startTime && data.endTime
          ? `${data.session}\n(${data.startTime} - ${data.endTime})`
          : "-", // If any session data is missing, show '-'
        student.activities && student.activities.length > 0
          ? wrapText(student.activities.map((activity, index) => {
              const scoreText = parseInt(activity.score) >= 0
                ? `\nScore: ${activity.score ?? 0}`
                : "";
              return   `${index + 1}.) ${activity.level_name ?? ""} ${activity.topic_name ?? ""} ${activity.name ?? ""}\nType: ${activity.type ?? ""}\nStatus: ${activity.status ?? ""}\nCoins: ${activity.coins ?? 0}${scoreText}`;
            }
          ).join("\n\n"))
          : "-" // If no activities, show '-'
      ]);
    };
    // Ensure formattedArray is not empty
    const students = formattedArray.length > 0 ? formattedArray[0] : [];

    // Convert data to table format
    const tableData = getTableRows(students);

    // Table Headers
    const headers = [["Student Name", "Session Details", "Activities"]];
    if (tableData.length === 0) {
      tableData.push(["", "", "No Data"]);
    }

    autoTable(doc, {
      head: headers,
      body: tableData,
      startY: 40,
      styles: {
        fontSize: 10,
        cellPadding: 3, // Reduce padding to minimize space
        valign: "top", // Align content vertically in the middle
        overflow: 'visible', // <--- let line breaks render naturally
        lineBreak: 'auto',    // optional, default is good too
        halign: 'left',
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
        halign: "start"
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { cellWidth: 50, halign: "left" },  // Adjust width for student names
        1: { cellWidth: 60, halign: "left" },  // Reduce width for session details
        2: { cellWidth: "auto", halign: "left" }  // Auto width for activities
      }
    });


    //homework table
    // Ensure formattedArray is not empty
    const studentsHomework = formattedHomeArray.length > 0 ? formattedHomeArray[0] : [];

    // Convert data to table format
    const tableHomeData = getTableRows(studentsHomework)

    // Table Headers
    if (tableHomeData.length === 0) {
      tableHomeData.push(["", "", "No Data"]);
    }

    const nextY = doc.lastAutoTable.finalY + 15;

    // Homework Header
    doc.setFont("times", "normal"); // Reset font style
    doc.setFontSize(16);
    doc.text("Homework", pageWidth / 2, nextY, { align: "center" });


    autoTable(doc, {
      head: headers,
      body: tableHomeData,
      startY: nextY + 10,
      styles: {
        fontSize: 10,
        cellPadding: 3, // Reduce padding to minimize space
        valign: "top", // Align content vertically in the middle
        overflow: "linebreak" // Ensure text wraps properly
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
        halign: "start"
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { cellWidth: 50, halign: "left" },  // Adjust width for student names
        1: { cellWidth: 60, halign: "left" },  // Reduce width for session details
        2: { cellWidth: "auto", halign: "left" }  // Auto width for activities
      }
    });



    // Save or Print PDF
    doc.save(file_name+".pdf");
  };
  //session print details end

  const LassonPlanContent = ({
                               sessionData,
                               customActiveTab,
                               getUniqueStudentSubjectNames,
                               getUniqueStudentSubjectID,
                               CountTotalCoins,
                               CountTotalActivity,
                               clearTimeout,
                               setLoopRun,
                               handleLinkClick,
                               toggleDropdown,
                               dropdownOpen,
                               onPreviewActivity,
                               onDelectActivityPopup,
                               onMoveActivityPopup,
                               getUniqueTopicsNames,
                               selectedActivityKeys,
                               handleCheckboxActivityChange,
                               activityStudentKey,
                               fetchMultipleUpcommingSessionData,
                               handleSelectAllChange,
                               selectAllChecked,
                               onHandleStudentIsleaderboard,
                               handle_tutorNote
                             }) => {

    if (
      sessionData &&
      sessionData.session &&
      sessionData.session.tbl_session_time &&
      sessionData.session.tbl_session_time.tbl_student_enrolment &&
      sessionData.session.tbl_session_time.tbl_student_enrolment.length > 0
    ) {
    } else {
      return <p className="cs-txt-danger">No student assigned</p>
    }


    /**
     * @param {SessionActivity} activity
     * @param sessionData
     * @param enrolment
     * @param {number} index
     * @return {React.JSX.Element}
     */
    const LessonPlanGeneralActivityCard = ({activity, sessionData, index, enrolment}) => {

      return (<>

        <GeneralActivityCard
          activity={activity} sessionData={sessionData} index={index}

          checkbox={{
            checkable: sessionData.session?.ses_is_completed === 1,
              // && activity.fk_student_key === activityStudentKey,
            checked: selectedActivityKeys.includes(activity.pk_lesson_activity_key),
            onCheckedChanged: () => handleCheckboxActivityChange (
              activity.pk_lesson_activity_key,
              activity,
              enrolment.tbl_student.Lesson.LessonActivities.length
            )
          }}

          manualMarkActivity={{
            enabled: true,
            onActivate: () => onManualMarkingActivity(activity)
          }}

          moveActivity={{
            enabled: true,
            onActivate: () => onMoveActivityPopup(activity)
          }}

          copyToHomework={{
            enabled: sessionData?.session?.ses_is_completed === 1,
            onActivate: () => onMoveHomeworkActivityPopup(activity)
          }}

          previewActivity={{
            enabled: true,
            onActivate: () => onPreviewActivity(activity)
          }}

          deleteActivity={{
            enabled: true,
            onActivate: () => onDelectActivityPopup(activity.pk_lesson_activity_key)
          }}
        ></GeneralActivityCard>

      </>)
    }



    return sessionData &&
    sessionData.session &&
    sessionData.session.tbl_session_time &&
    sessionData.session.tbl_session_time.tbl_student_enrolment
      ? sessionData.session.tbl_session_time.tbl_student_enrolment.map(
        (enrolment, index) => {

          return (
            <div className="kb-child" key={index}>
              <div className="bg-supermild st-pd">
                <div className="profile-details d-flex align-items-center pb-1">
                  <div className="stat-img">
                    <img
                      width={30}
                      className="rounded-circle me-10"
                      src={
                        enrolment.tbl_student && enrolment.tbl_student.avatar
                          ? enrolment.tbl_student.avatar
                          : st2
                      }
                      alt=""
                    />
                  </div>
                  <div>
                    <h5 className="text-dark fw-700">
                      {enrolment &&
                      enrolment.reassign &&
                      enrolment.reassign == "1"
                        ? "*"
                        : null}
                      {enrolment.tbl_student &&
                      enrolment.tbl_student.st_first_name
                        ? enrolment.tbl_student.st_first_name +
                        " " +
                        enrolment.tbl_student.st_surname
                        : null}

                      { enrolment?.tbl_student?.tbl_session_attendance?.is_flexi == 1 && (
                        <span className="badge tb-danger font-size-10 text-uppercase cp-bdg">
                            Flexi
                          </span>
                      )}
                    </h5>

                  </div>
                </div>

                <p className="font-size-15 fw-400 text-dark">
                  {sessionData && sessionData != ""
                    ? getUniqueStudentSubjectNames(
                    enrolment.tbl_enrolment_subject
                  ).join(" & ") || "-"
                    : "-"}
                </p>
                {enrolment.tbl_student && (
                  <p className="text-end mt-2 mb-2 text-danger" onClick={()=>{handle_tutorNote(enrolment.tbl_student || null)}} style={{textDecoration: "underline"}}>Feedback</p>
                )}
                <div className="d-flex gap-3  justify-content-between align-items-center mt-50 flex-wrap">
                  <div className="d-flex align-items-center">
                    <img className="me-10" width={24} src={awicon} alt="" />
                    <p className="mb-0 fw-700 text-dark font-size-12">
                      {CountTotalCoins(enrolment) || "-"}
                    </p>
                  </div>
                  <div
                    className="controls-row"
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'minmax(0,1fr) auto', // 1: button grows, 2: switch fits
                      alignItems: 'center',
                      gap: 8,
                      width: '100%',
                      minWidth: 0
                    }}
                  >

                    {/* PRINT button */}
                    {/* <img className="me-10" width={24} src={duration} alt="" />
                      <p className="mb-0 fw-700 text-dark font-size-12">
                        {CountHours(enrolment)}
                      </p> */}
                    <div
                      className="me-1 d-inline-flex align-items-center aw-button"
                      onClick={() => handlePrintStudentLabeled(enrolment.tbl_student)}
                      style={{ padding: '4px 12px', height: 36, borderRadius: 12, gap: 12, fontSize: 14, lineHeight: 1, minWidth: 0, whiteSpace: 'nowrap' }}
                      title=" Print student worksheets"
                    >
                      <i className="mdi mdi-printer" title="print all students' worksheets with labels" style={{ fontSize: 12 }} />
                      <span className="ms-1" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', maxWidth: '100%' }}>
                               Worksheets
                               </span>
                    </div>


                    <div className="switch-wrapper" style={{ display:'flex', alignItems:'center', whiteSpace:'nowrap', gap:8, justifySelf:'end' }}>
                      Leaderboard{" "}
                      <div className="sw-child" style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <Switch
                          onColor="#ec4561"
                          onChange={(data) => {
                            if(enrolment.tbl_student&& enrolment.tbl_student.pk_student_key ){
                              onHandleStudentIsleaderboard(data, enrolment.tbl_student.pk_student_key)
                            }else{
                              console.log('student key not found')
                            }

                          }}
                          checked={enrolment.tbl_student
                          && enrolment.tbl_student.is_leaderboard
                          && parseInt(enrolment.tbl_student.is_leaderboard) === 1
                            ? true
                            : false}
                        />
                      </div>
                    </div>

                  </div>


                </div>
              </div>

              {CountTotalActivity(enrolment)}

              {parseInt(customActiveTab) === 1 ? (
                  (sessionData.session &&
                    sessionData.session.ses_is_completed === 1) ||
                  (!([0, 1, 6, null].includes(enrolment.tbl_student?.tbl_session_attendance?.attendance_status))) ?
                    (
                      enrolment?.tbl_student?.tbl_session_attendance?.is_flexi == 1 && sessionData?.session?.ses_date
                      && (moment(sessionData.session.ses_date).tz(localStorage.getItem("timezone") || "Europe/London").add((parseInt(localStorage.getItem("flexiDays")) + 1), 'days')
                        >=
                        moment().tz(localStorage.getItem("timezone") || "Europe/London") ) && enrolment?.tbl_student?.tbl_session_attendance?.attendance_status != '' && enrolment?.tbl_student?.tbl_session_attendance?.attendance_status != 6 ?
                        enrolment?.tbl_student?.Lesson?.LessonActivities?.length > 0 ?
                          <Link
                            to={
                              "/edit-lesson-plan/" +
                              enrolment.tbl_student.Lesson.pk_lesson_key
                            }
                            className="btn btn-secondary w-100 btn-md"
                            onClick={() =>
                              handleLinkClick(
                                enrolment.tbl_student.pk_student_key,
                                sessionData.session.pk_ses_key,
                                getUniqueStudentSubjectID(
                                  enrolment.tbl_enrolment_subject
                                ).join(",") || ""
                              )
                            }
                          >
                            Edit Lesson Plan
                          </Link>
                          :
                          <Link
                            to="/edit-lesson-plan"
                            className="btn btn-secondary w-100 btn-md"
                            onClick={() =>
                              handleLinkClick(
                                enrolment.tbl_student.pk_student_key,
                                sessionData.session.pk_ses_key,
                                getUniqueStudentSubjectID(
                                  enrolment.tbl_enrolment_subject
                                ).join(",") || ""
                              )
                            }
                          >
                            Create Lesson Plan
                          </Link>

                        : null
                    )
                    : (null)
                ):
                parseInt(customActiveTab) === 2 ? (
                  (sessionData.session &&
                    sessionData.session.ses_is_completed === 1) ||
                  (!([0, 1, 6, null].includes(enrolment.tbl_student?.tbl_session_attendance?.attendance_status))) ?
                    (
                      enrolment?.tbl_student?.tbl_session_attendance?.is_flexi == 1 && sessionData?.session?.ses_date
                      && (moment(sessionData.session.ses_date).tz(localStorage.getItem("timezone") || "Europe/London").add((parseInt(localStorage.getItem("flexiDays")) + 1), 'days')
                        >=
                        moment().tz(localStorage.getItem("timezone") || "Europe/London") )?
                        enrolment?.tbl_student?.Lesson?.LessonActivities?.length > 0 ?
                          <Link
                            to={
                              "/edit-lesson-plan/" +
                              enrolment.tbl_student.Lesson.pk_lesson_key
                            }
                            className="btn btn-secondary w-100 btn-md"
                            onClick={() =>
                              handleLinkClick(
                                enrolment.tbl_student.pk_student_key,
                                sessionData.session.pk_ses_key,
                                getUniqueStudentSubjectID(
                                  enrolment.tbl_enrolment_subject
                                ).join(",") || ""
                              )
                            }
                          >
                            Edit Homework Plan
                          </Link>
                          :
                          <Link
                            to="/edit-lesson-plan"
                            className="btn btn-secondary w-100 btn-md"
                            onClick={() =>
                              handleLinkClick(
                                enrolment.tbl_student.pk_student_key,
                                sessionData.session.pk_ses_key,
                                getUniqueStudentSubjectID(
                                  enrolment.tbl_enrolment_subject
                                ).join(",") || ""
                              )
                            }
                          >
                            Create Homework Plan
                          </Link>

                        : null
                    )
                    : (null)
                ): null}

              {parseInt(customActiveTab) === 1 ? (
                  (sessionData.session &&
                    sessionData.session.ses_is_completed === 1) ||
                  (!([0, 1, null].includes(enrolment.tbl_student?.tbl_session_attendance?.attendance_status))) ? (
                      // Inside if condition
                      enrolment.tbl_student &&
                      enrolment.tbl_student.next_session_key !== null &&
                      enrolment.tbl_student.next_session_key !== "" ?
                        ([3, 4, 5, 6].includes(enrolment.tbl_student?.tbl_session_attendance?.attendance_status) ? (

                            <Link
                              to={
                                "/session/" + enrolment.tbl_student.next_session_key
                              }
                              className="btn btn-secondary w-100 btn-md"
                              onClick={() => {
                                clearTimeout(timeoutID)
                                setLoopRun(isLoopRun + 1)
                              }}
                            >
                              Plan Next Session
                            </Link>
                          ) : (
                            // For other attendance statuses
                            <Link
                              to={
                                "/session/" + enrolment.tbl_student.next_session_key
                              }
                              className="btn btn-secondary w-100 btn-md"
                              onClick={() => {
                                clearTimeout(timeoutID)
                                setLoopRun(isLoopRun + 1)
                              }}
                            >
                              Plan Next Session
                            </Link>
                          )
                        ) : (
                          // If next session data is missing
                          <Link className="btn btn-secondary w-100 btn-md">
                            No Next Session
                          </Link>
                        )
                    ) : // If outer if condition fails
                    enrolment.tbl_student?.Lesson?.pk_lesson_key &&
                    enrolment.tbl_student.Lesson.LessonActivities?.length > 0 ? (
                      // If lesson plan exists
                      <Link
                        to={
                          "/edit-lesson-plan/" +
                          enrolment.tbl_student.Lesson.pk_lesson_key
                        }
                        className="btn btn-secondary w-100 btn-md"
                        onClick={() =>
                          handleLinkClick(
                            enrolment.tbl_student.pk_student_key,
                            sessionData.session.pk_ses_key,
                            getUniqueStudentSubjectID(
                              enrolment.tbl_enrolment_subject
                            ).join(",") || ""
                          )
                        }
                      >
                        Edit Lesson Plan
                      </Link>
                    ) : (
                      // If no lesson plan exists
                      <Link
                        to="/edit-lesson-plan"
                        className="btn btn-secondary w-100 btn-md"
                        onClick={() =>
                          handleLinkClick(
                            enrolment.tbl_student.pk_student_key,
                            sessionData.session.pk_ses_key,
                            getUniqueStudentSubjectID(
                              enrolment.tbl_enrolment_subject
                            ).join(",") || ""
                          )
                        }
                      >
                        Create Lesson Plan
                      </Link>
                    )
                ) : // For other tabs
                parseInt(customActiveTab) === 2 ? (
                  sessionData.session?.ses_is_completed === 1 ||
                  !([0, 1].includes(enrolment.tbl_student?.tbl_session_attendance?.attendance_status)) ? (
                      // Inside if condition
                      enrolment.tbl_student?.next_session_key ? (
                        [3, 4, 5, 6].includes(enrolment.tbl_student?.tbl_session_attendance?.attendance_status) ? (
                          <Link
                            to={
                              "/session/" + enrolment.tbl_student.next_session_key
                            }
                            className="btn btn-secondary w-100 btn-md"
                          >
                            Plan Next Session
                          </Link>
                        ) : (
                          // For other attendance statuses
                          <Link
                            to={
                              "/session/" + enrolment.tbl_student.next_session_key
                            }
                            className="btn btn-secondary w-100 btn-md"
                          >
                            Plan Next Session
                          </Link>
                        )
                      ) : (
                        // If next session data is missing
                        <Link className="btn btn-secondary w-100 btn-md">
                          No Next Session
                        </Link>
                      )
                    ) : // If outer if condition fails
                    // For other tabs
                    enrolment.tbl_student?.Lesson?.pk_lesson_key &&
                    enrolment.tbl_student.Lesson.LessonActivities?.length > 0 ? (
                      // If lesson activities exist
                      <Link
                        to={
                          "/edit-lesson-plan/" +
                          enrolment.tbl_student.Lesson.pk_lesson_key
                        }
                        className="btn btn-secondary w-100 btn-md"
                        onClick={() =>
                          handleLinkClick(
                            enrolment.tbl_student.pk_student_key,
                            sessionData.session.pk_ses_key,
                            getUniqueStudentSubjectID(
                              enrolment.tbl_enrolment_subject
                            ).join(",") || ""
                          )
                        }
                      >
                        Edit homework plan
                      </Link>
                    ) : (
                      // If no lesson activities exist
                      <Link
                        to="/edit-lesson-plan"
                        className="btn btn-secondary w-100 btn-md"
                        onClick={() =>
                          handleLinkClick(
                            enrolment.tbl_student.pk_student_key,
                            sessionData.session.pk_ses_key,
                            getUniqueStudentSubjectID(
                              enrolment.tbl_enrolment_subject
                            ).join(",") || ""
                          )
                        }
                      >
                        Create homework plan
                      </Link>
                    )
                ) : null}
              <div className="d-flex justify-content-end gap-3 me-3">
                {enrolment.tbl_student?.pk_student_key === activityStudentKey &&
                sessionData?.session?.ses_is_completed === 1 &&
                selectedActivityKeys?.length > 0 ? (
                  <button
                    className="btn bg-danger text-white me-0 font-size-12"
                    onClick={() => {
                      fetchMultipleUpcommingSessionData(
                        enrolment.fk_stu_key,
                        enrolment.tbl_enrolment_subject
                      )
                    }}
                  >
                    Roll over
                  </button>
                ) : null}
                {sessionData?.session?.ses_is_completed === 1 &&
                enrolment.tbl_student?.Lesson?.LessonActivities?.length > 0 &&
                (!enrolment.tbl_student?.tbl_session_attendance ||
                  parseInt(enrolment.tbl_student.tbl_session_attendance?.attendance_status) !== 6) &&
                (enrolment.tbl_student?.pk_student_key === activityStudentKey || activityStudentKey === "") ? (
                  <input
                    type="checkbox"
                    checked={selectAllChecked}
                    onChange={() =>
                      handleSelectAllChange(
                        enrolment.tbl_student.Lesson.LessonActivities
                      )
                    }
                  />
                ) : null}
              </div>
              <div className="events border-top">
                {enrolment.tbl_student?.Lesson?.LessonActivities?.length > 0 &&
                (!enrolment.tbl_student?.tbl_session_attendance ||
                  parseInt(enrolment.tbl_student.tbl_session_attendance?.attendance_status) !== 6)
                  ? enrolment.tbl_student.Lesson.LessonActivities.map(
                    (activity, index1) => {
                      if (
                        (activity.activity_type === 0 || activity.activity_type === 8) &&
                        activity.fk_sub_id === 2
                      ) {
                        return (
                          <>
                            <MathOnlineActivityCard
                              activity={activity} sessionData={sessionData} studentKey={activityStudentKey}
                              index={index1}

                              checkbox={{
                                checkable: sessionData?.session.ses_is_completed===1,
                                checked: selectedActivityKeys.includes(activity.pk_lesson_activity_key),
                                onCheckedChanged: () =>
                                  handleCheckboxActivityChange(
                                  activity.pk_lesson_activity_key,
                                  activity,
                                  enrolment.tbl_student.Lesson.LessonActivities.length
                                  )
                              }}

                              moveActivity={{
                                enabled: true,
                                onActivate: ()=>onMoveActivityPopup(activity)
                              }}
                              copyToHomework={{
                                enabled: sessionData?.session?.ses_is_completed === 1,
                                onActivate: ()=>onMoveHomeworkActivityPopup(activity)
                              }}
                              previewActivity={{
                                enabled: true,
                                onActivate: ()=>onPreviewActivity(activity)
                              }}
                              deleteActivity={{
                                enabled: true,
                                onActivate: ()=>onDelectActivityPopup(activity.pk_lesson_activity_key)
                              }}
                            />
                          </>
                        )
                      } else if (
                        (activity.activity_type === 0 || activity.activity_type === 8) &&
                        activity.fk_sub_id === 1
                      ) {
                        return (
                          <>
                            <EnglishOnlineActivityCard
                              activity={activity} sessionData={sessionData} index={index1}

                              checkbox={{
                                checkable: sessionData?.session.ses_is_completed===1,
                                checked: selectedActivityKeys.includes(activity.pk_lesson_activity_key),
                                onCheckedChanged: () => handleCheckboxActivityChange(
                                    activity.pk_lesson_activity_key,
                                    activity,
                                    enrolment.tbl_student.Lesson.LessonActivities.length
                                  )
                              }}

                              moveActivity={{
                                enabled: true,
                                onActivate: ()=>onMoveActivityPopup(activity)
                              }}
                              copyToHomework={{
                                enabled: sessionData?.session?.ses_is_completed === 1,
                                onActivate: ()=>onMoveHomeworkActivityPopup(activity)
                              }}
                              previewActivity={{
                                enabled: true,
                                onActivate: ()=>onPreviewActivity(activity)
                              }}
                              deleteActivity={{
                                enabled: true,
                                onActivate: ()=>onDelectActivityPopup(activity.pk_lesson_activity_key)
                              }}
                              manualMarkActivity={{
                                enabled: true,
                                onActivate: ()=>onManualMarkingActivity(activity)
                              }}
                            />
                          </>
                        )
                      } else if (
                        activity.activity_type === 1
                      ) {
                        return (
                          <>
                            <LessonPlanGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1} enrolment={enrolment}>
                            </LessonPlanGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 2 &&
                        activity.fk_sub_id === 1
                      ) {
                        let total_coins = 0
                        let total_time = 0

                        let total_question = 0
                        let count_answer = 0
                        if (
                          activity.LessonActivitiesQuestions?.length > 0
                        ) {

                          activity.LessonActivitiesQuestions.forEach(
                            (activityQuestion) => {
                              if (
                                activityQuestion.english_question?.length > 0
                              ) {
                                activityQuestion.english_question.forEach(
                                  (question) => {
                                    total_question += 1
                                    total_coins += 2
                                    if (
                                      question.StudentAnsAttempts?.length > 0
                                    ) {
                                      question.StudentAnsAttempts.forEach(
                                        stuAnswer => {
                                          total_time += parseInt(
                                            stuAnswer.submitted_on
                                          )
                                        }
                                      )
                                      count_answer += 1 // Increment count_answer by 1 for each occurrence
                                    }
                                  }
                                )
                              }
                            }
                          )
                        }

                        return (
                          <div className={`${(() => {
                            if (
                              sessionData?.session?.ses_is_completed === 1
                            ) {
                              if (activity.status == "1" && activity.mastryScore) {
                                const score = parseInt(activity.mastryScore, 10);
                                if (score > 75) return "activity-card-success";
                                if (score < 75) return "activity-card-blue";
                              }else if(activity.status == "1"){
                                return "activity-card-blue";
                              }
                              return "activity-card-danger";
                            }
                            return "";
                          })()} set1 bg-supermild`}>
                            <div className="d-flex justify-content-between">
                              <div>
                                    <span className="cs-txt-danger font-size-10 me-2">
                                        {
                                          activity?.roll_date ? 'Rolled over from'+ moment(activity.roll_date,moment.ISO_8601).format("DD/MMM/YYYY")
                                            : null}
                                    </span>
                                <span
                                  className={`${
                                    activity.status == "0"
                                      ? "cs-txt-danger"
                                      : activity.status == "1"
                                        ? "text-success"
                                        : ""
                                  } font-size-10 me-2`}
                                >
                                      {activity.status == "0"
                                        ? "Incomplete"
                                        : activity.status == "1"
                                          ? "Completed"
                                          : null}
                                    </span>
                                <span className={`${
                                  activity.status == "0"
                                    ? "cs-txt-danger"
                                    : activity.status == "1"
                                      ? "text-success"
                                      : ""
                                } font-size-10 me-2`}>
                                      {count_answer != null &&
                                      total_question != null
                                        ? count_answer +
                                        "/" +
                                        total_question +
                                        " attempted"
                                        : null}
                                    </span>
                                <span className="cs-txt-danger font-size-10 me-2">
                                      {sessionData?.session?.ses_is_completed === 1 ? activity.mastryScore
                                          ? `Score: ${activity.mastryScore}` : `Score: 0`
                                        : null}
                                    </span>
                                {["top"].map(placement => (
                                  <OverlayTrigger
                                    key={placement}
                                    placement={placement}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${placement}`}
                                        className="custom-tooltip"
                                      >
                                        Comment:{" "}
                                        {activity?.tutor_comments ||
                                          "No comments available"}
                                      </Tooltip>
                                    }
                                  >
                                                <span
                                                  variant="secondary"
                                                  className="no-bdr"
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <i className="fas fa-info-circle"></i>
                                                </span>
                                  </OverlayTrigger>
                                ))}
                              </div>
                              <div>
                                {sessionData?.session &&
                                parseInt(sessionData.session.ses_is_completed) === 1 &&
                                (activityStudentKey === "" ||
                                  activity.fk_student_key === activityStudentKey) ? (
                                  <input
                                    type="checkbox"
                                    checked={selectedActivityKeys.includes(
                                      activity.pk_lesson_activity_key
                                    )}
                                    onChange={() =>
                                      handleCheckboxActivityChange(
                                        activity.pk_lesson_activity_key,
                                        activity,
                                        enrolment.tbl_student.Lesson
                                          .LessonActivities.length
                                      )
                                    }
                                  />
                                ) : null}
                              </div>
                            </div>
                            <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
                              {(index1 + 1) + ") "}
                              {activity.level_name && activity.level_name!='' ? activity.level_name+' - ' : null}
                              {activity.topics && activity.topics.length > 0
                                ? getUniqueTopicsNames(activity.topics)
                                : null}
                            </h6>

                            <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                    <span>
                                      {" "}
                                      <img
                                        className="me-10"
                                        width={24}
                                        src={reel}
                                        alt=""
                                      />
                                    </span>
                                Diagnostics
                              </div>
                              <Dropdown
                                isOpen={
                                  dropdownOpen[
                                    activity.pk_lesson_activity_key
                                    ]
                                }
                                toggle={() =>
                                  toggleDropdown(
                                    activity.pk_lesson_activity_key
                                  )
                                }
                              >
                                <DropdownToggle className="p-0 bg-transparent mb-0">
                                  <i className="mdi mdi-dots-horizontal text-dark"></i>{" "}
                                </DropdownToggle>
                                <DropdownMenu className="custom-position">
                                  {sessionData?.session?.ses_is_completed === 1 ? (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          onMoveActivityPopup(activity)
                                        }
                                      >
                                            <span>
                                              <i className="mdi mdi-arrow-right-bold-circle-outline font-size-15 me-1"></i>
                                            </span>{" "}
                                        Roll over to next session
                                      </DropdownItem>{" "}
                                    </>
                                  ) : null}
                                  {sessionData?.session?.ses_is_completed === 1 &&
                                  parseInt(activity.marked_for_homework) === 0 ? (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          onMoveHomeworkActivityPopup(
                                            activity
                                          )
                                        }
                                      >
                                            <span>
                                              <i className="mdi mdi-arrow-right-bold-circle-outline font-size-15 me-1"></i>
                                            </span>{" "}
                                        Copy to homework
                                      </DropdownItem>{" "}
                                    </>
                                  ) : null}
                                  <DropdownItem
                                    onClick={() =>
                                      onPreviewActivity(activity)
                                    }
                                  >
                                        <span>
                                          <i className="mdi mdi-eye-outline font-size-15 me-1"></i>
                                        </span>{" "}
                                    Preview
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() =>
                                      onDelectActivityPopup(
                                        activity.pk_lesson_activity_key
                                      )
                                    }
                                  >
                                        <span>
                                          <i className="far fa-trash-alt font-size-15 me-1"></i>
                                        </span>{" "}
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>

                            <div className="d-flex justify-content-between">
                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                              </div>

                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                {" "}
                                <img
                                  className="me-10"
                                  width={24}
                                  src={awicon}
                                  alt=""
                                />
                                {activity.coins_earned
                                  ? activity.coins_earned
                                  : 0}
                                /{total_coins}{" "}
                              </div>
                            </div>

                            <div className="question-count mt-2">
                              <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
                                {activity.LessonActivitiesQuestions?.length > 0
                                  ? activity.LessonActivitiesQuestions.map(
                                    (activityQuestion, index2) => {
                                      let color = ""

                                      if (
                                        activityQuestion.english_question?.length > 0
                                      ) {
                                        activityQuestion.english_question.forEach(
                                          (question) => {
                                            if (
                                              question.StudentAnsAttempts.length > 0
                                            ) {
                                              question.StudentAnsAttempts.forEach(
                                                (
                                                  answerattquestion,
                                                ) => {
                                                  color +=
                                                    answerattquestion.points_obtained
                                                }
                                              )
                                            }
                                          }
                                        )
                                      }

                                      const colorInt = parseInt(color)

                                      return (
                                        <li
                                          key={index2}
                                          className={`${
                                            colorInt === 1
                                              ? "attempt2 text-warning bg-success-subtle"
                                              : colorInt === 2
                                                ? "attempt1 custom-success bg-success-subtle"
                                                : colorInt === 0
                                                  ? "attempt3 cs-txt-danger bg-danger-subtle"
                                                  : ""
                                          }`}
                                        >
                                          {colorInt === 1 ? (
                                            <i className="fas fa-check"></i>
                                          ) : colorInt === 2 ? (
                                            <i className="fas fa-check"></i>
                                          ) : colorInt === 0 ? (
                                            <i className="mdi mdi-window-close"></i>
                                          ) : (
                                            index2 + 1
                                          )}
                                        </li>
                                      )
                                    }
                                  )
                                  : null}
                              </ul>
                            </div>
                          </div>
                        )
                      } else if (
                        activity.activity_type === 2 &&
                        activity.fk_sub_id === 2
                      ) {

                        let total_coins = 0
                        let total_time = 0

                        let total_question = 0
                        let count_answer = 0

                        if (
                          activity?.LessonActivitiesQuestions?.length > 0
                        ) {

                          activity.LessonActivitiesQuestions.forEach(
                            (activityQuestion) => {
                              if (
                                activityQuestion.question?.length > 0
                              ) {
                                activityQuestion.question.forEach(
                                  (question) => {
                                    total_question += 1
                                    total_coins += 2
                                    if (
                                      question.StudentAnsAttempts?.length > 0
                                    ) {
                                      question.StudentAnsAttempts.forEach(
                                        stuAnswer => {
                                          total_time += parseInt(
                                            stuAnswer.submitted_on
                                          )
                                        }
                                      )
                                      count_answer += 1 // Increment count_answer by 1 for each occurrence
                                    }
                                  }
                                )
                              }
                            }
                          )
                        }
                        return (
                          <div className={`${(() => {
                            if (
                              sessionData?.session?.ses_is_completed === 1
                            ) {
                              if (activity.status == "1" && activity.mastryScore) {
                                const score = parseInt(activity.mastryScore, 10);
                                if (score > 75) return "activity-card-success";
                                if (score < 75) return "activity-card-blue";
                              }else if(activity.status == "1"){
                                return "activity-card-blue";
                              }
                              return "activity-card-danger";
                            }
                            return "";
                          })()} set1 bg-supermild`}>
                            <div className="d-flex justify-content-between">
                              <div>
                                    <span className="cs-txt-danger font-size-10 me-2">
                                        {activity &&
                                        activity.roll_date ? 'Rolled over from'+ moment(activity.roll_date,moment.ISO_8601).format("DD/MMM/YYYY")
                                          : null}
                                    </span>
                                <span
                                  className={`${
                                    activity.status == "0"
                                      ? "cs-txt-danger"
                                      : activity.status == "1"
                                        ? "text-success"
                                        : ""
                                  } font-size-10 me-2`}
                                >
                                      {activity.status == "0"
                                        ? "Incomplete"
                                        : activity.status == "1"
                                          ? "Completed"
                                          : null}
                                    </span>
                                <span className={`${
                                  activity.status == "0"
                                    ? "cs-txt-danger"
                                    : activity.status == "1"
                                      ? "text-success"
                                      : ""
                                } font-size-10 me-2`}>
                                      {count_answer != null &&
                                      total_question != null
                                        ? count_answer +
                                        "/" +
                                        total_question +
                                        " attempted"
                                        : null}
                                    </span>
                                <span className="cs-txt-danger font-size-10 me-2">
                                      {sessionData?.session?.ses_is_completed === 1 ? activity.mastryScore
                                          ? `Score: ${activity.mastryScore}` : `Score: 0`
                                        : null}
                                    </span>
                                {["top"].map(placement => (
                                  <OverlayTrigger
                                    key={placement}
                                    placement={placement}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${placement}`}
                                        className="custom-tooltip"
                                      >
                                        Comment:{" "}
                                        {activity?.tutor_comments ||
                                          "No comments available"}
                                      </Tooltip>
                                    }
                                  >
                                                <span
                                                  variant="secondary"
                                                  className="no-bdr"
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <i className="fas fa-info-circle"></i>
                                                </span>
                                  </OverlayTrigger>
                                ))}
                              </div>
                              <div>
                                {sessionData?.session &&
                                parseInt(sessionData.session.ses_is_completed) === 1 &&
                                (activityStudentKey === "" || activity.fk_student_key === activityStudentKey) ? (
                                  <input
                                    type="checkbox"
                                    checked={selectedActivityKeys.includes(
                                      activity.pk_lesson_activity_key
                                    )}
                                    onChange={() =>
                                      handleCheckboxActivityChange(
                                        activity.pk_lesson_activity_key,
                                        activity,
                                        enrolment.tbl_student.Lesson
                                          .LessonActivities.length
                                      )
                                    }
                                  />
                                ) : null}
                              </div>
                            </div>
                            <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
                              {(index1 + 1) + ") "}
                              {activity.level_name && activity.level_name!='' ? activity.level_name+' - ' : null}
                              {activity.topics && activity.topics.length > 0
                                ? getUniqueTopicsNames(activity.topics)
                                : null}
                            </h6>

                            <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                    <span>
                                      {" "}
                                      <img
                                        className="me-10"
                                        width={24}
                                        src={reel}
                                        alt=""
                                      />
                                    </span>
                                Diagnostics
                              </div>
                              <Dropdown
                                isOpen={
                                  dropdownOpen[
                                    activity.pk_lesson_activity_key
                                    ]
                                }
                                toggle={() =>
                                  toggleDropdown(
                                    activity.pk_lesson_activity_key
                                  )
                                }
                              >
                                <DropdownToggle className="p-0 bg-transparent mb-0">
                                  <i className="mdi mdi-dots-horizontal text-dark"></i>{" "}
                                </DropdownToggle>
                                <DropdownMenu className="custom-position">
                                  {sessionData?.session?.ses_is_completed === 1 ? (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          onMoveActivityPopup(activity)
                                        }
                                      >
                                            <span>
                                              <i className="mdi mdi-arrow-right-bold-circle-outline font-size-15 me-1"></i>
                                            </span>{" "}
                                        Roll over to next session
                                      </DropdownItem>{" "}
                                    </>
                                  ) : null}
                                  {sessionData?.session?.ses_is_completed === 1 &&
                                  parseInt(activity.marked_for_homework) === 0 ? (
                                    <>
                                      <DropdownItem
                                        onClick={() =>
                                          onMoveHomeworkActivityPopup(
                                            activity
                                          )
                                        }
                                      >
                                            <span>
                                              <i className="mdi mdi-arrow-right-bold-circle-outline font-size-15 me-1"></i>
                                            </span>{" "}
                                        Copy to homework
                                      </DropdownItem>{" "}
                                    </>
                                  ) : null}
                                  <DropdownItem
                                    onClick={() =>
                                      onPreviewActivity(activity)
                                    }
                                  >
                                        <span>
                                          <i className="mdi mdi-eye-outline font-size-15 me-1"></i>
                                        </span>{" "}
                                    Preview
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() =>
                                      onDelectActivityPopup(
                                        activity.pk_lesson_activity_key
                                      )
                                    }
                                  >
                                        <span>
                                          <i className="far fa-trash-alt font-size-15 me-1"></i>
                                        </span>{" "}
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>

                            <div className="d-flex justify-content-between">
                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                              </div>

                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                {" "}
                                <img
                                  className="me-10"
                                  width={24}
                                  src={awicon}
                                  alt=""
                                />
                                {activity.coins_earned
                                  ? activity.coins_earned
                                  : 0}
                                /{total_coins}{" "}
                              </div>
                            </div>

                            <div className="question-count mt-2">
                              <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
                                {activity.LessonActivitiesQuestions?.length > 0
                                  ? activity.LessonActivitiesQuestions.map(
                                    (activityQuestion, index2) => {
                                      let color = ""

                                      if (
                                        activityQuestion.question?.length > 0
                                      ) {
                                        activityQuestion.question.forEach(
                                          (question) => {
                                            if (
                                              question.StudentAnsAttempts.length > 0
                                            ) {
                                              question.StudentAnsAttempts.forEach(
                                                (
                                                  answerattquestion,
                                                ) => {
                                                  color +=
                                                    answerattquestion.points_obtained
                                                }
                                              )
                                            }
                                          }
                                        )
                                      }

                                      const colorInt = parseInt(color)

                                      return (
                                        <li
                                          key={index2}
                                          className={`${
                                            colorInt === 1
                                              ? "attempt2 text-warning bg-success-subtle"
                                              : colorInt === 2
                                                ? "attempt1 custom-success bg-success-subtle"
                                                : colorInt === 0
                                                  ? "attempt3 cs-txt-danger bg-danger-subtle"
                                                  : ""
                                          }`}
                                        >
                                          {colorInt === 1 ? (
                                            <i className="fas fa-check"></i>
                                          ) : colorInt === 2 ? (
                                            <i className="fas fa-check"></i>
                                          ) : colorInt === 0 ? (
                                            <i className="mdi mdi-window-close"></i>
                                          ) : (
                                            index2 + 1
                                          )}
                                        </li>
                                      )
                                    }
                                  )
                                  : null}
                              </ul>
                            </div>
                          </div>
                        )
                      } else if (
                        activity.activity_type === 3 || activity.activity_type === 10
                      ) {
                        return (
                          <>
                            <LessonPlanGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1} enrolment={enrolment}>
                            </LessonPlanGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 4
                      ) {
                        return (
                          <>
                            <LessonPlanGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1} enrolment={enrolment}>
                            </LessonPlanGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 5
                      ) {
                        return (
                          <>
                            <LessonPlanGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1} enrolment={enrolment}>
                            </LessonPlanGeneralActivityCard>
                          </>

                        )
                      } else if (
                        activity.activity_type === 6 &&
                        (activity.fk_sub_id === 1 ||
                          activity.fk_sub_id === 2)
                      ) {
                        return (
                          <>
                            <LessonPlanGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1} enrolment={enrolment}>
                            </LessonPlanGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 7 &&
                        (activity.fk_sub_id === 1 ||
                          activity.fk_sub_id === 2)
                      ) {
                        return (
                          <>
                            <LessonPlanGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1} enrolment={enrolment}>
                            </LessonPlanGeneralActivityCard>
                          </>
                        )
                      }
                      else if (activity.activity_type === ActivityType.PLATFORM_GAMES){
                        return (
                          <GameCard activity={activity}
                                    options={{
                                      showStatus: true, showContextMenu: true, index: index1,
                                      showRollOverToNextSession: (isSessionCompleted(sessionData?.session)), onRollOverToNextSession: ()=>{ onMoveActivityPopup(activity)},
                                      showRollOverFrom: true, showHighlight: (isSessionCompleted(sessionData?.session))
                                    }}
                                    checkbox={{
                                     checkable: (isSessionCompleted(sessionData?.session)),
                                     checked: selectedActivityKeys.includes(activity.pk_lesson_activity_key),
                                     onCheckedChanged: () => handleCheckboxActivityChange(
                                       activity.pk_lesson_activity_key,
                                       activity,
                                       enrolment.tbl_student.Lesson.LessonActivities.length
                                     )
                                   }}
                        >
                        </GameCard>
                        )
                      }
                      else if (activity.activity_type===ActivityType.LLL){
                        return (
                          <>
                            <LllActivityCard activity={activity}
                                             studentKey={activityStudentKey}
                                             options={{
                                               showStatus: true, showContextMenu: (isSessionCompleted(sessionData?.session)), index: index1,
                                               showRollOverToNextSession: (isSessionCompleted(sessionData?.session)), onRollOverToNextSession: ()=>{ onMoveActivityPopup(activity)},
                                               showRollOverFrom: true, showHighlight: (isSessionCompleted(sessionData?.session))
                                             }}
                                             checkbox={{
                                               checkable: (sessionData && isSessionCompleted(sessionData.session)),
                                               checked: selectedActivityKeys.includes(activity.pk_lesson_activity_key),
                                               onCheckedChanged: () => handleCheckboxActivityChange(
                                                 activity.pk_lesson_activity_key,
                                                 activity,
                                                 enrolment.tbl_student.Lesson.LessonActivities.length
                                               )
                                             }}
                            >
                          </LllActivityCard>
                          </>
                        )
                      }
                      else if ( activity.activity_type === ActivityType.ONETIME) {
                        return (
                          <>
                            <LessonPlanGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1} enrolment={enrolment}>
                            </LessonPlanGeneralActivityCard>
                          </>
                        )
                      }
                      else if (activity.activity_type === ActivityType.SKILLBUILDER) {
                        // Without this the chain hits `return null` below and
                        // the Skill Builder is invisible during the session,
                        // even though the tutor assigned it.
                        return (
                          <SkillbuilderActivityCard
                            activity={activity}
                            index={index1}
                            showContextMenu={true}
                            onRollOver={() => onMoveActivityPopup(activity)}
                            rollOverEnabled={isSessionCompleted(sessionData?.session)}
                            checkbox={{
                              checkable: isSessionCompleted(sessionData?.session),
                              checked: selectedActivityKeys.includes(activity.pk_lesson_activity_key),
                              onCheckedChanged: () =>
                                handleCheckboxActivityChange(
                                  activity.pk_lesson_activity_key,
                                  activity,
                                  enrolment.tbl_student.Lesson.LessonActivities.length
                                ),
                            }}
                          />
                        )
                      }
                      else if (
                        activity.activity_type === ActivityType.DIAGNOSTICS_FLOW ||
                        activity.activity_type === ActivityType.ENGLISH_DIAGNOSTICS
                      ) {
                        return (
                          <BmdActivityCard
                            activity={activity}
                            index={index1}
                            showContextMenu={true}
                            onRollOver={() => onMoveActivityPopup(activity)}
                            rollOverEnabled={isSessionCompleted(sessionData?.session)}
                            checkbox={{
                              checkable: isSessionCompleted(sessionData?.session),
                              checked: selectedActivityKeys.includes(activity.pk_lesson_activity_key),
                              onCheckedChanged: () =>
                                handleCheckboxActivityChange(
                                  activity.pk_lesson_activity_key,
                                  activity,
                                  enrolment.tbl_student.Lesson.LessonActivities.length
                                ),
                            }}
                          />
                        )
                      }
                      else {
                        return null
                      }
                    }
                  )
                  : null}
              </div>
            </div>
          )
        }
      )
      : null
  }

  // Memoize LessonPlanContent to prevent unnecessary re-renders
  const MemoizedLessonPlanContent = useMemo(() => LassonPlanContent, [])

  const PreviousHomeWorkSessionContent = ({
                                            sessionData,
                                            indexKey,
                                            CountTotalCoins,
                                            CountTotalActivity,
                                            toggleDropdown,
                                            dropdownOpen,
                                            onPreviewActivity,
                                            onDelectActivityPopup,
                                            getUniqueTopicsNames,
                                          }) => {


    /**
     * @param {SessionActivity} activity
     * @param sessionData
     * @param {number} index
     * @return {React.JSX.Element}
     */
    const PreviousHomeworkGeneralActivityCard = ({activity, sessionData, index}) => {

      return (<>
        <GeneralActivityCard
          activity={activity} sessionData={sessionData} index={index}

          manualMarkActivity={{
            enabled: true,
            onActivate: () => onManualMarkingActivity(activity)
          }}

          previewActivity={{
            enabled: true,
            onActivate: () => onPreviewActivity(activity)
          }}

          deleteActivity={{
            enabled: true,
            onActivate: () => onDelectActivityPopup(activity.pk_lesson_activity_key)
          }}
        >
        </GeneralActivityCard>
      </>)
    }



    return sessionData?.session?.tbl_session_time?.tbl_student_enrolment
      ? sessionData.session.tbl_session_time.tbl_student_enrolment.map(
        (enrolment, index) => {
          if (index == indexKey) {
          } else {
            return null
          }

          return (
            <div className="lesson-plan-wrapper bg-white p-2 pt-0">
              <div className="section-divider">
                <div className="border-bottom pb-2 mb-2">
                  <h6 className="mb-0 text-dark">Homework plan</h6>
                  <div>
                    {enrolment.tbl_student.Lesson?.homework_description
                      ? enrolment.tbl_student.Lesson.homework_description
                      : null}
                  </div>
                </div>

                <div className="d-flex justify-content-between list-unstyled mb-0">
                  <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                    {" "}
                    <img className="me-10" width={24} src={awicon} alt="" />
                    {CountTotalCoins(enrolment) || "-"}
                  </div>
                  <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                  </div>
                </div>
                {CountTotalActivity(enrolment)}
              </div>

              <div
                className="events rm-heignt border-bottom1 pb-1 mb-1 mt-0"
                style={{ minHeight: "100px" }}
              >
                {enrolment.tbl_student?.Lesson?.LessonActivities?.length > 0 &&
                (!enrolment.tbl_student?.tbl_session_attendance ||
                  (enrolment.tbl_student.tbl_session_attendance.attendance_status != null &&
                    parseInt(enrolment.tbl_student.tbl_session_attendance.attendance_status) !== 6))
                  ? enrolment.tbl_student.Lesson.LessonActivities.map(
                    (activity, index1) => {
                      // console.log(activity)
                      if (
                        (activity.activity_type === 0 || activity.activity_type === 8) &&
                        activity.fk_sub_id === 2
                      ) {

                        return (
                          <>
                            <MathOnlineActivityCard
                              activity={activity} sessionData={sessionData}
                              index={index1}
                              previewActivity={{
                                enabled: true,
                                onActivate: ()=>onPreviewActivity(activity)
                              }}
                              deleteActivity={{
                                enabled: true,
                                onActivate: ()=>onDelectActivityPopup(activity.pk_lesson_activity_key)
                              }}
                            />
                          </>
                        )
                      } else if (
                        (activity.activity_type === 0 || activity.activity_type === 8) &&
                        activity.fk_sub_id === 1
                      ) {
                        return (
                          <>
                            <EnglishOnlineActivityCard
                              activity={activity} sessionData={sessionData} index={index1}
                              previewActivity={{
                                enabled: true,
                                onActivate: ()=>onPreviewActivity(activity)
                              }}
                              deleteActivity={{
                                enabled: true,
                                onActivate: ()=>onDelectActivityPopup(activity.pk_lesson_activity_key)
                              }}
                              manualMarkActivity={{
                                enabled: true,
                                onActivate: ()=>onManualMarkingActivity(activity)
                              }}
                            />
                          </>
                        )
                      } else if (
                        activity.activity_type === 1
                      ) {
                        return (
                          <>
                            <PreviousHomeworkGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1}
                            ></PreviousHomeworkGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 2 &&
                        activity.fk_sub_id === 1
                      ) {
                        let total_coins = 0
                        let total_time = 0

                        let total_question = 0
                        let count_answer = 0
                        if (
                          activity.LessonActivitiesQuestions?.length > 0
                        ) {

                          activity.LessonActivitiesQuestions.forEach(
                            (activityQuestion) => {
                              if (
                                activityQuestion.english_question?.length > 0
                              ) {
                                activityQuestion.english_question.forEach(
                                  (question) => {
                                    total_question += 1
                                    total_coins += 2
                                    if (
                                      question.StudentAnsAttempts?.length > 0
                                    ) {
                                      question.StudentAnsAttempts.forEach(
                                        stuAnswer => {
                                          total_time += parseInt(
                                            stuAnswer.submitted_on
                                          )
                                        }
                                      )
                                      count_answer += 1 // Increment count_answer by 1 for each occurrence
                                    }
                                  }
                                )
                              }
                            }
                          )
                        }
                        return (
                          <div className={`${(() => {
                            if (
                              sessionData?.session?.ses_is_completed === 1
                            ) {
                              if (activity.status == "1" && activity.mastryScore) {
                                const score = parseInt(activity.mastryScore, 10);
                                if (score > 75) return "activity-card-success";
                                if (score < 75) return "activity-card-blue";
                              }else if(activity.status == "1"){
                                return "activity-card-blue";
                              }
                              return "activity-card-danger";
                            }
                            return "";
                          })()} set1 bg-supermild`}>
                                <span className="cs-txt-danger font-size-10 me-2">
                                    {
                                      activity?.roll_date ? 'Rolled over from'+ moment(activity.roll_date,moment.ISO_8601).format("DD/MMM/YYYY")
                                        : null}
                                </span>
                            <span
                              className={`${
                                activity.status == "0"
                                  ? "cs-txt-danger"
                                  : activity.status == "1"
                                    ? "text-success"
                                    : ""
                              } font-size-10 me-2`}
                            >
                                  {activity.status == "0"
                                    ? "Incomplete"
                                    : activity.status == "1"
                                      ? "Completed"
                                      : null}
                                </span>
                            <span className={`${
                              activity.status == "0"
                                ? "cs-txt-danger"
                                : activity.status == "1"
                                  ? "text-success"
                                  : ""
                            } font-size-10 me-2`}>
                                  {count_answer != null &&
                                  total_question != null
                                    ? count_answer +
                                    "/" +
                                    total_question +
                                    " attempted"
                                    : null}
                                </span>
                            <span className="cs-txt-danger font-size-10 me-2">
                                  {sessionData?.session?.ses_is_completed === 1 ? activity.mastryScore
                                      ? `Score: ${activity.mastryScore}` : `Score: 0`
                                    : null}
                                </span>
                            {["top"].map(placement => (
                              <OverlayTrigger
                                key={placement}
                                placement={placement}
                                overlay={
                                  <Tooltip
                                    id={`tooltip-${placement}`}
                                    className="custom-tooltip"
                                  >
                                    Comment:{" "}
                                    {activity?.tutor_comments ||
                                      "No comments available"}
                                  </Tooltip>
                                }
                              >
                                                <span
                                                  variant="secondary"
                                                  className="no-bdr"
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <i className="fas fa-info-circle"></i>
                                                </span>
                              </OverlayTrigger>
                            ))}
                            <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
                              {(index1 + 1) + ") "}
                              {activity.level_name && activity.level_name!='' ? activity.level_name+' - ' : null}
                              {activity.topics && activity.topics.length > 0
                                ? getUniqueTopicsNames(activity.topics)
                                : null}
                            </h6>

                            <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                    <span>
                                      {" "}
                                      <img
                                        className="me-10"
                                        width={24}
                                        src={reel}
                                        alt=""
                                      />
                                    </span>
                                Diagnostics
                              </div>
                              <Dropdown
                                isOpen={
                                  dropdownOpen[
                                    activity.pk_lesson_activity_key
                                    ]
                                }
                                toggle={() =>
                                  toggleDropdown(
                                    activity.pk_lesson_activity_key
                                  )
                                }
                              >
                                <DropdownToggle className="p-0 bg-transparent mb-0">
                                  <i className="mdi mdi-dots-horizontal text-dark"></i>{" "}
                                </DropdownToggle>
                                <DropdownMenu className="custom-position">
                                  <DropdownItem
                                    onClick={() =>
                                      onPreviewActivity(activity)
                                    }
                                  >
                                        <span>
                                          <i className="mdi mdi-eye-outline font-size-15 me-1"></i>
                                        </span>{" "}
                                    Preview
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() =>
                                      onDelectActivityPopup(
                                        activity.pk_lesson_activity_key
                                      )
                                    }
                                  >
                                        <span>
                                          <i className="far fa-trash-alt font-size-15 me-1"></i>
                                        </span>{" "}
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>

                            <div className="d-flex justify-content-between">
                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                              </div>

                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                {" "}
                                <img
                                  className="me-10"
                                  width={24}
                                  src={awicon}
                                  alt=""
                                />
                                {activity.coins_earned
                                  ? activity.coins_earned
                                  : 0}
                                /{total_coins}{" "}
                              </div>
                            </div>

                            <div className="question-count mt-2">
                              <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
                                {
                                  activity.LessonActivitiesQuestions?.length >
                                  0
                                    ? activity.LessonActivitiesQuestions.map(
                                      (activityQuestion, index2) => {
                                        let color = ""

                                        if (
                                          activityQuestion.english_question?.length > 0
                                        ) {
                                          activityQuestion.english_question.forEach(
                                            (question) => {
                                              if (
                                                question.StudentAnsAttempts.length > 0
                                              ) {
                                                question.StudentAnsAttempts.forEach(
                                                  (
                                                    answerattquestion,
                                                  ) => {
                                                    color +=
                                                      answerattquestion.points_obtained
                                                  }
                                                )
                                              }
                                            }
                                          )
                                        }

                                        const colorInt = parseInt(color)

                                        return (
                                          <li
                                            key={index2}
                                            className={`${
                                              colorInt === 1
                                                ? "attempt2 text-warning bg-success-subtle"
                                                : colorInt === 2
                                                  ? "attempt1 custom-success bg-success-subtle"
                                                  : colorInt === 0
                                                    ? "attempt3 cs-txt-danger bg-danger-subtle"
                                                    : ""
                                            }`}
                                          >
                                            {colorInt === 1 ? (
                                              <i className="fas fa-check"></i>
                                            ) : colorInt === 2 ? (
                                              <i className="fas fa-check"></i>
                                            ) : colorInt === 0 ? (
                                              <i className="mdi mdi-window-close"></i>
                                            ) : (
                                              index2 + 1
                                            )}
                                          </li>
                                        )
                                      }
                                    )
                                    : null}
                              </ul>
                            </div>
                          </div>
                        )
                      } else if (
                        activity.activity_type === 2 &&
                        activity.fk_sub_id === 2
                      ) {
                        let total_coins = 0
                        let total_time = 0

                        let total_question = 0
                        let count_answer = 0

                        if (
                          activity.LessonActivitiesQuestions?.length > 0
                        ) {

                          activity.LessonActivitiesQuestions.forEach(
                            (activityQuestion) => {
                              if (
                                activityQuestion.question?.length > 0
                              ) {
                                activityQuestion.question.forEach(
                                  (question) => {
                                    total_question += 1
                                    total_coins += 2
                                    if (
                                      question.StudentAnsAttempts?.length > 0
                                    ) {
                                      question.StudentAnsAttempts.forEach(
                                        stuAnswer => {
                                          total_time += parseInt(
                                            stuAnswer.submitted_on
                                          )
                                        }
                                      )
                                      count_answer += 1 // Increment count_answer by 1 for each occurrence
                                    }
                                  }
                                )
                              }
                            }
                          )
                        }
                        return (
                          <div className={`${(() => {
                            if (
                              sessionData?.session?.ses_is_completed === 1
                            ) {
                              if (activity.status == "1" && activity.mastryScore) {
                                const score = parseInt(activity.mastryScore, 10);
                                if (score > 75) return "activity-card-success";
                                if (score < 75) return "activity-card-blue";
                              }else if(activity.status == "1"){
                                return "activity-card-blue";
                              }
                              return "activity-card-danger";
                            }
                            return "";
                          })()} set1 bg-supermild`}>
                                <span className="cs-txt-danger font-size-10 me-2">
                                    {activity &&
                                    activity.roll_date ? 'Rolled over from'+ moment(activity.roll_date,moment.ISO_8601).format("DD/MMM/YYYY")
                                      : null}
                                </span>
                            <span
                              className={`${
                                activity.status == "0"
                                  ? "cs-txt-danger"
                                  : activity.status == "1"
                                    ? "text-success"
                                    : ""
                              } font-size-10 me-2`}
                            >
                                  {activity.status == "0"
                                    ? "Incomplete"
                                    : activity.status == "1"
                                      ? "Completed"
                                      : null}
                                </span>
                            <span className={`${
                              activity.status == "0"
                                ? "cs-txt-danger"
                                : activity.status == "1"
                                  ? "text-success"
                                  : ""
                            } font-size-10 me-2`}>
                                  {count_answer != null &&
                                  total_question != null
                                    ? count_answer +
                                    "/" +
                                    total_question +
                                    " attempted"
                                    : null}
                                </span>
                            <span className="cs-txt-danger font-size-10 me-2">
                                  {sessionData?.session?.ses_is_completed === 1 ? activity.mastryScore
                                      ? `Score: ${activity.mastryScore}` : `Score: 0`
                                    : null}
                                </span>
                            {["top"].map(placement => (
                              <OverlayTrigger
                                key={placement}
                                placement={placement}
                                overlay={
                                  <Tooltip
                                    id={`tooltip-${placement}`}
                                    className="custom-tooltip"
                                  >
                                    Comment:{" "}
                                    {activity?.tutor_comments ||
                                      "No comments available"}
                                  </Tooltip>
                                }
                              >
                                                <span
                                                  variant="secondary"
                                                  className="no-bdr"
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <i className="fas fa-info-circle"></i>
                                                </span>
                              </OverlayTrigger>
                            ))}
                            <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
                              {(index1 + 1) + ") "}
                              {activity.level_name && activity.level_name!='' ? activity.level_name+' - ' : null}
                              {activity.topics && activity.topics.length > 0
                                ? getUniqueTopicsNames(activity.topics)
                                : null}
                            </h6>

                            <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                    <span>
                                      {" "}
                                      <img
                                        className="me-10"
                                        width={24}
                                        src={reel}
                                        alt=""
                                      />
                                    </span>
                                Diagnostics
                              </div>
                              <Dropdown
                                isOpen={
                                  dropdownOpen[
                                    activity.pk_lesson_activity_key
                                    ]
                                }
                                toggle={() =>
                                  toggleDropdown(
                                    activity.pk_lesson_activity_key
                                  )
                                }
                              >
                                <DropdownToggle className="p-0 bg-transparent mb-0">
                                  <i className="mdi mdi-dots-horizontal text-dark"></i>{" "}
                                </DropdownToggle>
                                <DropdownMenu className="custom-position">
                                  <DropdownItem
                                    onClick={() =>
                                      onPreviewActivity(activity)
                                    }
                                  >
                                        <span>
                                          <i className="mdi mdi-eye-outline font-size-15 me-1"></i>
                                        </span>{" "}
                                    Preview
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() =>
                                      onDelectActivityPopup(
                                        activity.pk_lesson_activity_key
                                      )
                                    }
                                  >
                                        <span>
                                          <i className="far fa-trash-alt font-size-15 me-1"></i>
                                        </span>{" "}
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>

                            <div className="d-flex justify-content-between">
                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                              </div>

                              <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                {" "}
                                <img
                                  className="me-10"
                                  width={24}
                                  src={awicon}
                                  alt=""
                                />
                                {activity.coins_earned
                                  ? activity.coins_earned
                                  : 0}
                                /{total_coins}{" "}
                              </div>
                            </div>

                            <div className="question-count mt-2">
                              <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
                                {
                                  activity.LessonActivitiesQuestions?.length >
                                  0
                                    ? activity.LessonActivitiesQuestions.map(
                                      (activityQuestion, index2) => {
                                        let color = ""

                                        if (
                                          activityQuestion.question?.length > 0
                                        ) {
                                          activityQuestion.question.forEach(
                                            (question) => {
                                              if (
                                                question.StudentAnsAttempts?.length > 0
                                              ) {
                                                question.StudentAnsAttempts.forEach(
                                                  (
                                                    answerattquestion,
                                                  ) => {
                                                    color +=
                                                      answerattquestion.points_obtained
                                                  }
                                                )
                                              }
                                            }
                                          )
                                        }

                                        const colorInt = parseInt(color)

                                        return (
                                          <li
                                            key={index2}
                                            className={`${
                                              colorInt === 1
                                                ? "attempt2 text-warning bg-success-subtle"
                                                : colorInt === 2
                                                  ? "attempt1 custom-success bg-success-subtle"
                                                  : colorInt === 0
                                                    ? "attempt3 cs-txt-danger bg-danger-subtle"
                                                    : ""
                                            }`}
                                          >
                                            {colorInt === 1 ? (
                                              <i className="fas fa-check"></i>
                                            ) : colorInt === 2 ? (
                                              <i className="fas fa-check"></i>
                                            ) : colorInt === 0 ? (
                                              <i className="mdi mdi-window-close"></i>
                                            ) : (
                                              index2 + 1
                                            )}
                                          </li>
                                        )
                                      }
                                    )
                                    : null}
                              </ul>
                            </div>
                          </div>
                        )
                      } else if (
                        activity.activity_type === 3 || activity.activity_type === 10
                      ) {
                        return (
                          <>
                            <PreviousHomeworkGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1}
                            ></PreviousHomeworkGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 4
                      ) {
                        return (
                          <>
                            <PreviousHomeworkGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1}
                            ></PreviousHomeworkGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 5
                      ) {
                        return (
                          <>
                            <PreviousHomeworkGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1}
                            ></PreviousHomeworkGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 6 &&
                        (activity.fk_sub_id === 1 ||
                          activity.fk_sub_id === 2)
                      ) {
                        return (
                          <>
                            <PreviousHomeworkGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1}
                            ></PreviousHomeworkGeneralActivityCard>
                          </>
                        )
                      } else if (
                        activity.activity_type === 7 &&
                        (activity.fk_sub_id === 1 ||
                          activity.fk_sub_id === 2)
                      ) {
                        return (
                          <>
                            <PreviousHomeworkGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1}
                            ></PreviousHomeworkGeneralActivityCard>
                          </>
                        )
                      }
                      else if (activity.activity_type === ActivityType.PLATFORM_GAMES) {
                        return (<>
                          <GameCard activity={activity} sessionData={sessionData}
                                    options={{
                                      showStatus: true,
                                      showContextMenu: true,
                                      index: index1,
                                      showRollOverFrom: true,
                                      showDelete: true,
                                      onDelete: ()=>{ onDelectActivity(activity.pk_lesson_activity_key)},
                                      showHighlight: true,
                                    }}
                          >
                          </GameCard>
                        </>)
                      }
                      else if (activity.activity_type === ActivityType.LLL) {
                        return (
                          <>
                            <LllActivityCard activity={activity}
                                             options={{
                                               showStatus: true,
                                               showContextMenu: true,
                                               index: index1,
                                               showRollOverFrom: true,
                                               showDelete: true,
                                               onDelete: ()=>{ onDelectActivity(activity.pk_lesson_activity_key)},
                                               showHighlight: true,
                                             }}
                            >
                            </LllActivityCard>
                          </>)
                      }
                      else if (activity.activity_type === ActivityType.ONETIME) {
                        return (
                          <>
                            <PreviousHomeworkGeneralActivityCard
                              activity={activity} sessionData={sessionData} index={index1}
                            ></PreviousHomeworkGeneralActivityCard>
                          </>
                        )
                      }
                      else if (activity.activity_type === ActivityType.SKILLBUILDER) {
                        return (
                          <SkillbuilderActivityCard
                            activity={activity}
                            index={index1}
                            showContextMenu={false}
                          />
                        )
                      }
                      else if (
                        activity.activity_type === ActivityType.DIAGNOSTICS_FLOW ||
                        activity.activity_type === ActivityType.ENGLISH_DIAGNOSTICS
                      ) {
                        return (
                          <BmdActivityCard
                            activity={activity}
                            index={index1}
                            showContextMenu={false}
                          />
                        )
                      }
                      else {
                        return null
                      }
                    }
                  )
                  : null}
              </div>
            </div>
          )
        }
      )
      : null

    //home
  }

  // Memoize LessonPlanContent to prevent unnecessary re-renders
  const MemoizedPreviousHomeWorkSessionContent = useMemo(
    () => PreviousHomeWorkSessionContent,
    []
  )

  const PreviousSessionContent = ({
                                    sessionData,
                                    PreHomeSessionData,
                                    customActiveTab,
                                    getUniqueStudentSubjectNames,
                                    CountTotalCoins,
                                    CountHours,
                                    CountTotalActivity,
                                    clearTimeout,
                                    setLoopRun,
                                    handleLinkClick,
                                    toggleDropdown,
                                    dropdownOpen,
                                    onPreviewActivity,
                                    onDelectActivityPopup,
                                    getUniqueTopicsNames,
                                  }) => {
    if (
      sessionData?.session?.tbl_session_time?.tbl_student_enrolment?.length > 0
    ) {
      // Perform operations with tbl_student_enrolment
    } else {
      return (
        <p className="cs-txt-danger">No student assigned previous session</p>
      )
    }


    /**
     * @param {SessionActivity} activity
     * @param sessionData
     * @param {number} index
     * @return {React.JSX.Element}
     */
    const PreviousLibraryGeneralCard = ({activity, sessionData, index}) => {

      return (<>
        <GeneralActivityCard
          activity={activity} sessionData={sessionData} index={index}

          manualMarkActivity={{
            enabled: true,
            onActivate: () => onManualMarkingActivity(activity)
          }}

          previewActivity={{
            enabled: true,
            onActivate: () => onPreviewActivity(activity)
          }}

          deleteActivity={{
            enabled: true,
            onActivate: () => onDelectActivityPopup(activity.pk_lesson_activity_key)
          }}
        >
        </GeneralActivityCard>
      </>)
    }


    //lesson Plan

    return sessionData?.session?.tbl_session_time?.tbl_student_enrolment
      ? sessionData.session.tbl_session_time.tbl_student_enrolment.map(
        (enrolment, index) => {
          // console.log(CountTotalCoins(enrolment))

          return (
            <div
              className="kb-child p-0"
              style={{ height: "calc(99vh - 120px)", overflow: "auto" }}
              key={index}
            >
              <div className="ss-details border-bottom1 pb-3 bg-white p-1 mb-3">
                <div className="bg-supermild st-pd">
                  <div className="profile-details d-flex align-items-center gap-2">
                    <div className="stat-img">
                      <img
                        className="rounded-circle avatar-xs"
                        src={st2}
                        alt=""
                      />
                    </div>
                    <div>
                      <h5 className="text-dark mb-1">
                        {enrolment?.reassign === "1"
                          ? "*"
                          : null}
                        {enrolment.tbl_student?.st_first_name
                          ? enrolment.tbl_student.st_first_name +
                          " " +
                          enrolment.tbl_student.st_surname
                          : null}
                      </h5>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
                    <div>
                      <p>{sessionData.session.tbl_session_time.sest_name}</p>
                      <small>
                        {sessionData.session.tbl_session_time.sest_type}
                      </small>
                    </div>
                    <div>
                      <p>
                        {sessionData?.session?.ses_date
                          ? moment(
                            sessionData.session.ses_date,
                            moment.ISO_8601
                          ).format("DD MMM YYYY (ddd)")
                          : "-"}
                      </p>
                      <small>
                        {sessionData?.session?.ses_start_time
                          ? getMomentLocaleTimeFormat(
                            sessionData.session.ses_start_time,
                            "HH:mm:ss", userSetting.locale
                          )
                          : "-"}{" "}
                        -{" "}
                        {sessionData?.session?.ses_end_time
                          ? getMomentLocaleTimeFormat(
                            sessionData.session.ses_end_time,
                            "HH:mm:ss", userSetting.locale
                          )
                          : "-"}
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lesson-plan-wrapper bg-white p-2 pt-0">
                <div className="section-divider">
                  <div className="border-bottom pb-2 mb-2">
                    <h6 className="mb-0 text-dark">Lesson Plan</h6>
                    <div>
                      {enrolment.tbl_student.Lesson?.description
                        ? enrolment.tbl_student.Lesson.description
                        : null}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between list-unstyled mb-0">
                    <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                      {" "}
                      <img className="me-10" width={24} src={awicon} alt="" />
                      {CountTotalCoins(enrolment) || "-"}
                    </div>
                    <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                    </div>
                  </div>
                  {CountTotalActivity(enrolment)}
                </div>

                <div
                  className="events rm-heignt border-bottom1 pb-1 mb-1 mt-0"
                  style={{ minHeight: "100px" }}
                >
                  {enrolment.tbl_student?.Lesson?.LessonActivities?.length > 0 &&
                  (!enrolment.tbl_student?.tbl_session_attendance ||
                    (enrolment.tbl_student.tbl_session_attendance.attendance_status != null &&
                      parseInt(enrolment.tbl_student.tbl_session_attendance.attendance_status) !== 6))
                    ? enrolment.tbl_student.Lesson.LessonActivities.map(
                      (activity, index1) => {
                        if (
                          (activity.activity_type === 0 ||
                            activity.activity_type === 8) &&
                          activity.fk_sub_id === 2
                        ) {

                          let total_coins = 0
                          let total_time = 0

                          let total_question = 0
                          let count_answer = 0

                          if (
                            activity.LessonActivitiesQuestions?.length > 0
                          ) {

                            activity.LessonActivitiesQuestions.forEach(
                              (activityQuestion) => {
                                if (
                                  activityQuestion.question?.length > 0
                                ) {
                                  activityQuestion.question.forEach(
                                    (question) => {
                                      question.question_parts?.length > 0 &&
                                      question.question_parts.forEach(
                                        (questionpat) => {
                                          total_question += 1

                                          total_coins += 2
                                          if (
                                            questionpat.StudentAnsAttempts?.length > 0
                                          ) {
                                            questionpat.StudentAnsAttempts.forEach(
                                              stuAnswer => {
                                                total_time += parseInt(
                                                  stuAnswer.submitted_on
                                                )
                                              }
                                            )
                                            count_answer += 1 // Increment count_answer by 1 for each occurrence
                                          }
                                        }
                                      )
                                    }
                                  )
                                }
                              }
                            )
                          }
                          return (

                            <>
                              <MathOnlineActivityCard
                                activity={activity}
                                sessionData={sessionData}
                                index={index1}
                                previewActivity={{
                                  enabled: true,
                                  onActivate: ()=>onPreviewActivity(activity)
                                }}
                                deleteActivity={{
                                  enabled: true,
                                  onActivate: ()=>onDelectActivityPopup(activity.pk_lesson_activity_key)
                                }}
                              />
                            </>

                          )
                        } else if (
                          (activity.activity_type === 0 ||
                            activity.activity_type === 8) &&
                          activity.fk_sub_id === 1
                        ) {
                          return (
                            <>
                              <EnglishOnlineActivityCard
                                activity={activity} sessionData={sessionData} index={index1}
                                previewActivity={{
                                  enabled: true,
                                  onActivate: ()=>onPreviewActivity(activity)
                                }}
                                deleteActivity={{
                                  enabled: true,
                                  onActivate: ()=>onDelectActivityPopup(activity.pk_lesson_activity_key)
                                }}
                                manualMarkActivity={{
                                  enabled: true,
                                  onActivate: ()=>onManualMarkingActivity(activity)
                                }}
                              />
                            </>
                          )
                        } else if (activity.activity_type === 1) {
                          let total_coins = 0
                          let total_time = 0

                          let total_question = 0
                          let count_answer = 0

                          if (
                            activity.LessonActivitiesQuestions?.length > 0
                          ) {

                            activity.LessonActivitiesQuestions.forEach(
                              (activityQuestion) => {
                                if (
                                  activityQuestion.question?.length > 0
                                ) {
                                  activityQuestion.question.forEach(
                                    (question) => {
                                      total_question += 1
                                      total_coins += 2
                                      if (
                                        question.StudentAnsAttempts?.length > 0
                                      ) {
                                        question.StudentAnsAttempts.forEach(
                                          stuAnswer => {
                                            total_time += parseInt(
                                              stuAnswer.submitted_on
                                            )
                                          }
                                        )
                                        count_answer += 1 // Increment count_answer by 1 for each occurrence
                                      }
                                    }
                                  )
                                }
                              }
                            )
                          }
                          return (
                            <>
                              <PreviousLibraryGeneralCard
                                activity={activity} sessionData={sessionData} index={index1}>
                              </PreviousLibraryGeneralCard>
                              <div
                                className={`${(() => {
                                  if (
                                    sessionData?.session?.ses_is_completed === 1
                                  ) {
                                    if (
                                      activity.status == "1" &&
                                      activity.mastryScore
                                    ) {
                                      const score = parseInt(
                                        activity.mastryScore,
                                        10
                                      )
                                      if (score > 75)
                                        return "activity-card-success"
                                      if (score < 75)
                                        return "activity-card-blue"
                                    } else if (activity.status == "1") {
                                      return "activity-card-success"
                                    }
                                    return "activity-card-danger"
                                  }
                                  return ""
                                })()} set1 bg-supermild`}
                              >
                                  <span className="cs-txt-danger font-size-10 me-2">
                                    {activity && activity.roll_date
                                      ? "Rolled over from" +
                                      moment(
                                        activity.roll_date,
                                        moment.ISO_8601
                                      ).format("DD/MMM/YYYY")
                                      : null}
                                  </span>
                                <span
                                  className={`${
                                    activity.status == "0"
                                      ? "cs-txt-danger"
                                      : activity.status == "1"
                                        ? "text-success"
                                        : ""
                                  } font-size-10 me-2`}
                                >
                                    {activity.status == "0"
                                      ? "Incomplete"
                                      : activity.status == "1"
                                        ? "Completed"
                                        : null}
                                  </span>
                                <span
                                  className={`${
                                    activity.status == "0"
                                      ? "cs-txt-danger"
                                      : activity.status == "1"
                                        ? "text-success"
                                        : ""
                                  } font-size-10 me-2`}
                                >
                                    {count_answer != null &&
                                    total_question != null
                                      ? count_answer +
                                      "/" +
                                      total_question +
                                      " attempted"
                                      : null}
                                  </span>
                                <span className="cs-txt-danger font-size-10 me-2">
                                    {sessionData?.session?.ses_is_completed === 1 ? activity.mastryScore
                                        ? `Score: ${activity.mastryScore}` :  activity.status == "1" ? `Score: 100` : `Score: 0`
                                      : null}
                                  </span>
                                {["top"].map(placement => (
                                  <OverlayTrigger
                                    key={placement}
                                    placement={placement}
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-${placement}`}
                                        className="custom-tooltip"
                                      >
                                        Comment:{" "}
                                        {activity?.tutor_comments ||
                                          "No comments available"}
                                      </Tooltip>
                                    }
                                  >
                                      <span
                                        variant="secondary"
                                        className="no-bdr"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-info-circle"></i>
                                      </span>
                                  </OverlayTrigger>
                                ))}
                                <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
                                  {index1 + 1 + ") "}
                                  {activity.level_name &&
                                  activity.level_name != ""
                                    ? activity.level_name + " - "
                                    : null}
                                  {activity.topic_name &&
                                  activity.topic_name != ""
                                    ? activity.topic_name + " - "
                                    : null}
                                  {activity.activity_node[0] &&
                                  activity.activity_node[0].name != ""
                                    ? activity.activity_node[0].name
                                    : null}
                                </h6>

                                <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
                                  <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                      <span>
                                        {" "}
                                        <img width={24} src={reel} alt="" />
                                      </span>
                                    Video
                                  </div>
                                  <Dropdown
                                    isOpen={
                                      dropdownOpen[
                                        activity.pk_lesson_activity_key
                                        ]
                                    }
                                    toggle={() =>
                                      toggleDropdown(
                                        activity.pk_lesson_activity_key
                                      )
                                    }
                                  >
                                    <DropdownToggle className="p-0 bg-transparent mb-0">
                                      <i className="mdi mdi-dots-horizontal text-dark"></i>{" "}
                                    </DropdownToggle>
                                    <DropdownMenu className="custom-position">
                                      <DropdownItem
                                        onClick={() =>
                                          onPreviewActivity(activity)
                                        }
                                      >
                                        Preview
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={() =>
                                          onDelectActivityPopup(
                                            activity.pk_lesson_activity_key
                                          )
                                        }
                                      >
                                        Delete
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </Dropdown>
                                </div>

                                <div className="d-flex justify-content-between">
                                  <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                  </div>

                                  <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                    {" "}
                                    <img
                                      className="me-10"
                                      width={24}
                                      src={awicon}
                                      alt=""
                                    />
                                    {activity.coins_earned
                                      ? activity.coins_earned
                                      : 0}
                                    /
                                    {activity.activity_node?.[0]?.coins !== ""
                                      ? activity.activity_node[0].coins
                                      : 2}{" "}
                                  </div>
                                </div>

                                <div className="question-count mt-2">
                                  <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
                                  </ul>
                                </div>
                              </div>
                            </>
                          )
                        } else if (
                          activity.activity_type === 2 &&
                          activity.fk_sub_id === 1
                        ) {
                          let total_coins = 0
                          let total_time = 0

                          let total_question = 0
                          let count_answer = 0
                          if (
                            activity.LessonActivitiesQuestions?.length > 0
                          ) {

                            activity.LessonActivitiesQuestions.forEach(
                              (activityQuestion) => {
                                if (
                                  activityQuestion.english_question?.length > 0
                                ) {
                                  activityQuestion.english_question.forEach(
                                    (question) => {
                                      total_question += 1
                                      total_coins += 2
                                      if (
                                        question.StudentAnsAttempts?.length > 0
                                      ) {
                                        question.StudentAnsAttempts.forEach(
                                          stuAnswer => {
                                            total_time += parseInt(
                                              stuAnswer.submitted_on
                                            )
                                          }
                                        )
                                        count_answer += 1 // Increment count_answer by 1 for each occurrence
                                      }
                                    }
                                  )
                                }
                              }
                            )
                          }
                          return (
                            <div
                              className={`${(() => {
                                if (
                                  sessionData?.session?.ses_is_completed === 1
                                ) {
                                  if (
                                    activity.status == "1" &&
                                    activity.mastryScore
                                  ) {
                                    const score = parseInt(
                                      activity.mastryScore,
                                      10
                                    )
                                    if (score > 75)
                                      return "activity-card-success"
                                    if (score < 75)
                                      return "activity-card-blue"
                                  } else if (activity.status == "1") {
                                    return "activity-card-blue"
                                  }
                                  return "activity-card-danger"
                                }
                                return ""
                              })()} set1 bg-supermild`}
                            >
                                  <span className="cs-txt-danger font-size-10 me-2">
                                    {activity?.roll_date
                                      ? "Rolled over from" +
                                      moment(
                                        activity.roll_date,
                                        moment.ISO_8601
                                      ).format("DD/MMM/YYYY")
                                      : null}
                                  </span>
                              <span
                                className={`${
                                  activity.status == "0"
                                    ? "cs-txt-danger"
                                    : activity.status == "1"
                                      ? "text-success"
                                      : ""
                                } font-size-10 me-2`}
                              >
                                    {activity.status == "0"
                                      ? "Incomplete"
                                      : activity.status == "1"
                                        ? "Completed"
                                        : null}
                                  </span>
                              <span
                                className={`${
                                  activity.status == "0"
                                    ? "cs-txt-danger"
                                    : activity.status == "1"
                                      ? "text-success"
                                      : ""
                                } font-size-10 me-2`}
                              >
                                    {count_answer != null &&
                                    total_question != null
                                      ? count_answer +
                                      "/" +
                                      total_question +
                                      " attempted"
                                      : null}
                                  </span>
                              <span className="cs-txt-danger font-size-10 me-2">
                                    {sessionData?.session?.ses_is_completed ===
                                    1
                                      ? activity.mastryScore
                                        ? `Score: ${activity.mastryScore}`
                                        : `Score: 0`
                                      : null}
                                  </span>
                              {["top"].map(placement => (
                                <OverlayTrigger
                                  key={placement}
                                  placement={placement}
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-${placement}`}
                                      className="custom-tooltip"
                                    >
                                      Comment:{" "}
                                      {activity?.tutor_comments ||
                                        "No comments available"}
                                    </Tooltip>
                                  }
                                >
                                      <span
                                        variant="secondary"
                                        className="no-bdr"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-info-circle"></i>
                                      </span>
                                </OverlayTrigger>
                              ))}
                              <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
                                {index1 + 1 + ") "}
                                {activity.level_name &&
                                activity.level_name != ""
                                  ? activity.level_name + " - "
                                  : null}
                                {activity.topics &&
                                activity.topics.length > 0
                                  ? getUniqueTopicsNames(activity.topics)
                                  : null}
                              </h6>

                              <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
                                <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                      <span>
                                        {" "}
                                        <img width={24} src={reel} alt="" />
                                      </span>
                                  Diagnostics
                                </div>
                                <Dropdown
                                  isOpen={
                                    dropdownOpen[
                                      activity.pk_lesson_activity_key
                                      ]
                                  }
                                  toggle={() =>
                                    toggleDropdown(
                                      activity.pk_lesson_activity_key
                                    )
                                  }
                                >
                                  <DropdownToggle className="p-0 bg-transparent mb-0">
                                    <i className="mdi mdi-dots-horizontal text-dark"></i>{" "}
                                  </DropdownToggle>
                                  <DropdownMenu className="custom-position">
                                    <DropdownItem
                                      onClick={() =>
                                        onPreviewActivity(activity)
                                      }
                                    >
                                      Preview
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        onDelectActivityPopup(
                                          activity.pk_lesson_activity_key
                                        )
                                      }
                                    >
                                      Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>

                              <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                </div>

                                <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                  {" "}
                                  <img
                                    className="me-10"
                                    width={24}
                                    src={awicon}
                                    alt=""
                                  />
                                  {activity.coins_earned
                                    ? activity.coins_earned
                                    : 0}
                                  /{total_coins}{" "}
                                </div>
                              </div>

                              <div className="question-count mt-2">
                                <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
                                  {
                                    activity.LessonActivitiesQuestions?.length > 0
                                      ? activity.LessonActivitiesQuestions.map(
                                        (activityQuestion, index2) => {
                                          let color = ""

                                          if (
                                            activityQuestion.english_question?.length > 0
                                          ) {
                                            activityQuestion.english_question.forEach(
                                              (question) => {
                                                if (
                                                  question.StudentAnsAttempts.length > 0
                                                ) {
                                                  question.StudentAnsAttempts.forEach(
                                                    (
                                                      answerattquestion,
                                                    ) => {
                                                      color +=
                                                        answerattquestion.points_obtained
                                                    }
                                                  )
                                                }
                                              }
                                            )
                                          }

                                          const colorInt = parseInt(color)

                                          return (
                                            <li
                                              key={index2}
                                              className={`${
                                                colorInt === 1
                                                  ? "attempt2 text-warning bg-success-subtle"
                                                  : colorInt === 2
                                                    ? "attempt1 custom-success bg-success-subtle"
                                                    : colorInt === 0
                                                      ? "attempt3 cs-txt-danger bg-danger-subtle"
                                                      : ""
                                              }`}
                                            >
                                              {colorInt === 1 ? (
                                                <i className="fas fa-check"></i>
                                              ) : colorInt === 2 ? (
                                                <i className="fas fa-check"></i>
                                              ) : colorInt === 0 ? (
                                                <i className="mdi mdi-window-close"></i>
                                              ) : (
                                                index2 + 1
                                              )}
                                            </li>
                                          )
                                        }
                                      )
                                      : null}
                                </ul>
                              </div>
                            </div>
                          )
                        } else if (
                          activity.activity_type === 2 &&
                          activity.fk_sub_id === 2
                        ) {
                          let total_coins = 0
                          let total_time = 0

                          let total_question = 0
                          let count_answer = 0

                          if (
                            activity.LessonActivitiesQuestions?.length > 0
                          ) {

                            activity.LessonActivitiesQuestions.forEach(
                              (activityQuestion) => {
                                if (
                                  activityQuestion.question?.length > 0
                                ) {
                                  activityQuestion.question.forEach(
                                    (question) => {
                                      total_question += 1
                                      total_coins += 2
                                      if (
                                        question.StudentAnsAttempts?.length > 0
                                      ) {
                                        question.StudentAnsAttempts.forEach(
                                          stuAnswer => {
                                            total_time += parseInt(
                                              stuAnswer.submitted_on
                                            )
                                          }
                                        )
                                        count_answer += 1 // Increment count_answer by 1 for each occurrence
                                      }
                                    }
                                  )
                                }
                              }
                            )
                          }
                          return (
                            <div
                              className={`${(() => {
                                if (
                                  sessionData?.session?.ses_is_completed === 1
                                ) {
                                  if (
                                    activity.status == "1" &&
                                    activity.mastryScore
                                  ) {
                                    const score = parseInt(
                                      activity.mastryScore,
                                      10
                                    )
                                    if (score > 75)
                                      return "activity-card-success"
                                    if (score < 75)
                                      return "activity-card-blue"
                                  } else if (activity.status == "1") {
                                    return "activity-card-blue"
                                  }
                                  return "activity-card-danger"
                                }
                                return ""
                              })()} set1 bg-supermild`}
                            >
                                  <span className="cs-txt-danger font-size-10 me-2">
                                    {activity?.roll_date
                                      ? "Rolled over from" +
                                      moment(
                                        activity.roll_date,
                                        moment.ISO_8601
                                      ).format("DD/MMM/YYYY")
                                      : null}
                                  </span>
                              <span
                                className={`${
                                  activity.status == "0"
                                    ? "cs-txt-danger"
                                    : activity.status == "1"
                                      ? "text-success"
                                      : ""
                                } font-size-10 me-2`}
                              >
                                    {activity.status == "0"
                                      ? "Incomplete"
                                      : activity.status == "1"
                                        ? "Completed"
                                        : null}
                                  </span>
                              <span className="font-size-10">
                                    {count_answer != null &&
                                    total_question != null
                                      ? count_answer +
                                      "/" +
                                      total_question +
                                      " attempted"
                                      : null}
                                  </span>
                              <span className="cs-txt-danger font-size-10 me-2">
                                    {sessionData?.session?.ses_is_completed ===
                                    1
                                      ? activity.mastryScore
                                        ? `Score: ${activity.mastryScore}`
                                        : `Score: 0`
                                      : null}
                                  </span>
                              {["top"].map(placement => (
                                <OverlayTrigger
                                  key={placement}
                                  placement={placement}
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-${placement}`}
                                      className="custom-tooltip"
                                    >
                                      Comment:{" "}
                                      {activity?.tutor_comments ||
                                        "No comments available"}
                                    </Tooltip>
                                  }
                                >
                                      <span
                                        variant="secondary"
                                        className="no-bdr"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-info-circle"></i>
                                      </span>
                                </OverlayTrigger>
                              ))}
                              <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
                                {index1 + 1 + ") "}
                                {activity.level_name &&
                                activity.level_name != ""
                                  ? activity.level_name + " - "
                                  : null}
                                {activity.topics &&
                                activity.topics.length > 0
                                  ? getUniqueTopicsNames(activity.topics)
                                  : null}
                              </h6>

                              <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
                                <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                      <span>
                                        {" "}
                                        <img width={24} src={reel} alt="" />
                                      </span>
                                  Diagnostics
                                </div>
                                <Dropdown
                                  isOpen={
                                    dropdownOpen[
                                      activity.pk_lesson_activity_key
                                      ]
                                  }
                                  toggle={() =>
                                    toggleDropdown(
                                      activity.pk_lesson_activity_key
                                    )
                                  }
                                >
                                  <DropdownToggle className="p-0 bg-transparent mb-0">
                                    <i className="mdi mdi-dots-horizontal text-dark"></i>{" "}
                                  </DropdownToggle>
                                  <DropdownMenu className="custom-position">
                                    <DropdownItem
                                      onClick={() =>
                                        onPreviewActivity(activity)
                                      }
                                    >
                                      Preview
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        onDelectActivityPopup(
                                          activity.pk_lesson_activity_key
                                        )
                                      }
                                    >
                                      Delete
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>

                              <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                </div>

                                <div className="d-flex align-items-center font-size-12 text-dark fw-400">
                                  {" "}
                                  <img
                                    className="me-10"
                                    width={24}
                                    src={awicon}
                                    alt=""
                                  />
                                  {activity.coins_earned
                                    ? activity.coins_earned
                                    : 0}
                                  /{total_coins}{" "}
                                </div>
                              </div>

                              <div className="question-count mt-2">
                                <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
                                  {
                                    activity.LessonActivitiesQuestions?.length > 0
                                      ? activity.LessonActivitiesQuestions.map(
                                        (activityQuestion, index2) => {
                                          let color = ""

                                          if (
                                            activityQuestion.question?.length > 0
                                          ) {
                                            activityQuestion.question.forEach(
                                              (question) => {
                                                if (
                                                  question.StudentAnsAttempts?.length > 0
                                                ) {
                                                  question.StudentAnsAttempts.forEach(
                                                    (
                                                      answerattquestion,
                                                    ) => {
                                                      color +=
                                                        answerattquestion.points_obtained
                                                    }
                                                  )
                                                }
                                              }
                                            )
                                          }

                                          const colorInt = parseInt(color)

                                          return (
                                            <li
                                              key={index2}
                                              className={`${
                                                colorInt === 1
                                                  ? "attempt2 text-warning bg-success-subtle"
                                                  : colorInt === 2
                                                    ? "attempt1 custom-success bg-success-subtle"
                                                    : colorInt === 0
                                                      ? "attempt3 cs-txt-danger bg-danger-subtle"
                                                      : ""
                                              }`}
                                            >
                                              {colorInt === 1 ? (
                                                <i className="fas fa-check"></i>
                                              ) : colorInt === 2 ? (
                                                <i className="fas fa-check"></i>
                                              ) : colorInt === 0 ? (
                                                <i className="mdi mdi-window-close"></i>
                                              ) : (
                                                index2 + 1
                                              )}
                                            </li>
                                          )
                                        }
                                      )
                                      : null}
                                </ul>
                              </div>
                            </div>
                          )
                        } else if (
                          activity.activity_type === 3 ||
                          activity.activity_type === 10
                        ) {
                          return (
                            <>
                              <PreviousLibraryGeneralCard
                                activity={activity} sessionData={sessionData} index={index1}>
                              </PreviousLibraryGeneralCard>
                            </>
                          )
                        } else if (activity.activity_type === 4) {
                          return (
                            <>
                              <PreviousLibraryGeneralCard
                                activity={activity} sessionData={sessionData} index={index1}>
                              </PreviousLibraryGeneralCard>
                            </>
                          )
                        } else if (activity.activity_type === 5) {
                          return (
                            <>
                              <PreviousLibraryGeneralCard
                                activity={activity} sessionData={sessionData} index={index1}>
                              </PreviousLibraryGeneralCard>
                            </>
                          )
                        } else if (
                          activity.activity_type === 6 &&
                          (activity.fk_sub_id === 1 ||
                            activity.fk_sub_id === 2)
                        ) {
                          return (
                            <>
                              <PreviousLibraryGeneralCard
                                activity={activity} sessionData={sessionData} index={index1}>
                              </PreviousLibraryGeneralCard>
                            </>
                          )
                        } else if (
                          activity.activity_type === 7 &&
                          (activity.fk_sub_id === 1 ||
                            activity.fk_sub_id === 2)
                        ) {
                          return (
                            <>
                              <PreviousLibraryGeneralCard
                                activity={activity} sessionData={sessionData} index={index1}>
                              </PreviousLibraryGeneralCard>
                            </>
                          )
                        }
                        else if (activity.activity_type === ActivityType.PLATFORM_GAMES) {
                          return (
                            <>
                              <GameCard activity={activity}
                                        options={{
                                          showStatus: true,
                                          showContextMenu: true,
                                          index: index1,
                                          showHighlight: true,
                                        }}>
                              </GameCard>
                            </>
                          )
                        }
                        else if (activity.activity_type === ActivityType.LLL) {
                          return (
                            <>
                              <LllActivityCard
                                activity={activity}
                                options={{
                                  showContextMenu: false,
                                  showStatus: true,
                                  index: index1,
                                  showRollOverFrom: true,
                                  showHighlight: true
                                }}
                              >
                              </LllActivityCard>
                            </>
                          )
                        }
                        else if (activity.activity_type === ActivityType.ONETIME) {
                          return (
                            <>
                              <PreviousLibraryGeneralCard
                                activity={activity} sessionData={sessionData} index={index1}>
                              </PreviousLibraryGeneralCard>
                            </>
                          )
                        }
                        else if (activity.activity_type === ActivityType.SKILLBUILDER) {
                          return (
                            <SkillbuilderActivityCard
                              activity={activity}
                              index={index1}
                              showContextMenu={false}
                            />
                          )
                        }
                        else if (
                        activity.activity_type === ActivityType.DIAGNOSTICS_FLOW ||
                        activity.activity_type === ActivityType.ENGLISH_DIAGNOSTICS
                      ) {
                          return (
                            <BmdActivityCard
                              activity={activity}
                              index={index1}
                              showContextMenu={false}
                            />
                          )
                        }
                        else {
                          return null
                        }
                      }
                    )
                    : null}
                </div>
              </div>
              <MemoizedPreviousHomeWorkSessionContent
                sessionData={PreHomeSessionData}
                indexKey={index}
                customActiveTab={customActiveTab}
                getUniqueStudentSubjectNames={getUniqueStudentSubjectNames}
                CountTotalCoins={CountTotalCoins}
                CountHours={CountHours}
                CountTotalActivity={CountTotalActivity}
                clearTimeout={clearTimeout}
                setLoopRun={setLoopRun}
                handleLinkClick={handleLinkClick}
                toggleDropdown={toggleDropdown}
                dropdownOpen={dropdownOpen}
                onPreviewActivity={onPreviewActivity}
                onDelectActivityPopup={onDelectActivityPopup}
                getUniqueTopicsNames={getUniqueTopicsNames}
              />
            </div>
          )
        }
      )
      : null

    //home
  }

  // Memoize LessonPlanContent to prevent unnecessary re-renders
  const MemoizedPreviousSessionContent = useMemo(
    () => PreviousSessionContent,
    []
  )

  function getRandomEven(min, max) {
    const random = Math.floor(Math.random() * ((max - min) / 2 + 1))
    return min + random * 2
  }
  useEffect(() => {
    setSessiosNextActivity([])

    // Only proceed if there is data
    if (
      (SessionStudentNextActivity &&
        Array.isArray(SessionStudentNextActivity) &&
        SessionStudentNextActivity.length > 0) ||
      (SessionStudentSubjectNextActivity &&
        Array.isArray(SessionStudentSubjectNextActivity) &&
        SessionStudentSubjectNextActivity.length > 0)
    ) {
      // Declare a new result array to collect valid activities
      let processingArray = []
      // Check for any numbers other than 1 or 2
      let hasOtherNumbers = SessionStudentSubject.some(
        id => id !== 1 && id !== 2
      )

      if (hasOtherNumbers) {
        processingArray = [
          ...SessionStudentNextActivity,
          ...SessionStudentSubjectNextActivity,
        ]
      } else {
        // If only 1 or 2 are present
        if (SessionStudentSubject.length === 1) {
          processingArray = SessionStudentNextActivity
        } else {
          processingArray = [
            ...SessionStudentNextActivity,
            ...SessionStudentSubjectNextActivity,
          ]
        }
      }

      const result = []
      processingArray.forEach((yearLevel) => {
        yearLevel.LevelTopics.forEach((topic, index) => {
          if (
            topic.topic_completed_existing > 0 &&
            topic.topic_Incompleted_existing === 0
          ) {
            if (topic.TopicActivities.length > 0) {
              if (
                NextSessionData.activity_count +
                parseInt(TotalPendingActivity) +
                result.length <=
                20
              ) {
                const options = [5, 10, 15, 20, 25, 30]
                const randomValue =
                  options[Math.floor(Math.random() * options.length)]
                result.push({
                  id: topic.TopicActivities[0].activity_node_id,
                  name: topic.TopicActivities[0].node_name,
                  subject_id: topic.subject_id,
                  topicID: topic.activity_topic_id,
                  coin: getRandomEven(4, 20),
                  duration: randomValue + " mins",
                  is_homework: validation1.values.activity_method,
                  type: "Online Activities",
                  activity_node_id: topic.TopicActivities[0].activity_node_id,
                  activity_type: 0,
                  activity_level_data: yearLevel.level_name,
                  activity_level_id_data: yearLevel.activity_level_id,
                  activity_topic_data: topic.topic_name,
                  activity_subject: yearLevel.subject_name,
                  level_id: yearLevel.activity_level_id,
                  level_name: yearLevel.level_name,
                  topic_name: topic.topic_name,
                })
              }
            } else {
              // Check subsequent topics for activities
              for (let i = index + 1; i < yearLevel.LevelTopics.length; i++) {
                const nextTopic = yearLevel.LevelTopics[i]
                if (nextTopic.TopicActivities.length > 0) {
                  // Skip activity assignment if conditions met
                  if (
                    nextTopic.topic_completed_existing > 0 ||
                    nextTopic.topic_Incompleted_existing > 0
                  ) {
                    // Skip this iteration as the activity is automatically assigned
                  } else {
                    if (
                      NextSessionData.activity_count +
                      parseInt(TotalPendingActivity) +
                      result.length <=
                      20
                    ) {
                      const options = [5, 10, 15, 20, 25, 30]
                      const randomValue =
                        options[Math.floor(Math.random() * options.length)]
                      result.push({
                        // level_name: yearLevel.level_name,
                        // topic_name: nextTopic.topic_name,
                        // activity: nextTopic.TopicActivities[0],
                        id: nextTopic.TopicActivities[0].activity_node_id,
                        name: nextTopic.TopicActivities[0].node_name,
                        subject_id: nextTopic.subject_id,
                        topicID: nextTopic.activity_topic_id,
                        coin: getRandomEven(4, 20),
                        duration: randomValue + " mins",
                        is_homework: validation1.values.activity_method,
                        type: "Online Activities",
                        activity_node_id:
                        nextTopic.TopicActivities[0].activity_node_id,
                        activity_type: 0,
                        activity_level_data: yearLevel.level_name,
                        activity_level_id_data: yearLevel.activity_level_id,
                        activity_topic_data: nextTopic.topic_name,
                        activity_subject: yearLevel.subject_name,
                        level_id: yearLevel.activity_level_id,
                        level_name: yearLevel.level_name,
                        topic_name: topic.topic_name,
                      })
                    }
                  }
                  break // Stop once a valid next topic is found
                }
              }
            }
          }
        })
      })

      // Update state with the new result array
      setSessiosNextActivity(prevResults => [...prevResults, ...result])
    }
  }, [SessionStudentNextActivity, SessionStudentSubjectNextActivity]) // Trigger effect when SessionStudentNextActivity changes

  // Grouping activities by `activity_level_id_data`
  const groupedByLevel = SessiosNextActivity.reduce((acc, activity) => {
    const { activity_level_id_data } = activity

    // Debugging line to check if activity_level_id_data is available

    if (activity_level_id_data !== undefined) {
      if (!acc[activity_level_id_data]) {
        acc[activity_level_id_data] = []
      }
      acc[activity_level_id_data].push(activity)
    }
    return acc
  }, {})

  useEffect(() => {
    if (
      validation1.values.pk_student_key?.value &&
      validation1.values.activity_method &&
      NextSessionData?.next_session &&
      NextSessionData?.next_session_date &&
      ActivityPendingLoading === false &&
      sessionData
    ) {
      sessionData.session.tbl_session_time.tbl_student_enrolment
        .filter(
          enroll =>
            enroll.fk_stu_key === validation1.values.pk_student_key.value
        )
        .map(enroll => {
          let totalPending = 0

          SessionStudentPendingActivity.forEach(enroll => {
            const isNextSessionAvailable =
              NextSessionData &&
              NextSessionData.next_session_date &&
              NextSessionData.next_session_date !== ""

            if (isNextSessionAvailable) {
              const activities = enroll.Lesson?.LessonActivities || []
              const incompleteActivities = activities.filter(
                activity =>
                  activity.status === 0 ||
                  ((activity.mastryScore === null ||
                      parseInt(activity.mastryScore) < 75) &&
                    activity.status === 1 &&
                    [0, 2, 6, 7].includes(activity.activity_type))
              )

              totalPending += incompleteActivities.length
            }
          })

          let subject_id =
            getUniqueStudentSubjectID(enroll.tbl_enrolment_subject).join(",") ||
            "1"

          let subject = "1"
          let NextSubject = ""

          // Calculate subject and next subject
          const ids = subject_id.split(",").map(Number).filter(Boolean)
          const hasOtherNumbers = ids.some(id => id !== 1 && id !== 2)
          setSessionStudentSubject(ids)
          if (hasOtherNumbers) {
            subject = "1"
            NextSubject = "2"
          } else {
            subject = ids.length === 1 ? subject_id : "1"
            NextSubject = ids.length === 2 ? "2" : ""
          }

          if (
            NextSessionData.activity_count + parseInt(totalPending) < 20 &&
            SessionStudentNextActivity.length === 0
          ) {
            // Automatically trigger the required actions
            if (NextSubject && NextSubject !== "") {
              fetchSessionStudentNextActivityData(
                validation1.values.pk_student_key,
                validation1.values.activity_method,
                NextSessionData.next_session,
                subject
              )
              fetchSessionStudentSubjectNextActivityData(
                validation1.values.pk_student_key,
                validation1.values.activity_method,
                NextSessionData.next_session,
                NextSubject
              )
            } else {
              fetchSessionStudentNextActivityData(
                validation1.values.pk_student_key,
                validation1.values.activity_method,
                NextSessionData.next_session,
                subject
              )
            }
          } else {
            //skip triggered
          }
        })
    }
  }, [
    // validation1.values.pk_student_key,
    // validation1.values.activity_method,
    //NextSessionData?.next_session,
    ActivityPendingLoading,
    SessionStudentPendingActivity,
  ])

  useEffect(() => {
    const newIncompleteActivities = [];

    SessionStudentPendingActivity.forEach((enroll) => {
      const isNextSessionAvailable =
        NextSessionData?.next_session_date &&
        NextSessionData.next_session_date !== "";

      if (!isNextSessionAvailable) {
        return; // Skip if the next session is not available
      }

      const activities = enroll.Lesson?.LessonActivities || [];
      const incompleteActivities = activities.filter(
        (activity) =>
          activity.status === 0 ||
          ((activity.mastryScore === null ||
              parseInt(activity.mastryScore) < 75) &&
            activity.status === 1 &&
            [0, 2, 6, 7].includes(activity.activity_type))
      );

      if (incompleteActivities.length > 0) {
        newIncompleteActivities.push(...incompleteActivities);
      }
    });

    // Update the state with the new incomplete activities
    setSessionStudentPendingActivityArray((prevArray) => [
      ...prevArray,
      ...newIncompleteActivities,
    ]);
  }, [SessionStudentPendingActivity, NextSessionData]); // Dependencies ensure it runs only when these change

// add tuto note
  const [modal_tutorNote, setmodal_tutorNote] = useState(false)
  const [IsTutorNoteSubmitting, setIsTutorNoteSubmitting] = useState(false)
  const [tutorNote, setTutorNote] = useState(null)
  const [tutorNoteDetails, setTutorNoteDetails] = useState(null)
  const tog_tutorNote = () => {
    setmodal_tutorNote(!modal_tutorNote)
  }

  const handle_tutorNote = data => {
    setTutorNoteDetails(data)
    setTutorNote(data?.tsf_feedback || null)
    setmodal_tutorNote(true)
  }

  const handleAddNoteChange = newComment => {
    setTutorNote(newComment)
  }

  const onTutorNote = () => {
    if (authUser && authUser != "" && authUser != null) {
      if (key) {
        setIsTutorNoteSubmitting(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "session/addTutorStudentFeedBack", {
            tutor_notes: tutorNote,
            pk_student_key: tutorNoteDetails.pk_student_key,
            fk_ses_key: key
          })
          .then(responseTutorNote => {
            if (parseInt(responseTutorNote.data) === 1) {
              toast.success("Feedback added successfully", {
                autoClose: 3000, // 3 seconds in this example
              })
              fetchData()
              tog_tutorNote()
              setIsTutorNoteSubmitting(false)
            } else {
              setIsTutorNoteSubmitting(false)
              toast.error("Failure! Unable to feedback added. Try again later", {
                autoClose: 3000, // 3 seconds in this example
              })
            }
          })
          .catch(error => {
            setIsTutorNoteSubmitting(false)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setIsTutorNoteSubmitting(false)
        toast.error("Failure! Unable to feedback added. Try again later", {
          autoClose: 3000
        })
      }
    } else {
      setIsTutorNoteSubmitting(false)
      navigate("/login")
    }
  }
  const [printingAll, setPrintingAll] = useState(false)
  const sessionDataRef = useRef(null);
  useEffect(() => {
    sessionDataRef.current = sessionData;
  }, [sessionData]);

  const handlePrintAllLabeled = async (evt, passedSession) => {
    evt?.preventDefault?.();
    evt?.stopPropagation?.();

    if (printingAll) return;
    const lessonSession   = (passedSession ?? sessionDataRef.current?.session ?? sessionData?.session);
    const homeworkSession = HomeSessionData?.session;

    if (!lessonSession && !homeworkSession) {
      toast.info("Session data not loaded yet.");
      return;
    }

    try {
      setPrintingAll(true);

      const sessionForLabel = lessonSession || homeworkSession;
      const { dateStr, timeStr } = sessionDateTimeStrings(sessionForLabel);
      const tutorName =
        tutorNameFromSest(sessionForLabel?.tbl_session_time?.sest_name) ||
        authUser?.name || authUser?.full_name || "Tutor";

      const jobs = gatherWorksheetJobs({ lessonSession, homeworkSession });
      if (!jobs.length) {
        toast.info("No printable worksheets found.");
        return;
      }

      const merged = await PDFDocument.create();

      for (const j of jobs) {
        try {
          const labeledBlob = await labelPdf({
            pdfUrl: j.url,
            studentName: j.studentName,
            tutorName,
            dateStr,
            timeStr,
            sessionKey: sessionForLabel?.pk_ses_key,
            origin: j.origin,
          });

          const src   = await PDFDocument.load(await labeledBlob.arrayBuffer());
          const pages = await merged.copyPages(src, src.getPageIndices());
          pages.forEach(p => merged.addPage(p));

          if (src.getPageCount() % 2 === 1) {
            const { width, height } = pages[pages.length - 1].getSize();
            merged.addPage([width, height]);
          }
        } catch (e) {
          console.warn("Skipping broken PDF:", j.url, e);
        }
      }

      if (merged.getPageCount() === 0) {
        toast.info("No pages to print (files may be missing).");
        return;
      }

      const mergedBytes = await merged.save();
      openBlobForPrint(new Blob([mergedBytes], { type: "application/pdf" }));
    } catch (e) {
      console.error("Print ALL (labeled) failed", e);
    } finally {
      setPrintingAll(false);
    }
  };


// SINGLE student
  const handlePrintStudentLabeled = async (student) => {
    try {
      if (!student) { toast.info("No student found for this row."); return; }

      // Use the correct session data for labels depending on the active tab
      const sessionForLabel =
        (isHomeworkView() ? HomeSessionData?.session : sessionData?.session) ??
        sessionDataRef.current?.session;

      if (!sessionForLabel) { toast.info("Session data not loaded yet."); return; }

      const { dateStr, timeStr } = sessionDateTimeStrings(sessionForLabel);
      const tutorName =
        tutorNameFromSest(sessionForLabel?.tbl_session_time?.sest_name) ||
        authUser?.name || authUser?.full_name || "Tutor";

      const acts = student?.Lesson?.LessonActivities || [];
      const worksheets = acts.filter(a => Number(a?.activity_type) === 7);
      if (!worksheets.length) { toast.info("No printable worksheets for this student."); return; }

      const merged = await PDFDocument.create();
      const failures = [];

      for (const a of worksheets) {
        const node = a?.activity_node?.[0];
        const url  = buildPdfUrl(node?.file_name, a?.fk_sub_id);
        if (!url) { console.warn("No URL for worksheet", { a, node }); failures.push("missing-url"); continue; }

        const origin =
          (a?.marked_for_homework === 1 || a?.marked_for_homework === true)
            ? "homework"
            : (isHomeworkView() ? "homework" : "session");

        try {
          const labeledBlob = await labelPdf({
            pdfUrl: url,
            studentName: [student.st_first_name, student.st_surname].filter(Boolean).join(" ") || "Student",
            tutorName,
            dateStr,
            timeStr,
            origin,
          });

          const src   = await PDFDocument.load(await labeledBlob.arrayBuffer());
          const pages = await merged.copyPages(src, src.getPageIndices());
          pages.forEach(p => merged.addPage(p));

          if (src.getPageCount() % 2 === 1) {
            const { width, height } = pages[pages.length - 1].getSize();
            merged.addPage([width, height]);
          }
        } catch (e) {
          console.warn("Skipping broken PDF", url, e);
          failures.push(url);
        }
      }

      if (merged.getPageCount() === 0) {
        toast.error("No pages to print. See console for the failing URLs.");
        return;
      }

      const bytes = await merged.save();
      openBlobForPrint(new Blob([bytes], { type: "application/pdf" }));

      if (failures.length) {
        console.table(failures.map(u => ({ failedUrl: u })));
        toast.warn(`Printed with ${failures.length} file(s) skipped. Check console for details.`);
      }
    } catch (err) {
      console.error("Print Student (labeled) failed", err);
      toast.error("Couldn't print this student's worksheets. Check the console for details.");
    }
  };


  const {centerTimezone} = getUserSession();

  const copyActivitiesDialogRef = useRef(null);
  const openCopyActivitiesDialog = async ()=>{

    const result = await copyActivitiesDialogRef?.current?.open({session: sessionData?.session});
    if(result) {
      toast.success("Activities copied", { autoClose: 3000 })
      window.location.reload();
    }
  }


  return (
    <React.Fragment>
      <Loader
        show={loader}
        type="body"
        // stack="vertical"
        // message="Loading Data"
      />
      <ToastContainer autoClose={3000} />
      {/* popup for note delete start*/}
      <Modal isOpen={modal_delete_note} toggle={tog_delete_note} centered>
        {/* <ModalHeader className="mt-0" toggle={tog_center}>Center Modal</ModalHeader> */}
        <ModalBody className="text-center">
          <div className="my-4">
            <h5 className="mb-4">Are you sure you want to delete?</h5>
            <Button
              color="success"
              className="mr-3"
              disabled={isNoteSubmitting}
              onClick={onDelectNote}
            >
              {" "}
              Yes{" "}
            </Button>
            <Button color="danger" onClick={tog_delete_note}>
              {" "}
              No{" "}
            </Button>
          </div>
        </ModalBody>
      </Modal>
      {/* popup for activity delete  end*/}
      {/* Notes start */}
      <Modal isOpen={modal_tutorNote} toggle={tog_tutorNote} centered>
        <ModalHeader className="mt-0" toggle={tog_tutorNote}>
          Feedback
        </ModalHeader>
        <ModalBody>
          <div className="comment-section mt-3">
            <label className="font-size-15">Tutor Feedback:</label>
            <textarea
              id={`notesTutor}`}
              className="form-control"
              placeholder="Add your feedback here"
              value={tutorNote || ""} // Display existing comment or empty string
              onChange={
                e => handleAddNoteChange(e.target.value)
              }
              rows="10"
            />
          </div>
          <div className="text-end mt-3">
            <div className="btn-group">
              <button
                className="btn bg-danger text-white  me-3 font-size-12"
                disabled={IsTutorNoteSubmitting}
                onClick={() => {
                  onTutorNote()
                }}
              >
                Save
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {/* Notes end */}
      {/* popup for activity Move start*/}
      <Modal
        isOpen={modal_move_activity}
        toggle={tog_move_activity}
        size="lg"
        centered
      >
        <ModalHeader
          className="mt-0 w-100"
          close={
            moveingSessionKey.length > 0 ? (
              <button
                className="btn bg-danger text-white text-uppercase position-absolute top-3 end-0 me-3"
                disabled={isMASubmitting}
                onClick={() => {
                  onMoveingActivityPopup()
                }}
              >
                Submit
              </button>
            ) : (
              ""
            )
          }
        >
          {/* Tab Navigation */}

          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${
                  rollOveractiveTabSingle === "lessonPlan" ? "active" : ""
                }`}
                id="lessonPlan-tab"
                data-bs-toggle="tab"
                role="tab"
                onClick={() => handlerollOverTabChangeSingle("lessonPlan")}
              >
                Roll over to lesson plan
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${
                  rollOveractiveTabSingle === "homework" ? "active" : ""
                }`}
                id="homework-tab"
                data-bs-toggle="tab"
                role="tab"
                onClick={() => handlerollOverTabChangeSingle("homework")}
              >
                Roll over to home work
              </a>
            </li>
          </ul>
        </ModalHeader>

        <ModalBody className="text-center">
          <div>
            {/* Tab Content */}
            <div className="tab-content mt-3">
              <div
                className={`tab-pane fade ${
                  rollOveractiveTabSingle === "lessonPlan" ? "show active" : ""
                }`}
                role="tabpanel"
              >
                <label>Choose session</label>
                {/* Content for the Lesson Plan Tab */}
                <TableComm
                  columns={columns_session}
                  defaultId={"ses_date"}
                  data={UpcomingSessionData}
                />
              </div>
              <div
                className={`tab-pane fade ${
                  rollOveractiveTabSingle === "homework" ? "show active" : ""
                }`}
                role="tabpanel"
              >
                <label>Choose session</label>
                {/* Content for the Lesson Plan Tab */}
                <TableComm
                  columns={columns_session}
                  defaultId={"ses_date"}
                  data={UpcomingSessionData}
                />
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {/* popup for activity move  end*/}
      {/* popup for student past session start*/}
      <Modal
        isOpen={modalStuPastSession}
        toggle={togStudentPastSession}
        size="xl"
        centered
      >
        <ModalHeader className="mt-0" toggle={togStudentPastSession}>
          <label>View past sessions</label>
        </ModalHeader>
        <ModalBody>
          <TableComm
            columns={columns1}
            defaultId={"sest_name"}
            data={PastSessionStuData}
          />
        </ModalBody>
      </Modal>
      {/* popup for student past session end*/}
      {/* popup for multiple activity Move start*/}

      <Modal
        isOpen={show_modal_move_multiple_activity}
        toggle={tog_move_multiple_activity}
        size="lg"
        centered
      >
        <ModalHeader
          className="mt-0 w-100"
          close={
            moveingMultipleSessionKey.length > 0 ? (
              <button
                className="btn bg-danger text-white text-uppercase position-absolute top-3 end-0 me-3"
                disabled={isMulMoningSubmitting}
                onClick={() => {
                  onMoveingMultipleActivityPopup()
                }}
              >
                Submit
              </button>
            ) : (
              ""
            )
          }
        >
          {/* Tab Navigation */}

          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${
                  rollOveractiveTab === "lessonPlan" ? "active" : ""
                }`}
                id="lessonPlan-tab"
                data-bs-toggle="tab"
                role="tab"
                onClick={() => handlerollOverTabChange("lessonPlan")}
              >
                Roll over to lesson plan
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${
                  rollOveractiveTab === "homework" ? "active" : ""
                }`}
                id="homework-tab"
                data-bs-toggle="tab"
                role="tab"
                onClick={() => handlerollOverTabChange("homework")}
              >
                Roll over to home work
              </a>
            </li>
          </ul>
        </ModalHeader>

        <ModalBody className="text-center">
          <div>
            {/* Tab Content */}
            <div className="tab-content mt-3">
              <div
                className={`tab-pane fade ${
                  rollOveractiveTab === "lessonPlan" ? "show active" : ""
                }`}
                role="tabpanel"
              >
                <label>Choose session</label>
                {/* Content for the Lesson Plan Tab */}
                <TableComm
                  columns={columns_multi_session}
                  defaultId={"ses_date"}
                  data={MultipleUpcomingSessionData}
                />
              </div>
              <div
                className={`tab-pane fade ${
                  rollOveractiveTab === "homework" ? "show active" : ""
                }`}
                role="tabpanel"
              >
                <label>Choose session</label>
                {/* Content for the Lesson Plan Tab */}
                <TableComm
                  columns={columns_multi_session}
                  defaultId={"ses_date"}
                  data={MultipleUpcomingSessionData}
                />
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      {/* popup for multiple activity move  end*/}

      {/* popup for activity Roll over to lession or homewor start*/}
      {/* popup for activity Roll over to homework  end*/}
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box mb-2">
            <div className="custom-pg_header">
              <div>
                <div className="d-flex align-items-center gap-2">
                  <Button
                    color="light"
                    className="bck-btn"
                    onClick={() => window.history.back()}
                  >
                    <i className="ion ion-ios-arrow-back"></i>
                  </Button>

                  <h6 className="page-title mb-0  font-size-18">
                    {sessionData?.session?.tbl_session_time?.sest_name
                      ? sessionData.session.tbl_session_time.sest_name
                      : "-"}{" "}

                  </h6>
                  {((parseInt(customActiveTab) === 1 || parseInt(customActiveTab) === 2) ) ? (
                    <div
                      className="ms-0 d-flex align-items-center aw-button me-2"
                      color=""
                      onClick={generatePDF}
                    >
                      {" "}
                      <span>
                      <img className="cs-mg  font-size-18" width={24} src={reportIcon} alt="" />
                    </span>{" "}
                      <div className="cs-mg  font-size-16"> Summary{" "}</div>
                    </div>
                  ): null}
                </div>

              </div>
              <div className="d-flex align-items-center flex-wrap">
                <div className="text-dark font-size-16">
                  {" "}
                  {sessionData?.session?.tbl_session_time?.sest_type
                    ? sessionData.session.tbl_session_time.sest_type
                    : "-"}
                </div>
                <div
                  className="me-2 d-flex align-items-center aw-button"
                  color=""
                  // onClick={toggleRightCanvas}
                  onClick={tog_center2}
                >
                  <span>
                    <img className="cs-mg" width={24} src={awicon} alt="" />
                  </span>
                  <div className="cs-mg  font-size-16">Award Coins</div>
                </div>
                <div
                  className="me-2 d-flex align-items-center aw-button"
                  onClick={tog_removeCoins}
                >
                  <span>
                    <img className="cs-mg" width={24} src={awicon} alt="" />
                  </span>
                  <div className="cs-mg font-size-16 text-danger">Remove Coins</div>
                </div>
                {sessionData?.session?.ses_status === 0 &&
                  <div
                    className="me-2 d-flex align-items-center aw-button"
                    onClick={openCopyActivitiesDialog}
                  >
                    <i class="fas fa-solid fa-copy"></i>
                    <span className="cs-mg font-size-16">&nbsp;Copy Activities</span>
                  </div>
                }
                <div
                  className="me-2 d-flex align-items-center aw-button"
                  role="button"
                  tabIndex={0}
                  onClick={(e) => {
                    if (printingAll) return;
                    e.preventDefault();
                    e.stopPropagation();
                    handlePrintAllLabeled(e, sessionData?.session);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !printingAll) {
                      e.preventDefault();
                      e.stopPropagation();
                      handlePrintAllLabeled(e, sessionData?.session);
                    }
                  }}
                  style={printingAll ? { opacity: 0.6, pointerEvents: "none" } : undefined}
                  title="Print all students' worksheets with labels"
                >
                  <span className="d-inline-flex align-items-center justify-content-center" style={{ width: 18 }}>
                    {printingAll ? (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    ) : (
                      <i className="mdi mdi-printer font-size-18 text-dark" />
                    )}
                  </span>
                  <span className="ms-1  font-size-16 ">Print Session Worksheets</span>
                </div>

                <Modal
                  isOpen={modal_center2}
                  toggle={tog_center2}
                  centered
                  className="mastery-modal"
                >
                  <ModalHeader className="mt-0 text-dark" toggle={tog_center2}>
                    Award coin to
                  </ModalHeader>
                  <ModalBody>
                    <Form
                      className=""
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                      action="#"
                    >
                      <div className="mb-3">
                        <Label className="font-size-12 mb-1 pb-0">
                          Student List
                        </Label>
                        <Select
                          isMulti={true}
                          options={studentOption}
                          classNamePrefix="select2-selection"
                          id="pk_student_key"
                          onBlur={validation.handleBlur}
                          name="pk_student_key"
                          value={validation.values.pk_student_key || ""}
                          onChange={selectedOption => {
                            const event = {
                              target: {
                                name: "pk_student_key",
                                value: selectedOption,
                              },
                            }
                            validation.handleChange(event)
                          }}
                          className={
                            validation.touched.coins_earned &&
                            validation.errors.coins_earned
                              ? "is-invalid cs-style"
                              : "cs-style"
                          }
                        />
                        {validation.touched.pk_student_key &&
                        validation.errors.pk_student_key ? (
                          <FormFeedback type="invalid">
                            {validation.errors.pk_student_key}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className=" col-form-label pt-0 font-size-12 mb-1 pb-0"
                        >
                          No. Of Coins
                        </label>
                        <div className="">
                          <input
                            type="number"
                            placeholder="Enter number of coins to award"
                            id="coins_earned"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.coins_earned}
                            className={
                              validation.touched.coins_earned &&
                              validation.errors.coins_earned
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            min="1"
                            max="30"
                          />
                          {validation.touched.coins_earned &&
                          validation.errors.coins_earned ? (
                            <FormFeedback type="invalid">
                              {validation.errors.coins_earned}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="mb-3">
                        <label
                          htmlFor="example-text-input"
                          className=" col-form-label pt-0 font-size-12 mb-1 pb-0"
                        >
                          Reason
                        </label>
                        <Input
                          type="textarea"
                          maxLength="225"
                          rows="3"
                          placeholder="Type notes here"
                          id="remarks"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.remarks || ""}
                          className={
                            validation.touched.remarks &&
                            validation.errors.remarks
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        {validation.touched.remarks &&
                        validation.errors.remarks ? (
                          <FormFeedback type="invalid">
                            {validation.errors.remarks}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-end">
                        <div className="btn-group">
                          <button
                            type="submit"
                            class="btn btn-danger"
                            disabled={isSubmitting}
                          >
                            Award
                          </button>
                        </div>
                      </div>
                    </Form>
                  </ModalBody>
                </Modal>

                <Modal
                  isOpen={modal_removeCoins}
                  toggle={tog_removeCoins}
                  centered
                  className="mastery-modal"
                >
                  <ModalHeader className="mt-0 text-dark" toggle={tog_removeCoins}>
                    Remove coin from
                  </ModalHeader>

                  <ModalBody>
                    <Form
                      onSubmit={e => {
                        e.preventDefault()
                        removeValidation.handleSubmit()
                        return false
                      }}
                      action="#"
                    >
                      <div className="mb-3">
                        <Label className="font-size-12 mb-1 pb-0">Student List</Label>
                        <Select
                          isMulti={true}
                          options={studentOption}
                          classNamePrefix="select2-selection"
                          id="pk_student_key"
                          onBlur={removeValidation.handleBlur}
                          name="pk_student_key"
                          value={removeValidation.values.pk_student_key || ""}
                          onChange={selectedOption => {
                            const event = {
                              target: {
                                name: "pk_student_key",
                                value: selectedOption,
                              },
                            }
                            removeValidation.handleChange(event)
                          }}
                          className={
                            removeValidation.touched.pk_student_key &&
                            removeValidation.errors.pk_student_key
                              ? "is-invalid cs-style"
                              : "cs-style"
                          }
                        />
                        {removeValidation.touched.pk_student_key &&
                        removeValidation.errors.pk_student_key ? (
                          <FormFeedback type="invalid">
                            {removeValidation.errors.pk_student_key}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <label className="col-form-label pt-0 font-size-12 mb-1 pb-0">
                          No. Of Coins
                        </label>
                        <input
                          type="number"
                          placeholder="Enter number of coins to remove"
                          id="coins_deducted"
                          onChange={removeValidation.handleChange}
                          onBlur={removeValidation.handleBlur}
                          value={removeValidation.values.coins_deducted}
                          className={
                            removeValidation.touched.coins_deducted &&
                            removeValidation.errors.coins_deducted
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          min="1"
                        />
                        {removeValidation.touched.coins_deducted &&
                        removeValidation.errors.coins_deducted ? (
                          <FormFeedback type="invalid">
                            {removeValidation.errors.coins_deducted}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <label className="col-form-label pt-0 font-size-12 mb-1 pb-0">
                          Reason
                        </label>
                        <Input
                          type="textarea"
                          maxLength="225"
                          rows="3"
                          placeholder="Type notes here"
                          id="remarks"
                          onChange={removeValidation.handleChange}
                          onBlur={removeValidation.handleBlur}
                          value={removeValidation.values.remarks || ""}
                          className={
                            removeValidation.touched.remarks && removeValidation.errors.remarks
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                        />
                        {removeValidation.touched.remarks && removeValidation.errors.remarks ? (
                          <FormFeedback type="invalid">
                            {removeValidation.errors.remarks}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-end">
                        <div className="btn-group">
                          <button type="submit" className="btn btn-danger" disabled={isSubmitting}>
                            Remove
                          </button>
                        </div>
                      </div>
                    </Form>
                  </ModalBody>
                </Modal>



                <Modal
                  isOpen={modal_center3}
                  toggle={tog_center3}
                  centered
                  className="mastery-modal"
                >
                  <ModalHeader className="mt-0 text-dark" toggle={tog_center3}>
                    Incomplete Activities
                  </ModalHeader>
                  <ModalBody>
                    <Form
                      className=""
                      onSubmit={e => {
                        e.preventDefault()
                        validation1.handleSubmit()
                        return false
                      }}
                      action="#"
                    >
                      <div className="mb-3">
                        <Label className="font-size-12 mb-1 pb-0">
                          Student List
                        </Label>
                        <Select
                          options={studentOption}
                          classNamePrefix="select2-selection"
                          id="pk_student_key"
                          onBlur={validation1.handleBlur}
                          name="pk_student_key"
                          value={validation1.values.pk_student_key || ""}
                          onChange={selectedOption => {
                            const event = {
                              target: {
                                name: "pk_student_key",
                                value: selectedOption,
                              },
                            }
                            validation1.handleChange(event)
                            validation1.setFieldValue("activities", [])
                            fetchNextSessionData(
                              selectedOption,
                              validation1.values.activity_method
                            )
                            setnextsessiondeatils("")
                            fetchSessionStudentPendingActivityData(
                              selectedOption,
                              validation1.values.activity_method
                            )
                            setSessionStudentPendingActivity([])
                            setSessionStudentNextActivity([])
                            setSessiosNextActivity([])
                          }}
                          className={
                            validation1.touched.pk_student_key &&
                            validation1.errors.pk_student_key
                              ? "is-invalid cs-style"
                              : "cs-style"
                          }
                        />
                        {validation1.touched.pk_student_key &&
                        validation1.errors.pk_student_key ? (
                          <FormFeedback type="invalid">
                            {validation1.errors.pk_student_key}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="font-size-12 mb-1 pb-0">
                          Activity Method
                        </Label>
                        <Select
                          // isMulti={true}
                          options={optionPendingActivityType}
                          classNamePrefix="select2-selection"
                          id="activity_method"
                          onBlur={validation1.handleBlur}
                          name="activity_method"
                          value={optionPendingActivityType.find(
                            option =>
                              option.value == validation1.values.activity_method
                          )}
                          onChange={selectedOption => {
                            // console.log(selectedOption)
                            const event = {
                              target: {
                                name: "activity_method",
                                value: selectedOption["value"],
                              },
                            }
                            validation1.handleChange(event)
                            validation1.setFieldValue("activities", [])
                            fetchNextSessionData(
                              validation1.values.pk_student_key,
                              selectedOption["value"]
                            )
                            setnextsessiondeatils("")
                            fetchSessionStudentPendingActivityData(
                              validation1.values.pk_student_key,
                              selectedOption["value"]
                            )
                            setSessionStudentPendingActivity([])
                            setSessionStudentNextActivity([])
                            setSessiosNextActivity([])
                          }}
                          className={
                            validation1.touched.activity_method &&
                            validation1.errors.activity_method
                              ? "is-invalid cs-style"
                              : "cs-style"
                          }
                        />
                        {validation1.touched.activity_method &&
                        validation1.errors.activity_method ? (
                          <FormFeedback type="invalid">
                            {validation1.errors.activity_method}
                          </FormFeedback>
                        ) : null}
                      </div>
                      {validation1.values.pk_student_key &&
                        (NextSessionData &&
                        NextSessionData.next_session_date ? (
                          <div className="mb-3">
                            <Label className="font-size-12 mb-1 pb-0">
                              Next Session: {NextSessionData.sest_name} (
                              {moment(
                                NextSessionData.next_session_date,
                                "YYYY-MM-DDTHH:mm:ss.SSSZ"
                              ).format("DD MMM YYYY")}
                              ) (Total Activity :{" "}
                              {NextSessionData && NextSessionData.activity_count
                                ? NextSessionData.activity_count
                                : 0}
                              )
                            </Label>
                          </div>
                        ) : (
                          <div className="alert alert-info">
                            No session available for this student.
                          </div>
                        ))}

                      <div className="mb-3">
                        {SessionStudentPendingActivity &&
                        SessionStudentPendingActivity.length > 0 ? (
                          <label
                            htmlFor="example-text-input"
                            className="col-form-label pt-0 font-size-12 mb-1 pb-0"
                          >
                            Incomplete activities move to next session
                          </label>
                        ) : null}
                        <div className="activities-container">
                          <Loader
                            show={ActivityPendingLoading}
                            type="inline"
                            spinnerSize="20px"
                            spinnerStyle={{
                              secondary: "#2D866D",
                            }}
                          />
                          <div className="form-check">
                            {SessionStudentPendingActivityArray && SessionStudentPendingActivityArray.length > 0 ?
                              <>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`activity-all`}
                                  name="activities"
                                  checked={PendingActivitySeleteAll || (SessionStudentPendingActivityArray && validation1.values.activities && SessionStudentPendingActivityArray.length === validation1.values.activities.length)}
                                  onChange={event => {
                                    const value = event.target.checked
                                    setPendingActivitySeleteAll(value)
                                    console.log(value)
                                    let next_activity_count =
                                      NextSessionData &&
                                      NextSessionData.activity_count !=
                                      null &&
                                      NextSessionData.activity_count <= 20
                                        ? 20 -
                                        parseInt(
                                          NextSessionData.activity_count
                                        )
                                        : 0

                                    if (value === true) {
                                      let selectedActivity = [];
                                      let exceededLimit = false;
                                      console.log('start loop')

                                      SessionStudentPendingActivityArray.forEach((activity) => {
                                        if (selectedActivity.length < next_activity_count) {
                                          console.log('add activity')
                                          console.log(activity)
                                          selectedActivity = [
                                            ...selectedActivity,
                                            activity.pk_lesson_activity_key,
                                          ];
                                        } else if (!exceededLimit) {
                                          // Show the error message only once when the limit is reached
                                          exceededLimit = true;
                                          toast.error(
                                            "Sorry, a maximum of 20 activities are allowed next session",
                                            { autoClose: 3000 } // 3 seconds
                                          );
                                        }
                                      });

                                      validation1.setFieldValue("activities", selectedActivity);
                                    } else {
                                      // Handle deselection or reset if value is not true
                                      validation1.setFieldValue("activities", []);
                                    }

                                  }}
                                />
                                <label htmlFor="exampleCheckbox">Select All</label></>
                              : null}
                          </div>
                          {!validation1.values.pk_student_key ? (
                            <div className="alert alert-warning">
                              Please select a student to list the activities.
                            </div>
                          ) : SessionStudentPendingActivity?.length > 0 ? (
                            SessionStudentPendingActivity.map(enroll => {
                              const isNextSessionAvailable =
                                NextSessionData &&
                                NextSessionData.next_session_date &&
                                NextSessionData.next_session_date !== ""

                              if (!isNextSessionAvailable) {
                                return (
                                  <div
                                    key={`no-session-${enroll.pk_student_key}`}
                                    className="alert alert-info"
                                  >
                                    Next session not available for this student.
                                  </div>
                                )
                              }

                              const activities =
                                enroll.Lesson?.LessonActivities || []
                              const incompleteActivities = activities.filter(
                                activity =>
                                  activity.status === 0 ||
                                  ((activity.mastryScore === null ||
                                      parseInt(activity.mastryScore) < 75) &&
                                    activity.status === 1 &&
                                    [0, 2, 6, 7].includes(
                                      activity.activity_type
                                    ))
                              )

                              if (incompleteActivities.length === 0) {
                                return null
                                // <div key={`no-activities-${enroll.pk_student_key}`} className="alert alert-info">
                                //   No pending activities for this student.
                                // </div>
                              }
                              //console.log(validation1.values.activities);
                              return (

                                <div
                                  key={`activities-${enroll.pk_ses_key}`}
                                  className="mb-3"
                                >
                                  <Label className="font-size-12 mb-1 pb-0">
                                    <strong>
                                      {" "}
                                      Date:{" "}
                                      {moment(
                                        enroll.ses_date,
                                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                                      ).format("DD MMM YYYY")}{" "}
                                    </strong>
                                  </Label>
                                  {incompleteActivities.map(activity => (
                                    <div
                                      key={activity.pk_lesson_activity_key}
                                      className="form-check"
                                    >
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`activity-${activity.pk_lesson_activity_key}`}
                                        name="activities"
                                        value={activity.pk_lesson_activity_key}
                                        checked={validation1.values.activities.includes(
                                          activity.pk_lesson_activity_key
                                        )}
                                        onChange={event => {
                                          const value = event.target.value
                                          let next_activity_count =
                                            NextSessionData?.activity_count !=
                                            null &&
                                            NextSessionData.activity_count <= 20
                                              ? 20 -
                                              parseInt(
                                                NextSessionData.activity_count
                                              )
                                              : 0
                                          if (
                                            validation1.values.activities.includes(
                                              value
                                            )
                                          ) {
                                            setPendingActivitySeleteAll(false)
                                            const updatedActivities =
                                              validation1.values.activities.includes(
                                                value
                                              )
                                                ? validation1.values.activities.filter(
                                                  item => item !== value
                                                )
                                                : [
                                                  ...validation1.values
                                                    .activities,
                                                  value,
                                                ]
                                            validation1.setFieldValue(
                                              "activities",
                                              updatedActivities
                                            )
                                          } else if (
                                            validation1.values.activities
                                              .length < next_activity_count &&
                                            !validation1.values.activities.includes(
                                              value
                                            )
                                          ) {
                                            const updatedActivities =
                                              validation1.values.activities.includes(
                                                value
                                              )
                                                ? validation1.values.activities.filter(
                                                  item => item !== value
                                                )
                                                : [
                                                  ...validation1.values
                                                    .activities,
                                                  value,
                                                ]
                                            validation1.setFieldValue(
                                              "activities",
                                              updatedActivities
                                            )
                                          } else {
                                            toast.error(
                                              "Sorry, a maximum of 20 activities are allowed next session",
                                              {
                                                autoClose: 3000, // 3 seconds
                                              }
                                            )
                                          }
                                        }}
                                      />
                                      <label>
                                        {
                                          // Customize the displayed name based on the activity type and subject
                                          activity.activity_type === 0 &&
                                          [1, 2].includes(activity.fk_sub_id)
                                            ? activity.activity_node[0]
                                            ?.node_name || ""
                                            : activity.activity_type === 1
                                              ? activity.activity_node[0]?.name ||
                                              ""
                                              : activity.activity_type === 2 &&
                                              [1, 2].includes(
                                                activity.fk_sub_id
                                              )
                                                ? getUniqueTopicsNames(
                                                  activity?.topics
                                                )
                                                : activity.activity_type === 3
                                                  ? activity.activity_node[0]?.name ||
                                                  ""
                                                  : activity.activity_type === 4
                                                    ? activity.activity_node[0]?.name ||
                                                    ""
                                                    : activity.activity_type === 5
                                                      ? activity.activity_node[0]?.name ||
                                                      ""
                                                      : activity.activity_type === 6 &&
                                                      [1, 2].includes(
                                                        activity.fk_sub_id
                                                      )
                                                        ? activity.activity_node[0]
                                                        ?.video_name || ""
                                                        : activity.activity_type === 7 &&
                                                        [1, 2].includes(
                                                          activity.fk_sub_id
                                                        )
                                                          ? activity.activity_node[0]
                                                          ?.node_name || ""
                                                          : "Activity"
                                        }
                                      </label>
                                      <label>
                                        {" - "}Status :
                                        <span className="text-danger">
                                          {activity.status === 0
                                            ? "Incomplete"
                                            : activity.status === 1 &&
                                            parseInt(activity.mastryScore) <
                                            75
                                              ? "Score below 75%"
                                              : "Incomplete"}
                                        </span>
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              )
                            })
                          ) : null}
                          {validation1.touched.activities &&
                            validation1.errors.activities && (
                              <p className="text-danger">
                                {validation1.errors.activities}
                              </p>
                            )}

                          {ActivityPendingLoading === false ? (
                              <div>
                                {NextSessionData?.next_session &&
                                validation1.values.pk_student_key &&
                                sessionData &&
                                validation1.values.activity_method
                                  ? sessionData.session.tbl_session_time.tbl_student_enrolment
                                    .filter(
                                      enroll =>
                                        enroll.fk_stu_key ===
                                        validation1.values.pk_student_key.value
                                    )
                                    .map(enroll => {
                                      // console.log(enroll)
                                      let subject_id =
                                        getUniqueStudentSubjectID(
                                          enroll.tbl_enrolment_subject
                                        ).join(",") || "1"

                                      return SessionStudentNextActivity.length ===
                                      0 ? (
                                        <div>
                                          {SessionStudentPendingActivity &&
                                          SessionStudentPendingActivity.length >
                                          0 ? null : (
                                            <div
                                              key={`no-activities`}
                                              className="alert alert-info mb-3 align-items-center"
                                            >
                                              No pending activities for this
                                              student.
                                            </div>
                                          )}
                                          <Loader
                                            show={
                                              ActivityNextLoading ||
                                              ActivitySubjectNextLoading
                                            }
                                            type="inline"
                                            spinnerSize="20px"
                                            spinnerStyle={{
                                              secondary: "#2D866D",
                                            }}
                                          />
                                          {!ActivityNextLoading &&
                                          !ActivitySubjectNextLoading ? null : (
                                            <div className="d-flex justify-content-center">
                                              <p>
                                                <strong>
                                                  <small>
                                                    Please Wait Automation Check
                                                    Next Activity...
                                                  </small>
                                                </strong>
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                      ) : SessionStudentNextActivity &&
                                      SessionStudentNextActivity.length > 0 &&
                                      !ActivityNextLoading &&
                                      !ActivitySubjectNextLoading ? (
                                        // Check if there are no activities in SessiosNextActivity
                                        SessiosNextActivity.length === 0 ? (
                                          <p>
                                            <strong>
                                              {" "}
                                              Automation not found any
                                              activities{" "}
                                              <small>
                                                Because no activity has been
                                                assigned, or topic-based wise
                                                any activity has been not
                                                completed in past session, or
                                                next session maximum 20
                                                activitys reached
                                              </small>
                                            </strong>
                                          </p> // Display message if SessiosNextActivity is empty
                                        ) : (
                                          <>
                                            <p className="mb-3">
                                              <strong>
                                                Automation found below
                                                activities:{" "}
                                                <small>
                                                  Note: The activities for each
                                                  past session is based on the
                                                  initial topic. Ensure all
                                                  pendings activities are
                                                  completed before proceeding to
                                                  the get next activities and
                                                  also check next session
                                                  available space for assign
                                                  activities.{" "}
                                                </small>
                                              </strong>
                                            </p>
                                            {Object.keys(groupedByLevel).map(
                                              levelId => {
                                                const activitiesForLevel =
                                                  groupedByLevel[levelId]

                                                // Find the correct `activity_level_data` using the current `levelId`
                                                const levelData =
                                                  activitiesForLevel[0]
                                                    ?.activity_level_data
                                                const subjectData =
                                                  activitiesForLevel[0]
                                                    ?.activity_subject
                                                return (
                                                  <div
                                                    key={`activitiesData-${levelId}`}
                                                    className="mb-3"
                                                  >
                                                    <Label className="font-size-12 mb-1 pb-0">
                                                      <strong>
                                                        {levelData} (
                                                        {subjectData})
                                                      </strong>
                                                    </Label>
                                                    <div className="form-check">
                                                      {activitiesForLevel.length >
                                                      0 ? (
                                                        activitiesForLevel.map(
                                                          (activity) => (
                                                            <Label
                                                              className="font-size-12 mb-1 pb-0"
                                                              key={`activity-${activity.id}`}
                                                            >
                                                              <strong>
                                                                {
                                                                  activity.activity_topic_data
                                                                }
                                                              </strong>
                                                              : {activity.name}
                                                            </Label>
                                                          )
                                                        )
                                                      ) : (
                                                        <p>
                                                          Automation did not
                                                          find any activities.
                                                        </p>
                                                      )}
                                                    </div>
                                                  </div>
                                                )
                                              }
                                            )}
                                          </>
                                        )
                                      ) : null
                                    })
                                  : null}
                              </div>
                            ) :
                            null}
                        </div>
                      </div>
                      <div className="text-end">
                        <div className="btn-group">
                          {!ActivityNextLoading &&
                          !ActivitySubjectNextLoading &&
                          validation1.values.activities.length > 0 &&
                          SessionStudentPendingActivity &&
                          SessionStudentPendingActivity.length > 0 ? (
                            <button
                              type="submit"
                              className="btn btn-danger"
                              disabled={isSubmitting}
                            >
                              Move
                            </button>
                          ) : null}

                          {!ActivityNextLoading &&
                          !ActivitySubjectNextLoading &&
                          TotalPendingActivity === 0 &&
                          SessiosNextActivity.length > 0 &&
                          NextSessionData.next_session ? (
                            <button
                              type="button"
                              className="btn btn-danger"
                              disabled={isSubmitting}
                              onClick={() => {
                                OnSubmitNavActivityAssign(
                                  NextSessionData.next_session,
                                  validation1.values.pk_student_key,
                                  validation1.values.activity_method
                                )
                              }}
                            >
                              Move
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </Form>
                  </ModalBody>
                </Modal>

                {startButton ? (
                  <div
                    className="ms-0 d-flex align-items-center aw-button"
                    color=""
                    disabled={SessionStart}
                    onClick={onSessionStart}
                  >
                    {" "}
                    <span>
                      <img className="cs-mg" width={24} src={play} alt="" />
                    </span>{" "}
                    Start Session{" "}
                  </div>
                ) : null}

                {endButton ? (
                  <div
                    className="ms-0 d-flex align-items-center aw-button"
                    color=""
                    // disabled={SessionEnd}
                    onClick={tog_session_end}
                  >
                    {" "}
                    <span>
                      <img className="cs-mg" width={24} src={record} alt="" />
                    </span>{" "}
                    <div className="cs-mg  font-size-16" >End Session{" "}</div>
                  </div>
                ) : null}

                <Modal
                  isOpen={modal_session_end}
                  toggle={tog_session_end}
                  centered
                >
                  <ModalBody className="text-center">
                    <div className="my-4">
                      <h5 className="mb-1">Do you want to end the session?</h5>
                      <p className="text-danger font-size-10 mb-4">*If you end the session, it cannot be restarted.</p>
                      <div className="d-flex justify-content-center gap-3">
                        <Button
                          color="success"
                          disabled={SessionEnd}
                          onClick={onSessionEnd}
                        >
                          {" "}
                          End Session{" "}
                        </Button>
                        <Button
                          color="danger"
                          onClick={tog_session_end}
                        >
                          {" "}
                          Cancel{" "}
                        </Button>
                      </div>
                    </div>
                  </ModalBody>

                </Modal>

                <Offcanvas
                  isOpen={isRightStu}
                  direction="end"
                  toggle={toggleRightCanvasStu}
                >
                  <OffcanvasHeader
                    toggle={toggleRightCanvasStu}
                    className="border-bottom off-can-header align-items-start"
                  >
                    <div className="stu-detail-wrap ">
                      <div className="d-flex">
                        <div className="me-10 mt-5">
                          <img width={40} src={st1} alt="" />
                        </div>
                        <div className="">
                          <label className="student_label m-0">
                            {studentDetail &&
                            studentDetail.st_first_name &&
                            studentDetail.st_first_name != ""
                              ? studentDetail.st_first_name.concat(
                                " " +
                                (studentDetail.st_surname
                                  ? studentDetail.st_surname
                                  : "")
                              )
                              : null}
                          </label>
                          <div className="">
                            <label className="student_label2 font-size-18 m-0 d-flex align-items-center">
                              {studentDetail?.activity_level?.level_name
                                ? studentDetail.activity_level.level_name
                                : null}{" "}
                              <i className="fa fa-circle ms-1"> </i>{" "}
                              {studentDetail?.tbl_school?.sc_name
                                ? studentDetail.tbl_school.sc_name
                                : null}
                            </label>
                          </div>
                          <div className="d-flex align-items-center">
                            <p className="student_label_id me-1 font-size-12">
                              Student ID{" "}
                              {studentDetail?.pk_student_id
                                ? studentDetail.pk_student_id
                                : null}
                            </p>
                            <i className="fa fa-circle text-dark me-1"></i>
                            <p className="student_label_id font-size-12">
                              Joined{" "}
                              {studentDetail?.enroll_Date
                                ? moment(
                                  studentDetail.enroll_Date,
                                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                                ).format("DD MMM YYYY")
                                : null}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </OffcanvasHeader>
                  <OffcanvasBody className="cstm-off-body">
                    <div className="white-contrast">
                      <div>
                        <label className="student_label_id">Next Session</label>
                      </div>
                      {studentDetail?.next_session?.ses_date ? (
                        <>
                          <div className="d-flex align-items-start">
                            <div className="stud_date">
                              <label className="font-size-16 fw-700">
                                {studentDetail?.next_session?.ses_date
                                  ? moment(
                                    studentDetail.next_session.ses_date,
                                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                                  ).format("DD")
                                  : null}
                              </label>

                              <label className="student_label_id font-size-16">
                                {studentDetail?.next_session?.ses_date
                                  ? moment(
                                    studentDetail.next_session.ses_date,
                                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                                  ).format("MMM")
                                  : null}
                              </label>
                            </div>

                            <div class="d-flex flex-column">
                              <label className="student_label_id m-0 font-size-15">
                                {studentDetail?.next_session?.ses_start_time &&
                                studentDetail?.next_session?.ses_end_time
                                  ? (() => {
                                    const startMoment = moment(
                                      studentDetail.next_session
                                        .ses_start_time,
                                      "HH:mm"
                                    )
                                    const endMoment = moment(
                                      studentDetail.next_session.ses_end_time,
                                      "HH:mm"
                                    )
                                    const durationMinutes = endMoment.diff(
                                      startMoment,
                                      "minutes"
                                    )
                                    const formattedDuration = `(${durationMinutes} min)`
                                    return (
                                      getMomentLocaleTimeFormat(startMoment, "hh:mm", userSetting.locale) +
                                      " - " +
                                      getMomentLocaleTimeFormat(endMoment,"hh:mm", userSetting.locale) +
                                      " " +
                                      formattedDuration
                                    )
                                  })()
                                  : null}
                              </label>

                              <label className="m-0 fw-800 font-size-15">
                                {studentDetail?.next_session?.tbl_session_time?.sest_name
                                  ? studentDetail.next_session.tbl_session_time
                                    .sest_name
                                  : null}
                              </label>

                              <label className="student_label_id m-0">
                                {studentDetail?.next_session?.tbl_session_time?.sest_is_holidays
                                  ? studentDetail.next_session.tbl_session_time
                                    .sest_is_holidays == null ||
                                  studentDetail.next_session.tbl_session_time
                                    .sest_is_holidays == ""
                                    ? "-"
                                    : studentDetail.next_session
                                      .tbl_session_time.sest_is_holidays ==
                                    "1"
                                      ? "Recurring"
                                      : studentDetail.next_session
                                        .tbl_session_time.sest_is_holidays ==
                                      "2"
                                        ? "One Off Session"
                                        : studentDetail.next_session
                                          .tbl_session_time.sest_is_holidays ==
                                        "3"
                                          ? "Make Up Session"
                                          : "-"
                                  : null}{" "}
                                {studentDetail?.next_session?.tbl_session_time
                                  ?.tbl_student_enrolment?.tbl_subject_enrolment?.sub_name
                                  ? studentDetail.next_session.tbl_session_time
                                    .tbl_student_enrolment
                                    .tbl_subject_enrolment.sub_name
                                  : null}{" "}
                                {studentDetail?.next_session?.total_student
                                  ? `${studentDetail.next_session.total_student}-students`
                                  : null}
                              </label>
                            </div>
                          </div>
                          <label
                            className={`${
                              studentDetail?.next_session?.activity_count
                                ? ""
                                : "cs-txt-danger font-size-12 mt-5 ms-0 mb-0"
                            }`}
                          >
                            {studentDetail?.next_session?.activity_count
                              ? `${studentDetail.next_session.activity_count} activities assigned`
                              : "No activities assigned"}
                          </label>
                        </>
                      ) : (
                        <p className="ml-3">No next session</p>
                      )}
                    </div>
                    <div className="lesson-wrapper">
                      <div className="bg-white d-flex lesson-div justify-content-between">
                        <h4
                          className="font-size-18 text-dark"
                          style={{ lineHeight: "24px" }}
                        >
                          View past lessons
                        </h4>
                        <button
                          type="button"
                          className="btn p-0"
                          onClick={togStudentPastSession}
                        >
                          <i className="fas fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>

                    {/* lesson tab */}

                    <div>
                      <Nav pills className="navtab-bg nav-justified lesson-nav">
                        <NavItem className="lesson-navitem">
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames("lesson-navlink", {
                              active: activeTab1 === "5",
                            })}
                            onClick={() => {
                              toggle1("5")
                            }}
                          >
                            Notes
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            className={classnames("lesson-navlink", {
                              active: activeTab1 === "6",
                            })}
                            onClick={() => {
                              toggle1("6")
                            }}
                          >
                            Report
                          </NavLink>
                        </NavItem>
                      </Nav>

                      <TabContent activeTab={activeTab1} className="text-muted">
                        <TabPane tabId="5" className="pd-10">
                          <div className="note-wrap">
                            <div>
                              <div>
                                <p>Lesson Notes</p>
                                <small>Add lesson notes for this session</small>
                              </div>
                              <div className="mt-2">
                                <Input
                                  type="textarea"
                                  id="textarea"
                                  onChange={e => {
                                    textareachange(e)
                                  }}
                                  maxLength="225"
                                  rows="3"
                                  onBlur={e => {
                                    noteaddfunction(e)
                                  }}
                                  value={lessonNote}
                                />
                              </div>
                            </div>
                            <div className="mt-2">
                              {
                                LessonNoteDetail?.length > 0 ? (
                                  <>
                                    {LessonNoteDetail.map((notes, index) =>
                                      notes.notes_details != null ? (
                                        <div
                                          className="mt-2 mb-2 w-100 justify-content-between d-flex bg-white"
                                          key={index}
                                        >
                                          <div>
                                            <p>
                                              {" "}
                                              {moment(
                                                notes.created_on,
                                                moment.ISO_8601
                                              ).format("DD MMM YYYY (ddd)")}
                                            </p>
                                            <small>
                                              {getMomentLocaleTimeFormat(
                                                notes.ses_start_time,
                                                "HH:mm:ss", userSetting.locale
                                              )}{" "}
                                              -{" "}
                                              {getMomentLocaleTimeFormat(
                                                notes.ses_end_time,
                                                "HH:mm:ss", userSetting.locale
                                              )}
                                            </small>
                                            <br />
                                            <small>{notes.sest_name}</small>
                                          </div>
                                          <div>
                                            <div
                                              onClick={() =>
                                                delete_notes(notes.pk_notes_key)
                                              }
                                              style={{ cursor: "pointer" }}
                                              className="me-0"
                                            >
                                              x
                                            </div>
                                            <p className="me-2">
                                              {" "}
                                              {notes.notes_details}
                                            </p>
                                          </div>
                                        </div>
                                      ) : null
                                    )}
                                  </>
                                ) : (
                                  <span>No Lesson Notes</span>
                                )}
                            </div>
                            <label className="mt-5 font-size-18 fw-700 mb-0">
                              Other Notes
                            </label>
                            <div className="mt-5 w-100">
                              <p className="bg-white pd-10 font-size-10">
                                {studentDetail?.la_notes
                                  ? studentDetail.la_notes
                                  : "No Data"}
                              </p>
                            </div>
                            <label className="mt-5 font-size-18 fw-700 mb-0">
                              Goals
                            </label>
                            <div className="mt-5 ">
                              <p className="bg-white bg-white pd-10 w-100 font-size-10">
                                {studentDetail?.la_goals
                                  ? studentDetail.la_goals
                                  : "No Data"}
                              </p>
                            </div>
                          </div>
                        </TabPane>
                        <TabPane tabId="6" className="bg-white">
                          <div className="report-wrap pd-10">
                            <div>
                              <label className="student_label2 font-size-18 fw-700">
                                {mastryScore?.level_name
                                  ? mastryScore.level_name
                                  : ""}{" "}
                                <i className="fa fa-circle"></i>{" "}
                                {mastryScore?.subject_name
                                  ? mastryScore.subject_name
                                  : ""}
                                {" "}Curriculum
                              </label>
                            </div>
                            <div className=""></div>
                            <div class="studentdetails-report">
                              <div class="studentdetails-report-values">
                                <label>Classes Attended</label>
                                <span>
                                  {mastryScore?.attended_session
                                    ? mastryScore.attended_session
                                    : 0}
                                </span>
                              </div>
                              <div class="studentdetails-report-values">
                                <label>Activities Completed</label>
                                <span>
                                  {mastryScore?.attended_session
                                    ? mastryScore.attended_session
                                    : 0}
                                </span>
                              </div>
                            </div>

                            <div className="mt-2">
                              <label className="student_label2 font-size-18 fw-700">
                                Topic Score{" "}
                                <span onClick={tog_center1}>
                                  <i className="font-size-14 far fa-question-circle"></i>
                                </span>
                                <Modal
                                  className="mastery-modal"
                                  isOpen={modal_center1}
                                  toggle={tog_center1}
                                  centered
                                >
                                  <ModalHeader
                                    className="mt-0 text-dark"
                                    toggle={tog_center1}
                                  >
                                    Topic score
                                  </ModalHeader>
                                  <ModalBody className="mastery-modal_body">
                                    <p style={{ marginBottom: "1rem" }}>
                                      A topic score is an integer from 0 - 100
                                      that indicates a student's competence in a
                                      particular topic at a particular year
                                      level. A topic score is always given
                                      with a (Year Level) and a (Topic). This
                                      year level and topic is obtained from the
                                      Mastery Tree in LCMS.
                                    </p>
                                    <div
                                      className="good-wrapper"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <p className="state-good fw-700">
                                        Excellent
                                      </p>
                                      <p className="state-good ">
                                        Average score of more than 70
                                      </p>
                                      <p>
                                        Your child is proficient at this topic
                                        and can move on to new topics.
                                      </p>
                                    </div>
                                    <div
                                      className="warning-wrapper"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <p className="state-warning fw-700">
                                        Average
                                      </p>
                                      <p className="state-warning ">
                                        Average score of 30 - 69
                                      </p>
                                      <p>
                                        Your child is getting the hang of these
                                        topics and should practice more to get
                                        better at it!
                                      </p>
                                    </div>
                                    <div
                                      className="critical-wrapper"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <p className="state-critical fw-700">
                                        Improvement Needed
                                      </p>
                                      <p
                                        className="state-critical"
                                        style={{ marginBottom: "1rem" }}
                                      >
                                        Average score of less than 30
                                      </p>
                                      <p>
                                        Your child might be new to the topic and
                                        would need time to grasp the fundamental
                                        concepts.!
                                      </p>
                                    </div>
                                    <div
                                      className="disabled-wrapper"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <p className="state-secondary fw-700">
                                        No score
                                      </p>
                                      <p>
                                        Your child will need to complete more
                                        questions in that topic to generate a
                                        mastery score.
                                      </p>
                                    </div>
                                    <div
                                      className="child-wrapper"
                                      style={{ marginBottom: "1rem" }}
                                    >
                                      <p className="state-secondary fw-700 text-dark">
                                        How is the topic score calculated?{" "}
                                      </p>
                                      <p>
                                        Formula: (No of Q correct on 1st try) /
                                        (Total no of Q in Year Level + Topic) *
                                        100%
                                      </p>
                                    </div>
                                    <p style={{ marginBottom: "1rem" }}>
                                      Rounding: To nearest whole integer
                                    </p>
                                  </ModalBody>
                                  <ModalFooter></ModalFooter>
                                </Modal>
                              </label>
                            </div>

                            <p className="d-flex flex-column text-center font-size-15 mt-5">
                              No of Topics
                              <span className="font-size-15 fw-700 text-dark">
                                {topicData?.total_level
                                  ? topicData.total_level
                                  : 0}
                              </span>
                            </p>

                            <div className="mt-5">
                              <Progress multi>
                                <Progress
                                  bar
                                  className="high_mastery"
                                  value={25}
                                />

                                <Progress
                                  bar
                                  className="medium_mastery"
                                  value={25}
                                />

                                <Progress
                                  bar
                                  className="low_mastery"
                                  value={25}
                                />
                                <Progress bar className="noscore" value={25} />
                              </Progress>

                              <div className="row">
                                <div className="col-3 text-center">
                                  <label
                                    className="topic_mas_label mt-1 font-size-15"
                                    style={{ color: "#63d3a6" }}
                                  >
                                    Excellent
                                  </label>
                                  <p className="topic_mas_para">
                                    <b className="font-size-15">
                                      {topicData?.high_level
                                        ? topicData.high_level
                                        : 0}
                                    </b>{" "}
                                    topic
                                  </p>
                                </div>
                                <div className="col-3 text-center">
                                  <label
                                    className="topic_mas_label mt-1 font-size-15"
                                    style={{ color: "#f6911e" }}
                                  >
                                    Average
                                  </label>
                                  <p className="topic_mas_para">
                                    <b className="font-size-15">
                                      {topicData?.mid_level
                                        ? topicData.mid_level
                                        : 0}
                                    </b>{" "}
                                    topic
                                  </p>
                                </div>
                                <div className="col-3 text-center">
                                  <label
                                    className="topic_mas_label mt-1 font-size-15"
                                    style={{ color: "#fb0000" }}
                                  >
                                    Improvement
                                  </label>
                                  <p className="topic_mas_para">
                                    <b className="font-size-15">
                                      {topicData?.low_level
                                        ? topicData.low_level
                                        : 0}
                                    </b>{" "}
                                    topic
                                  </p>
                                </div>
                                <div className="col-3 text-center">
                                  <label
                                    className="topic_mas_label mt-1 font-size-15"
                                    style={{ color: "#b3b3b3" }}
                                  >
                                    No score
                                  </label>
                                  <p className="topic_mas_para">
                                    <b className="font-size-15">
                                      {topicData?.no_score_level
                                        ? topicData.no_score_level
                                        : 0}
                                    </b>{" "}
                                    topic
                                  </p>
                                </div>
                              </div>

                              <button
                                className="btn report-btn"
                                onClick={toggleRightCanvasStuTopic}
                              >
                                All Activities{" "}
                                <i className="fas fa-arrow-right"></i>{" "}
                              </button>
                              {mastryScore?.mistryScore?.length > 0 ? (
                                <>
                                  {" "}
                                  <h5 className="mt-1 font-size-18 text-dark">
                                    Activities practiced in the past month
                                  </h5>
                                  <div className="justify-content-right h-30 w-98">
                                    <Pie
                                      width={98}
                                      height={30}
                                      data={pie_mastry_data}
                                      options={options_pie_mastry}
                                      style={{
                                        height: "270px",
                                        width: "560px",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <h5 className="font-size-18 text-dark">
                                      Improve their score
                                    </h5>
                                    <p className="mb-1 font-size-15 text-dark">
                                      Practice these activities more
                                    </p>
                                    <div className="justify-content-between d-flex">
                                      <p className="text-uppercase font-size-12 fw-700 luminous-wht mb-2">
                                        ACTIVITIES
                                      </p>
                                      <p className="text-uppercase font-size-12 fw-700 luminous-wht mt-0 mb-2">
                                        SCORE
                                      </p>
                                    </div>
                                    {mastryScore.mistryScore.map(activity => {
                                      if (
                                        activity.activity_type === 0 &&
                                        (activity.fk_sub_id === 1 ||
                                          activity.fk_sub_id === 2)
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0]
                                                .node_name != ""
                                                ? activity.activity_node[0]
                                                  .node_name
                                                : null}
                                            </div>
                                            <div
                                              className={`font-size-15 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else if (
                                        activity.activity_type === 1
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0].name !=
                                              ""
                                                ? activity.activity_node[0].name
                                                : null}
                                            </div>
                                            <div
                                              className={`ms-3 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else if (
                                        activity.activity_type === 2 &&
                                        (activity.fk_sub_id === 1 ||
                                          activity.fk_sub_id === 2)
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0]
                                                .topic_name != ""
                                                ? activity.activity_node[0]
                                                  .topic_name
                                                : null}
                                            </div>
                                            <div
                                              className={`ms-3 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != "" &&
                                              activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else if (
                                        activity.activity_type === 3
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0].name !=
                                              ""
                                                ? activity.activity_node[0].name
                                                : null}
                                            </div>
                                            <div
                                              className={`ms-3 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else if (
                                        activity.activity_type === 4
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0].name !=
                                              ""
                                                ? activity.activity_node[0].name
                                                : null}
                                            </div>
                                            <div
                                              className={`ms-3 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else if (
                                        activity.activity_type === 5
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0].name !=
                                              ""
                                                ? activity.activity_node[0].name
                                                : null}
                                            </div>
                                            <div
                                              className={`ms-3 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != "" &&
                                              activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else if (
                                        activity.activity_type === 6 &&
                                        activity.fk_sub_id === 1
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0]
                                                .video_name != ""
                                                ? activity.activity_node[0]
                                                  .video_name
                                                : null}
                                            </div>
                                            <div
                                              className={`ms-3 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else if (
                                        activity.activity_type === 6 &&
                                        activity.fk_sub_id === 2
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0]
                                                .video_name != ""
                                                ? activity.activity_node[0]
                                                  .video_name
                                                : null}
                                            </div>
                                            <div
                                              className={`ms-3 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else if (
                                        activity.activity_type === 7 &&
                                        (activity.fk_sub_id === 1 ||
                                          activity.fk_sub_id === 2)
                                      ) {
                                        return (
                                          <div className="justify-content-between d-flex">
                                            <div className="font-size-15 text-dark w-70 mb-1">
                                              {activity.activity_node[0]
                                                .file_name != ""
                                                ? activity.activity_node[0]
                                                  .file_name
                                                : null}
                                            </div>
                                            <div
                                              className={`ms-3 ${
                                                activity.masteryscore >= 70
                                                  ? "text-success"
                                                  : activity.masteryscore >=
                                                  30 &&
                                                  activity.masteryscore <= 69
                                                    ? "text-warning"
                                                    : activity.masteryscore <=
                                                    30 &&
                                                    activity.masteryscore >= 1
                                                      ? "text-danger"
                                                      : ""
                                              }`}
                                            >
                                              {activity.masteryscore != ""
                                                ? activity.masteryscore
                                                : "No Score"}
                                              <span>
                                                <i
                                                  className="mdi mdi-chevron-right"
                                                  onClick={() => {
                                                    toggleRightCanvasTopicGraph()
                                                    setTopicId(
                                                      activity.ms_topic_id
                                                    )
                                                    setNodeId(
                                                      activity.fk_activity_node_id
                                                    )
                                                  }}
                                                ></i>
                                              </span>
                                            </div>
                                          </div>
                                        )
                                      } else {
                                        return null // or any other JSX you want to render for other activity types
                                      }
                                    })}
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </TabPane>
                        <TabPane tabId="7">
                          <div class="contact-wrap">
                            <div class="contact-stu-det mb-10">
                              <label className="mb-10 font-size-18 text-dark">
                                Student Details
                              </label>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Gender Identity
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.st_gender
                                    ? studentDetail.st_gender
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Date of birth
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.st_dob
                                    ? moment(
                                      studentDetail.st_dob,
                                      moment.ISO_8601
                                    ).format("DD MMM YYYY")
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  School
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.fk_sc_id
                                    ? studentDetail.fk_sc_id
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Email
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.st_email
                                    ? studentDetail.st_email
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Mobile
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.st_phone
                                    ? studentDetail.st_phone
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Country
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.country_name
                                    ? studentDetail.country_name
                                    : null}
                                </span>
                              </div>
                            </div>
                            <div class="contact-stu-det">
                              <label className=" mb-10 font-size-18 text-dark">
                                Contact Details
                              </label>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  First name
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.tbl_parstu_relation?.tbl_parent?.par_firstname
                                    ? studentDetail.tbl_parstu_relation
                                      .tbl_parent.par_firstname
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Last name
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.tbl_parstu_relation?.tbl_parent?.par_surname
                                    ? studentDetail.tbl_parstu_relation
                                      .tbl_parent.par_surname
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Relationship
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.tbl_parstu_relation?.ps_relationship
                                    ? studentDetail.tbl_parstu_relation
                                      .ps_relationship
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Mobile
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.tbl_parstu_relation?.tbl_parent?.par_phone
                                    ? studentDetail.tbl_parstu_relation
                                      .tbl_parent.par_phone
                                    : null}
                                </span>
                              </div>
                              <div class="contact-stu-value">
                                <label className="font-size-15 fw-400">
                                  Email
                                </label>
                                <span className="font-size-15 fw-700">
                                  {studentDetail?.tbl_parstu_relation?.tbl_parent?.par_emailid
                                    ? studentDetail.tbl_parstu_relation
                                      .tbl_parent.par_emailid
                                    : null}
                                </span>
                              </div>
                            </div>
                          </div>
                        </TabPane>

                      </TabContent>
                    </div>
                  </OffcanvasBody>
                </Offcanvas>

                <Offcanvas
                  isOpen={isRightStuTopic}
                  direction="end"
                  toggle={toggleRightCanvasStuTopic}
                >
                  <OffcanvasHeader
                    toggle={toggleRightCanvasStuTopic}
                    className="border-bottom off-can-header cp-2"
                  >
                    <div
                      className="d-flex align-items-center"
                      onClick={toggleRightCanvasStuTopic}
                    >
                      <div className="short-ic">
                        <img className="bc-bg" src={chevleft} />
                      </div>
                      <p className="student_label_id font-size-12 ">Back</p>
                    </div>
                  </OffcanvasHeader>
                  <OffcanvasBody className="p-0">
                    <div className="alltopic-wrap">
                      <div className="white-contrast p-0">
                        <div
                          className=""
                          style={{ padding: "10px", paddingBottom: "0" }}
                        >
                          <label className="student_label2 font-size-12 fw-700 m-0">
                            View all activities
                          </label>
                        </div>
                        <div className="d-flex pd-10 align-items-center">
                          <div className="me-10">
                            <img src={sort} />
                          </div>
                          <div>
                            <Select
                              className="stud_level cp-wd me-20"
                              value={levelOption?.find(option => option.value == selectedYearLevelTopic) || ''}
                              onChange={selectedOption => {
                                handleSelectYearLevelTopic(
                                  selectedOption["value"]
                                )
                              }}
                              options={levelOption}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                          <div>
                            <Select
                              className="masterScore_level cp-wd"
                              value={optionMastryScore.find(
                                option => option.value == selectedMastryScore
                              )}
                              onChange={selectedOption => {
                                handleSelectMastryScore(selectedOption["value"])
                              }}
                              options={optionMastryScore}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </div>
                      </div>

                      {MistryTopic.length > 0 ? (
                        MistryTopic.map(activity => {
                          if (
                            activity.activity_type === 0 &&
                            (activity.fk_sub_id === 1 ||
                              activity.fk_sub_id === 2) &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.node_name
                                          ? activity.activity_node[0].node_name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className=" fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between d-flex mt-2">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={` m-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else if (
                            activity.activity_type === 1  &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.name
                                          ? activity.activity_node[0].name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={`me-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else if (
                            activity.activity_type === 2 &&
                            (activity.fk_sub_id === 1 ||
                              activity.fk_sub_id === 2) &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.topic_name
                                          ? activity.activity_node[0].topic_name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between d-flex mt-2">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={`me-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.masteryscore != "" &&
                                      activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else if (
                            activity.activity_type === 3 &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.name
                                          ? activity.activity_node[0].name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={`me-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else if (
                            activity.activity_type === 4 &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.name
                                          ? activity.activity_node[0].name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className=" fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={`me-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.masteryscore != "" &&
                                      activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else if (
                            activity.activity_type === 5 &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.name
                                          ? activity.activity_node[0].name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={`me-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.masteryscore != "" &&
                                      activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else if (
                            activity.activity_type === 6 &&
                            activity.fk_sub_id === 1 &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.video_name
                                          ? activity.activity_node[0].video_name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={`me-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.activity_node &&
                                      activity.activity_node.length > 0 &&
                                      activity.masteryscore != "" &&
                                      activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else if (
                            activity.activity_type === 6 &&
                            activity.fk_sub_id === 2 &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.video_name
                                          ? activity.activity_node[0].video_name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={`me-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else if (
                            activity.activity_type === 7 &&
                            (activity.fk_sub_id === 1 ||
                              activity.fk_sub_id === 2) &&
                            activity.activity_node.length > 0
                          ) {
                            return (
                              <div
                                className="bg-white"
                                style={{ borderBottom: "1px solid #b5c4d7" }}
                              >
                                <div className="inner-pd pd-10">
                                  <div className="justify-content-between d-flex align-items-center">
                                    <div>
                                      <h5
                                        className="font-size-18 fw-700 text-dark"
                                        style={{ lineHeight: "24px" }}
                                      >
                                        {activity.activity_node?.[0]?.file_name
                                          ? activity.activity_node[0].file_name
                                          : null}
                                      </h5>
                                      <p className="mb-0 font-size-15 fw-700 text-dark">
                                        {activity.activity_node?.[0]?.level_name
                                          ? activity.activity_node[0].level_name
                                          : null}
                                      </p>{" "}
                                    </div>
                                    <strong
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        toggleRightCanvasTopicGraph()
                                        setTopicId(activity.ms_topic_id)
                                        setNodeId(activity.fk_activity_node_id)
                                      }}
                                    >
                                      {" "}
                                      <i className="fas fa-angle-right"></i>
                                    </strong>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Questions Completed
                                    </p>{" "}
                                    <p className="m-0 font-size-15 fw-700 text-dark">
                                      {activity.question_attended != ""
                                        ? parseInt(activity.question_attended)
                                        : 0}
                                    </p>
                                  </div>
                                  <div className="justify-content-between mt-2 d-flex">
                                    <p className="font-size-15 fw-400 text-dark">
                                      Current average score
                                    </p>{" "}
                                    <p
                                      className={`me-0 ${
                                        activity.masteryscore >= 70
                                          ? "text-success"
                                          : activity.masteryscore >= 30 &&
                                          activity.masteryscore <= 69
                                            ? "text-warning"
                                            : activity.masteryscore <= 30 &&
                                            activity.masteryscore >= 1
                                              ? "text-danger"
                                              : ""
                                      }`}
                                    >
                                      {activity.masteryscore != ""
                                        ? activity.masteryscore
                                        : "No Score"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          } else {
                            return // or any other JSX you want to render for other activity types
                          }
                        })
                      ) : (
                        <p className="text-center font-size-15 fw-400 text-dark mt-3">
                          No Data
                        </p>
                      )}
                    </div>
                  </OffcanvasBody>
                </Offcanvas>

                <Offcanvas
                  isOpen={isRightTopicGraph}
                  direction="end"
                  toggle={toggleRightCanvasTopicGraph}
                >
                  <OffcanvasHeader
                    toggle={toggleRightCanvasTopicGraph}
                    className="border-bottom off-can-header cp-2"
                  >
                    <div
                      className="d-flex align-items-center"
                      onClick={toggleRightCanvasTopicGraph}
                    >
                      <div className="short-ic">
                        <img className="bc-bg" src={chevleft} />
                      </div>
                      <p className="student_label_id font-size-12 ">Back</p>
                    </div>
                  </OffcanvasHeader>
                  <OffcanvasBody className="p-0">
                    <div className="alltopic-wrap white-contrast p-1">
                      <div>
                        <label className="student_label2 m-0 font-size-12 fw-400 mb-02">
                          {TopicGraphDeatils
                            ? TopicGraphDeatils.subject
                              ? TopicGraphDeatils.subject
                              : null
                            : null}
                        </label>
                        {TopicGraphDeatils ? (
                          TopicGraphDeatils.topic ? (
                            <>
                              <p className="mb-02 font-size-16 text-dark lh-sm">
                                {TopicGraphDeatils
                                  ? TopicGraphDeatils.topic
                                    ? TopicGraphDeatils.topic
                                    : null
                                  : null}
                              </p>

                              <label className="student_label2 mb-02 font-size-12 ms-0 fw-400 opacity-50">
                                Questions Completed
                              </label>
                              <p className="mb-02 font-size-12 ms-0 fw-500 text-dark">
                                {TopicGraphDeatils
                                  ? TopicGraphDeatils.total_question
                                    ? TopicGraphDeatils.total_question
                                    : null
                                  : null}
                              </p>
                            </>
                          ) : null
                        ) : null}
                      </div>
                      <div className="filter-section d-flex mb-4 flex-wrap">
                        <div className="me-12">
                          <label>Date</label>
                          <br />
                          <DateRangePicker
                            format="dd-MM-yyyy"
                            value={dateValue}
                            onChange={handleDateChange}
                            cleanable={false}
                            className="custom-dropdown"
                            style={{ zIndex: 5050 }}
                            weekStart={userSetting.calendarInput.firstDay}
                          />
                        </div>
                      </div>
                      {TopicGraphDeatils ? (
                        TopicGraphDeatils.topic ? (
                          <>
                            <div className="chart-wrapper">
                              <div className="d-flex justify-content-between">
                                <div className="">
                                  <div>
                                    <p className="mb-02 font-size-12 fw-400 text-dark">
                                      Average score over time
                                    </p>
                                    <p className="mb-02 mt-0 font-size-16 fw-400 text-dark">
                                      {TopicGraphDeatilsValueData.length > 0
                                        ? TopicGraphDeatilsValueData.join(",  ")
                                        : 0}
                                    </p>
                                  </div>
                                </div>
                                <div
                                  style={{ marginBottom: "20px" }}
                                  className="me-2"
                                >

                                  <div>
                                    {startDate != null && startDate != "" ? (
                                      <button
                                        className=""
                                        onClick={handelDateReset}
                                      >
                                        <i
                                          class="mdi  mdi-close-circle"
                                          style={{
                                            color: "#979797",
                                            fontSize: "20px",
                                          }}
                                        ></i>
                                      </button>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <Line data={data_area_chart} />
                            </div>
                            <br></br>
                          </>
                        ) : (
                          "Activity not available"
                        )
                      ) : null}
                    </div>
                  </OffcanvasBody>
                </Offcanvas>
              </div>
            </div>
          </div>

          <Card className="mb-3">
            <CardBody className="ut-pd">
              <div className="utilities-wrapper d-flex align-items-centerflex-wrap position-relative">
                <div className="status-wrapper position-absolute">
                  {" "}
                  {sessionData && sessionData.session ? (
                    sessionData.session.ses_status == 0 ? (
                      <span class="badge tb-primary inner-bd ">Upcoming</span>
                    ) : sessionData.session.ses_status == 1 &&
                    sessionData.session.ses_is_completed == 0 ? (
                      <span class="badge tb-warning inner-bd ">Ongoing</span>
                    ) : sessionData.session.ses_status == 1 &&
                    sessionData.session.ses_is_completed == 1 ? (
                      <span class="badge tb-success inner-bd ">Completed</span>
                    ) : null
                  ) : (
                    "-"
                  )}


                  {accessibleService.hasAccessToOnlineSession() && sessionData &&
                    <OnlineSessionStatus
                      sessionISODateString={sessionData?.session?.ses_date}
                      startTimeString={sessionData.session?.ses_start_time}
                      endTimeString={sessionData?.session?.ses_end_time}
                      timezone={centerTimezone}
                    >
                      <OnlineSessionStatusChild slot={'available'}>
                        <div style={{cursor: "pointer", textAlign: 'center'}}
                             onClick={(clickEvent)=>{
                               clickEvent.stopPropagation();
                               gotoOnlineSession({sessionKey: sessionData.session.pk_ses_key})
                             }}>
                          <i
                            style={{color: '#0000ff', fontSize: '16pt'}}
                            class="fas fa-solid fa-video"></i>
                        </div>
                      </OnlineSessionStatusChild>
                      <OnlineSessionStatusChild slot={'not_available'}>
                        <div style={{textAlign: 'center'}}>
                          <i
                            style={{color: '#aaaaaa', fontSize: '16pt'}}
                            class="fas fa-solid fa-video"></i>
                        </div>
                      </OnlineSessionStatusChild>

                    </OnlineSessionStatus>
                  }

                </div>


                <div
                  className="d-flex align-items-center"
                  style={{ marginRight: "1rem" }}
                >
                  <img
                    style={{ marginRight: "0.5rem" }}
                    width={36}
                    src={calendar}
                    alt=""
                  />
                  <div>
                    <p className="">Date</p>
                    <h6 className="mb-0 fw-medium text-dark">
                      {sessionData?.session?.ses_date
                        ? moment(
                          sessionData.session.ses_date,
                          moment.ISO_8601
                        ).format("DD MMM YYYY (ddd)")
                        : "-"}
                    </h6>
                  </div>
                </div>
                <div
                  className="d-flex align-items-center"
                  style={{ marginRight: "1rem" }}
                >
                  {/* <div className="ut_ic">
                    <i className="ion ion-ios-timer"></i>
                  </div> */}
                  <img
                    style={{ marginRight: "0.5rem" }}
                    width={36}
                    src={watch}
                    alt=""
                  />
                  <div>
                    <p className="">Time</p>
                    <h6 className="mb-0 mb-0 fw-medium text-dark">
                      {getMomentLocaleTimeFormat(sessionData?.session?.ses_start_time,
                        "HH:mm:ss", userSetting.locale) ?? "-"}
                      {" "}
                      -{" "}
                      {getMomentLocaleTimeFormat(sessionData?.session?.ses_end_time,
                        "HH:mm:ss", userSetting.locale) ?? "-"}
                    </h6>
                  </div>
                </div>
                <div
                  className="d-flex align-items-center"
                  style={{ marginRight: "1rem" }}
                >
                  <img
                    style={{ marginRight: "0.5rem" }}
                    width={36}
                    src={timer}
                    alt=""
                  />
                  <div>
                    <p className="">Duration</p>
                    <h6 className="mb-0 mb-0 fw-medium text-dark">
                      {sessionData?.session?.ses_start_time && sessionData?.session?.ses_end_time
                        ? calculateSessionDuration(
                          sessionData.session.ses_start_time,
                          sessionData.session.ses_end_time
                        )
                        : "-"}
                    </h6>
                  </div>
                </div>
                <div
                  className="d-flex align-items-center"
                  style={{ marginRight: "1rem" }}
                >
                  <div
                    className="ut_ic custom-me"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <i className="ion ion-md-bookmarks font-size-24"></i>
                  </div>
                  <div>
                    <p className="">Subject</p>
                    <h6 className="mb-0 mb-0 fw-medium text-dark">
                      {sessionData && sessionData != ""
                        ? getUniqueSubjectNames(sessionData).join(" & ") || "-"
                        : "-"}
                    </h6>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Nav tabs className="nav-tabs-custom mb-3">
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "1",
                })}
                onClick={() => {
                  toggleCustom("1")
                }}
              >
                <span className="d-none d-sm-block">Lesson Plan</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "2",
                })}
                onClick={() => {
                  toggleCustom("2")
                }}
              >
                <span className="d-none d-sm-block">Homework</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "3",
                })}
                onClick={() => {
                  toggleCustom("3")
                }}
              >
                <span className="d-none d-sm-block">Previous Session</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "4",
                })}
                onClick={() => {
                  toggleCustom("4")
                }}
              >
                <span className="d-none d-sm-block">Students</span>
              </NavLink>
            </NavItem>
          </Nav>
          <Card>
            <CardBody className="p-1">
              <div className="session-details">
                <TabContent activeTab={customActiveTab} className="text-muted">
                  <TabPane tabId="1">
                    <div className="kanban-wrapper d-flex gap-1">
                      <MemoizedLessonPlanContent
                        sessionData={sessionData}
                        customActiveTab={customActiveTab}
                        getUniqueStudentSubjectNames={
                          getUniqueStudentSubjectNames
                        }
                        getUniqueStudentSubjectID={getUniqueStudentSubjectID}
                        CountTotalCoins={CountTotalCoins}
                        CountHours={CountHours}
                        CountTotalActivity={CountTotalActivity}
                        clearTimeout={clearTimeout}
                        setLoopRun={setLoopRun}
                        handleLinkClick={handleLinkClick}
                        toggleDropdown={toggleDropdown}
                        dropdownOpen={dropdownOpen}
                        onPreviewActivity={onPreviewActivity}
                        onDelectActivityPopup={onDelectActivityPopup}
                        onMoveActivityPopup={onMoveActivityPopup}
                        getUniqueTopicsNames={getUniqueTopicsNames}
                        selectedActivityKeys={selectedActivityKeys}
                        handleCheckboxActivityChange={
                          handleCheckboxActivityChange
                        }
                        activityStudentKey={activityStudentKey}
                        fetchMultipleUpcommingSessionData={
                          fetchMultipleUpcommingSessionData
                        }
                        handleSelectAllChange={handleSelectAllChange}
                        selectAllChecked={selectAllChecked}
                        onHandleStudentIsleaderboard={onHandleStudentIsleaderboard}
                        handle_tutorNote={handle_tutorNote}
                      />
                      {/* <LassonPlanContent sessionData={sessionData} /> */}
                    </div>
                  </TabPane>
                  <TabPane tabId="2">
                    <div className="kanban-wrapper d-flex gap-1">
                      <MemoizedLessonPlanContent
                        sessionData={HomeSessionData}
                        customActiveTab={customActiveTab}
                        getUniqueStudentSubjectNames={
                          getUniqueStudentSubjectNames
                        }
                        getUniqueStudentSubjectID={getUniqueStudentSubjectID}
                        CountTotalCoins={CountTotalCoins}
                        CountHours={CountHours}
                        CountTotalActivity={CountTotalActivity}
                        clearTimeout={clearTimeout}
                        setLoopRun={setLoopRun}
                        handleLinkClick={handleLinkClick}
                        toggleDropdown={toggleDropdown}
                        dropdownOpen={dropdownOpen}
                        onPreviewActivity={onPreviewActivity}
                        onDelectActivityPopup={onDelectActivityPopup}
                        onMoveActivityPopup={onMoveActivityPopup}
                        getUniqueTopicsNames={getUniqueTopicsNames}
                        selectedActivityKeys={selectedActivityKeys}
                        handleCheckboxActivityChange={
                          handleCheckboxActivityChange
                        }
                        activityStudentKey={activityStudentKey}
                        fetchMultipleUpcommingSessionData={
                          fetchMultipleUpcommingSessionData
                        }
                        handleSelectAllChange={handleSelectAllChange}
                        selectAllChecked={selectAllChecked}
                        onHandleStudentIsleaderboard={onHandleStudentIsleaderboard}
                        handle_tutorNote={handle_tutorNote}
                      />
                      {/* <LassonPlanContent sessionData={HomeSessionData} /> */}
                    </div>
                  </TabPane>
                  <TabPane tabId="3">
                    <div className="kanban-wrapper d-flex gap-1">
                      {/* <LassonPlanContent sessionData={sessionData} /> */}

                      {/* <PreviousSessionContent sessionData={PresessionData} /> */}
                      <MemoizedPreviousSessionContent
                        sessionData={PresessionData}
                        PreHomeSessionData={PreHomeSessionData}
                        customActiveTab={customActiveTab}
                        getUniqueStudentSubjectNames={
                          getUniqueStudentSubjectNames
                        }
                        CountTotalCoins={CountTotalCoins}
                        CountHours={CountHours}
                        CountTotalActivity={CountTotalActivity}
                        clearTimeout={clearTimeout}
                        setLoopRun={setLoopRun}
                        handleLinkClick={handleLinkClick}
                        toggleDropdown={toggleDropdown}
                        dropdownOpen={dropdownOpen}
                        onPreviewActivity={onPreviewActivity}
                        onDelectActivityPopup={onDelectActivityPopup}
                        getUniqueTopicsNames={getUniqueTopicsNames}
                      />
                    </div>
                  </TabPane>
                  <TabPane tabId="4">
                    <TableComm
                      columns={columns}
                      defaultId={"sest_name"}
                      data={StudentData}
                    />
                  </TabPane>
                </TabContent>
              </div>
            </CardBody>
          </Card>

          <CopyLessonActivitiesDialog ref={copyActivitiesDialogRef}/>

        </Container>
      </div>
    </React.Fragment>
  )
}

SessionDetails.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(SessionDetails)
